export type Language = 'fr' | 'en';

interface Translations {
  [key: string]: {
    fr: string;
    en: string;
  };
}

export const translations: Translations = {
  // Header
  "app.title": {
    fr: "VisualGrid",
    en: "VisualGrid"
  },
  "app.description": {
    fr: "Générateur de motifs de test pour écrans LED",
    en: "LED Test Pattern Generator"
  },

  "Multi-Grid": {
    fr: "MultiGrid",
    en: "MultiGrid"
  },

  // Navigation
  "nav.about": {
    fr: "À propos",
    en: "About"
  },
  "nav.changelogs": {
    fr: "Historique des modifications",
    en: "Changelogs"
  },
  "nav.grid": {
    fr: "Grid",
    en: "Grid"
  },
  "nav.downloads": {
    fr: "Téléchargements",
    en: "Downloads"
  },

  // Footer
  "footer.madeby": {
    fr: "Fait avec ❤️ par Axel Pouppart",
    en: "Made with ❤️ by Axel Pouppart"
  },

  "footer.gridsCreated": {
    fr: "Grilles créées",
    en: "Grids created"
  },

  "footer.classicMode": {
    fr: "Mode classique",
    en: "Classic mode"
  },

  "footer.multiGridMode": {
    fr: "MultiGrid",
    en: "MultiGrid"
  },

  "footer.total": {
    fr: "Total",
    en: "Total"
  },

  "footer.visits": {
    fr: "Visites",
    en: "Visits"
  },

  // About page
  "about.title": {
    fr: "À propos",
    en: "About"
  },
  "about.description": {
    fr: "Information sur l'auteur et le projet VisualGrid",
    en: "Information about the author and the VisualGrid project"
  },
  "about.visualgrid.title": {
    fr: "VisualGrid",
    en: "VisualGrid"
  },
  "about.visualgrid.description": {
    fr: "VisualGrid est un outil conçu pour les professionnels de l'audiovisuel permettant de créer des mires de test dynamiques pour les projecteurs et murs LED. L'application facilite l'alignement, le calibrage et la configuration des affichages professionnels avec une interface simple et intuitive.",
    en: "VisualGrid is a tool designed for audiovisual professionals to create dynamic test patterns for projectors and LED walls. The application facilitates alignment, calibration, and configuration of professional displays with a simple and intuitive interface."
  },
  "about.author.title": {
    fr: "Axel Pouppart",
    en: "Axel Pouppart"
  },
  "about.author.description": {
    fr: "Technicien vidéo & Développeur passionné par l'audiovisuel.",
    en: "Video technician & Developer passionate about audiovisual."
  },
  "about.social.instagram": {
    fr: "Instagram",
    en: "Instagram"
  },
  "about.social.linkedin": {
    fr: "LinkedIn",
    en: "LinkedIn"
  },

  // Changelogs page
  "changelogs.title": {
    fr: "Historique des modifications",
    en: "Changelogs"
  },
  "changelogs.description": {
    fr: "Historique des modifications et mises à jour de VisualGrid",
    en: "History of changes and updates to VisualGrid"
  },
  "changelogs.loading": {
    fr: "Chargement des modifications...",
    en: "Loading changes..."
  },

  // Downloads page
  "downloads.title": {
    fr: "Téléchargements",
    en: "Downloads"
  },
  "downloads.cta": {
    fr: "Télécharger pour {title}",
    en: "Download for {title}"
  },
  "downloads.windows.title": {
    fr: "Windows",
    en: "Windows"
  },
  "downloads.windows.subtitle": {
    fr: "Installeur pour Windows 10/11",
    en: "Installer for Windows 10/11"
  },
  "downloads.windows.req.os": {
    fr: "OS: Windows 10 ou 11 (64 bits)",
    en: "OS: Windows 10 or 11 (64-bit)"
  },
  "downloads.windows.req.cpu": {
    fr: "CPU: Intel/AMD 2 coeurs ou plus",
    en: "CPU: Intel/AMD 2 cores or more"
  },
  "downloads.windows.req.ram": {
    fr: "RAM: 4 Go Minimum (8 Go recommandé)",
    en: "RAM: 4 GB minimum (8 GB recommended)"
  },
  "downloads.windows.req.gpu": {
    fr: "GPU: Compatible WebGL",
    en: "GPU: WebGL compatible"
  },
  "downloads.macos.title": {
    fr: "macOS",
    en: "macOS"
  },
  "downloads.macos.subtitle": {
    fr: "Installeur DMG pour macOS",
    en: "DMG installer for macOS"
  },
  "downloads.macos.req.os": {
    fr: "OS: macOS 12 Monterey ou plus récent",
    en: "OS: macOS 12 Monterey or later"
  },
  "downloads.macos.req.cpu": {
    fr: "CPU: Apple Silicon (M1/M2/M3/M4) ou Intel 64 bits",
    en: "CPU: Apple Silicon (M1/M2/M3/M4) or Intel 64-bit"
  },
  "downloads.macos.req.ram": {
    fr: "RAM: 4 Go Minimum (8 Go recommandé)",
    en: "RAM: 4 GB minimum (8 GB recommended)"
  },
  "downloads.macos.req.gpu": {
    fr: "GPU: Compatible WebGL",
    en: "GPU: WebGL compatible"
  },

  // Navigation buttons
  "nav.back": {
    fr: "Retour",
    en: "Back"
  },

  // Common
  "common.back": {
    fr: "Retour",
    en: "Back"
  },

  // Configuration
  "config.title": {
    fr: "Configuration",
    en: "Configuration"
  },
  "config.description": {
    fr: "Paramètres de la mire de test",
    en: "Test pattern settings"
  },
  "config.preset": {
    fr: "Résolution prédéfinie",
    en: "Preset Resolution"
  },
  "config.choose": {
    fr: "Choisir une résolution",
    en: "Choose a resolution"
  },
  "config.ledwall": {
    fr: "Mode Mur de LED",
    en: "LED Wall Mode"
  },
  "config.columns": {
    fr: "Colonnes",
    en: "Columns"
  },
  "config.rows": {
    fr: "Lignes",
    en: "Rows"
  },
  "config.panelWidth": {
    fr: "Largeur dalle (px)",
    en: "Panel Width (px)"
  },
  "config.panelHeight": {
    fr: "Hauteur dalle (px)",
    en: "Panel Height (px)"
  },
  "config.borderWidth": {
    fr: "Épaisseur des bordures (px)",
    en: "Border Width (px)"
  },
  "logo.widthMin": {
    fr: "Largeur minimale du logo (1 px)",
    en: "Minimum logo width (1 px)"
  },
  "logo.heightMin": {
    fr: "Hauteur minimale du logo (px)",
    en: "Minimum logo height (px)"
  },
  "config.ledWallInfo": {
    fr: "• Configuration actuelle du mur: {columns} × {rows} dalles\n• Taille de dalle: {width} × {height} pixels\n• Résolution totale: {totalWidth} × {totalHeight} pixels\n• Note: Les dimensions des dalles incluent l'espacement de {border}px entre elles",
    en: "• Current wall configuration: {columns} × {rows} panels\n• Panel size: {width} × {height} pixels\n• Total resolution: {totalWidth} × {totalHeight} pixels\n• Note: Panel dimensions include {border}px spacing between them"
  },
  "config.width": {
    fr: "Largeur",
    en: "Width"
  },
  "config.height": {
    fr: "Hauteur",
    en: "Height"
  },
  "config.grid": {
    fr: "Taille de la grille",
    en: "Grid Size"
  },
  "config.gridSize": {
    fr: "Taille de dalle (px)",
    en: "Panel Size (px)"
  },
  "config.showGrid": {
    fr: "Afficher la grille",
    en: "Show Grid"
  },
  "config.gridEvenOpacity": {
    fr: "Opacité panneaux pairs",
    en: "Even Panel Opacity"
  },
  "config.gridOddOpacity": {
    fr: "Opacité panneaux impairs",
    en: "Odd Panel Opacity"
  },
  "config.showLogo": {
    fr: "Afficher le logo",
    en: "Show Logo"
  },
  "config.showSonar": {
    fr: "Afficher le sonar",
    en: "Show Sonar"
  },
  "config.showRes": {
    fr: "Afficher dimensions panneau",
    en: "Show Panel Dimensions"
  },
  "config.showResolution": {
    fr: "Afficher la résolution",
    en: "Show Resolution"
  },
  "config.resolutionFontSize": {
    fr: "Taille de la résolution",
    en: "Resolution Size"
  },
  "config.anamorphose": {
    fr: "Anamorphose",
    en: "Anamorphosis"
  },
  "config.anamorphoseDesc": {
    fr: "Écrase verticalement pour compensation",
    en: "Vertically squashes for compensation"
  },
  "config.showLEDNumbers": {
    fr: "Numérotation LED",
    en: "LED Numbering"
  },
  "config.showTechnicalDetails": {
    fr: "Grille & Résolution",
    en: "Grid & Resolution"
  },
  "config.showDefaultLogo": {
    fr: "Afficher le logo VisualGrid",
    en: "Show VisualGrid Logo"
  },
  "config.backgroundColor": {
    fr: "Couleur de fond",
    en: "Background color"
  },
  "config.pattern": {
    fr: "Type de motif",
    en: "Pattern Type"
  },
  "config.patternTypeSwitch": {
    fr: "Type de motif",
    en: "Pattern Type"
  },
  "config.patternTypeSwitchDesc": {
    fr: "Choisissez entre motifs personnalisés et mires standards",
    en: "Choose between custom patterns and standard test patterns"
  },
  "config.customPattern": {
    fr: "Créatif",
    en: "Custom"
  },
  "config.standardPatternShort": {
    fr: "Standard",
    en: "Standard"
  },
  "config.standardPattern": {
    fr: "Standard",
    en: "Standard"
  },
  "config.patternMode": {
    fr: "Mode de mire de test",
    en: "Test pattern mode"
  },
  "config.solidColor": {
    fr: "Couleur unie",
    en: "Solid color"
  },
  "config.easyMode": {
    fr: "Easy",
    en: "Easy"
  },
  "config.fullMode": {
    fr: "Full",
    en: "Full"
  },
  "config.standardPatternDesc": {
    fr: "Sélectionnez une mire de test standard",
    en: "Select a standard test pattern"
  },
  "config.none": {
    fr: "Aucun",
    en: "None"
  },
  "config.gradient": {
    fr: "Dégradé",
    en: "Gradient"
  },
  "config.simple": {
    fr: "Simple",
    en: "Simple"
  },
  "config.custom": {
    fr: "Personnalisé",
    en: "Custom"
  },

  // Standard test patterns
  "pattern.liveVHScroll": {
    fr: "Line V H Scroll",
    en: "Line V H Scroll"
  },
  "pattern.liveVScroll": {
    fr: "Line V Scroll",
    en: "Line V Scroll"
  },
  "pattern.lineHScroll": {
    fr: "Line H Scroll",
    en: "Line H Scroll"
  },
  "pattern.grayRamp": {
    fr: "Rampe de gris",
    en: "Gray Ramp"
  },
  "pattern.greenRamp": {
    fr: "Rampe de vert",
    en: "Green Ramp"
  },
  "pattern.redRamp": {
    fr: "Rampe de rouge",
    en: "Red Ramp"
  },
  "pattern.blueRamp": {
    fr: "Rampe de bleu",
    en: "Blue Ramp"
  },
  "pattern.whiteRamp": {
    fr: "Rampe de blanc",
    en: "White Ramp"
  },
  "pattern.movingBall": {
    fr: "Balle en mouvement",
    en: "Moving Ball"
  },
  "pattern.colorBar": {
    fr: "Barres de couleur 100/75/50/25%",
    en: "100/75/50/25% Color Bar"
  },
  "pattern.grayBar8": {
    fr: "Barres de gris 8 niveaux",
    en: "8 Step Grey Bar"
  },
  "pattern.grayBar16": {
    fr: "Barres de gris 16 niveaux",
    en: "16 Step Grey Bar"
  },
  "pattern.redScreen": {
    fr: "Écran rouge",
    en: "Red Screen"
  },
  "pattern.blueScreen": {
    fr: "Écran bleu",
    en: "Blue Screen"
  },
  "pattern.greenScreen": {
    fr: "Écran vert",
    en: "Green Screen"
  },
  "pattern.cyanScreen": {
    fr: "Écran cyan",
    en: "Cyan Screen"
  },
  "pattern.yellowScreen": {
    fr: "Écran jaune",
    en: "Yellow Screen"
  },
  "pattern.blackScreen": {
    fr: "Écran noir",
    en: "Black Screen"
  },
  "pattern.whiteScreen": {
    fr: "Écran blanc",
    en: "White Screen"
  },
  "pattern.verticalSplit": {
    fr: "Séparation verticale",
    en: "Vertical Split"
  },
  "pattern.horizontalSplit": {
    fr: "Séparation horizontale",
    en: "Horizontal Split"
  },
  "pattern.quarterBlock": {
    fr: "Damier 1 et 2 quarts",
    en: "QuarterBlock 1and2 Checkboard"
  },
  "pattern.alternateCheckboard": {
    fr: "Damier noir et blanc alterné",
    en: "Alternate B&W Checkboard"
  },
  "pattern.smpteBar": {
    fr: "Mire SMPTE",
    en: "SMPTE Bar"
  },

  // ========== MIRES SPÉCIFIQUES VIDÉOPROJECTEURS ==========
  "pattern.pluge": {
    fr: "PLUGE (Niveau noir)",
    en: "PLUGE (Black Level)"
  },
  "pattern.zonePlate": {
    fr: "Zone Plate (Convergence)",
    en: "Zone Plate (Convergence)"
  },
  "pattern.crosshatch": {
    fr: "Crosshatch (Grille convergence)",
    en: "Crosshatch (Convergence Grid)"
  },
  "pattern.focusPattern": {
    fr: "Focus Pattern (Netteté)",
    en: "Focus Pattern (Sharpness)"
  },
  "pattern.geometricDistortion": {
    fr: "Distorsion géométrique",
    en: "Geometric Distortion"
  },
  "pattern.windowPattern": {
    fr: "Window Pattern (Positionnement)",
    en: "Window Pattern (Positioning)"
  },
  "pattern.multiburst": {
    fr: "Multiburst (Résolution H)",
    en: "Multiburst (H Resolution)"
  },
  "pattern.gamma22": {
    fr: "Gamma 2.2 Ramp",
    en: "Gamma 2.2 Ramp"
  },
  "pattern.whiteUniformity": {
    fr: "Uniformité blanc",
    en: "White Uniformity"
  },
  "pattern.blackUniformity": {
    fr: "Uniformité noir",
    en: "Black Uniformity"
  },
  "pattern.ansiCheckerboard": {
    fr: "ANSI Checkerboard",
    en: "ANSI Checkerboard"
  },
  "pattern.colorTemperature": {
    fr: "Température couleur",
    en: "Color Temperature"
  },
  "pattern.horizontalResolution": {
    fr: "Résolution horizontale",
    en: "Horizontal Resolution"
  },
  "pattern.verticalResolution": {
    fr: "Résolution verticale",
    en: "Vertical Resolution"
  },
  "config.sonar": {
    fr: "Sonar",
    en: "Sonar"
  },
  "config.checkerboard": {
    fr: "Damier",
    en: "Checkerboard"
  },
  "config.colorBars": {
    fr: "Barres de couleur",
    en: "Color Bars"
  },
  "config.animationSpeed": {
    fr: "Vitesse d'animation",
    en: "Animation Speed"
  },
  "config.patternSeed": {
    fr: "Seed du motif",
    en: "Pattern Seed"
  },
  "config.exportFps": {
    fr: "FPS Vidéo Export",
    en: "Export Video FPS"
  },
  "config.exportFormat": {
    fr: "Format d'Export",
    en: "Export Format"
  },
  "config.sonarSpeed": {
    fr: "Vitesse du sonar",
    en: "Sonar Speed"
  },
  "config.sonarThickness": {
    fr: "Épaisseur du sonar",
    en: "Sonar Thickness"
  },
  "action.exportVideo": {
    fr: "Export Vidéo Loop",
    en: "Export Loop Video"
  },
  "config.sonarMode": {
    fr: "Mode sonar avancé",
    en: "Advanced Sonar Mode"
  },
  "config.sonarDesc": {
    fr: "Révèle le motif à travers la grille",
    en: "Reveals pattern through the grid"
  },
  "config.fullscreenScroll": {
    fr: "Défilement plein écran",
    en: "Fullscreen Scrolling"
  },
  "config.fullscreenScrollDesc": {
    fr: "Permet de faire défiler la grille en plein écran",
    en: "Allows scrolling the grid in fullscreen mode"
  },
  "config.stretchFullscreen": {
    fr: "Étirer en plein écran",
    en: "Stretch in fullscreen"
  },
  "config.stretchFullscreenDesc": {
    fr: "Étire la grille pour remplir l'écran en mode plein écran",
    en: "Stretches the grid to fill the screen in fullscreen mode"
  },
  "config.minColumnsError": {
    fr: "Le nombre de colonnes doit être au moins 1",
    en: "The number of columns must be at least 1"
  },
  "config.minRowsError": {
    fr: "Le nombre de lignes doit être au moins 1",
    en: "The number of rows must be at least 1"
  },
  "config.maxPixelsError": {
    fr: "Trop de pixels. Réduisez les dimensions",
    en: "Too many pixels. Reduce dimensions"
  },
  "config.renderErrorTitle": {
    fr: "Erreur de rendu",
    en: "Render Error"
  },
  "config.renderError": {
    fr: "Impossible de rendre cette configuration. Le nombre total de pixels dépasse la limite de {maxPixels} millions",
    en: "Unable to render this configuration. Total pixel count exceeds the limit of {maxPixels} million"
  },
  "config.minDimensionsError": {
    fr: "Les dimensions sont trop petites pour le rendu",
    en: "Dimensions are too small for rendering"
  },

  // Text and Logo Panel
  "text.add": {
    fr: "Ajouter du texte",
    en: "Add Text"
  },
  "text.panel": {
    fr: "Panneau de texte",
    en: "Text Panel"
  },
  "text.text": {
    fr: "Texte",
    en: "Text"
  },
  "text.fontSize": {
    fr: "Taille de police",
    en: "Font Size"
  },
  "text.fontFamily": {
    fr: "Police",
    en: "Font Family"
  },
  "text.fontWeight": {
    fr: "Graisse",
    en: "Font Weight"
  },
  "text.fontStyle": {
    fr: "Style",
    en: "Style"
  },
  "text.textAlign": {
    fr: "Alignement",
    en: "Text Align"
  },
  "text.color": {
    fr: "Couleur",
    en: "Color"
  },
  "text.strokeWidth": {
    fr: "Contour",
    en: "Stroke Width"
  },
  "text.alignment": {
    fr: "Alignement",
    en: "Alignment"
  },
  "text.new": {
    fr: "Nouveau texte",
    en: "New text"
  },
  "text.delete": {
    fr: "Supprimer",
    en: "Delete"
  },
  "logo.add": {
    fr: "Ajouter un logo",
    en: "Add Logo"
  },
  "logo.panel": {
    fr: "Panneau de logo",
    en: "Logo Panel"
  },
  "logo.size": {
    fr: "Taille",
    en: "Size"
  },
  "logo.opacity": {
    fr: "Opacité",
    en: "Opacity"
  },
  "logo.horizontalAlignment": {
    fr: "Alignement horizontal",
    en: "Horizontal Alignment"
  },
  "logo.verticalAlignment": {
    fr: "Alignement vertical",
    en: "Vertical Alignment"
  },
  "logo.top": {
    fr: "Haut",
    en: "Top"
  },
  "logo.middle": {
    fr: "Milieu",
    en: "Middle"
  },
  "logo.bottom": {
    fr: "Bas",
    en: "Bottom"
  },
  "logo.left": {
    fr: "Gauche",
    en: "Left"
  },
  "logo.center": {
    fr: "Centre",
    en: "Center"
  },
  "logo.right": {
    fr: "Droite",
    en: "Right"
  },
  "logo.positionX": {
    fr: "Position X",
    en: "Position X"
  },
  "logo.positionY": {
    fr: "Position Y",
    en: "Position Y"
  },
  "logo.tips": {
    fr: "• Cliquez sur le canvas pour positionner\n• Utilisez les flèches pour déplacer (Shift = 10px)\n• Le logo sélectionné est entouré en vert\n• Maintient le ratio d'aspect automatiquement",
    en: "• Click on the canvas to position\n• Use arrow keys to move (Shift = 10px)\n• Selected logo is outlined in green\n• Automatically maintains aspect ratio"
  },
  "logo.delete": {
    fr: "Supprimer",
    en: "Delete"
  },

  // Preview Panel
  "preview.title": {
    fr: "Aperçu de la mire de test",
    en: "Test Pattern Preview"
  },
  "preview.grid": {
    fr: "Grille",
    en: "Grid"
  },
  "preview.selected": {
    fr: "sélectionné - Utilisez les flèches",
    en: "selected - Use arrow keys"
  },
  "preview.start": {
    fr: "Démarrer",
    en: "Start"
  },
  "preview.stop": {
    fr: "Arrêter",
    en: "Stop"
  },
  "preview.reset": {
    fr: "Reset",
    en: "Reset"
  },
  "preview.fullscreen": {
    fr: "Plein écran",
    en: "Fullscreen"
  },
  "preview.instructions": {
    fr: "• Cliquez sur le canvas pour positionner l'élément sélectionné\n• Utilisez les flèches du clavier pour déplacer (Shift pour 10px)",
    en: "• Click on the canvas to position the selected element\n• Use arrow keys to move (Shift for 10px)"
  },
  "preview.disablePreview": {
    fr: "Désactiver l'aperçu",
    en: "Disable Preview"
  },
  "preview.enablePreview": {
    fr: "Activer l'aperçu",
    en: "Enable Preview"
  },
  "preview.disabledTitle": {
    fr: "Aperçu désactivé",
    en: "Preview Disabled"
  },
  "preview.disabledMessage": {
    fr: "L'aperçu est désactivé pour économiser les performances. Le rendu s'effectue uniquement sur l'affichage externe.",
    en: "Preview is disabled to save performance. Rendering is only done on the external display."
  },
  "preview.preview": {
    fr: "Aperçu",
    en: "Preview"
  },
  "preview.performance": {
    fr: "Performance",
    en: "Performance"
  },
  "preview.activate": {
    fr: "Activer",
    en: "Activate"
  },

  // Config Management
  "config.save": {
    fr: "Sauvegarder",
    en: "Save"
  },
  "config.saveAs": {
    fr: "Sauvegarder sous...",
    en: "Save As..."
  },
  "config.saveTooltip": {
    fr: "Sauvegarder la configuration actuelle",
    en: "Save current configuration"
  },
  "config.saveAsTooltip": {
    fr: "Sauvegarder sous un nouveau nom",
    en: "Save with a new name"
  },
  "config.saveError": {
    fr: "Erreur lors de la sauvegarde",
    en: "Error saving configuration"
  },
  "config.load": {
    fr: "Charger",
    en: "Load"
  },
  "config.export": {
    fr: "Exporter",
    en: "Export"
  },
  "config.import": {
    fr: "Importer",
    en: "Import"
  },
  "config.saveTitle": {
    fr: "Sauvegarder la configuration",
    en: "Save Configuration"
  },
  "config.saveAsTitle": {
    fr: "Sauvegarder sous un nouveau nom",
    en: "Save As"
  },
  "config.saveAsDesc": {
    fr: "Créez une nouvelle configuration avec un nom différent",
    en: "Create a new configuration with a different name"
  },
  "config.configName": {
    fr: "Nom de la configuration",
    en: "Configuration Name"
  },
  "config.cancel": {
    fr: "Annuler",
    en: "Cancel"
  },
  "config.confirm": {
    fr: "Confirmer",
    en: "Confirm"
  },
  "config.loadTitle": {
    fr: "Charger une configuration",
    en: "Load Configuration"
  },
  "config.noSavedConfigs": {
    fr: "Aucune configuration sauvegardée",
    en: "No saved configurations"
  },
  "config.technicalName": {
    fr: "Nom technique (sans espaces)",
    en: "Technical name (no spaces)"
  },
  "config.technicalNamePlaceholder": {
    fr: "ma_config",
    en: "my_config"
  },
  "config.technicalNameDesc": {
    fr: "Utilisé pour le fichier de sauvegarde. Si vide, un nom sera généré automatiquement.",
    en: "Used for the save file. If empty, a name will be generated automatically."
  },
  "config.displayName": {
    fr: "Nom d'affichage",
    en: "Display name"
  },
  "config.displayNamePlaceholder": {
    fr: "Ma configuration",
    en: "My configuration"
  },
  "config.displayNameDesc": {
    fr: "Nom affiché dans la liste des configurations. Si vide, la date actuelle sera utilisée.",
    en: "Name displayed in the configuration list. If empty, the current date will be used."
  },
  "config.makeDefault": {
    fr: "Définir comme configuration par défaut",
    en: "Set as default configuration"
  },
  "config.selectConfig": {
    fr: "Sélectionnez une configuration à charger",
    en: "Select a configuration to load"
  },
  "config.exportPNG": {
    fr: "Exporter PNG",
    en: "Export PNG"
  },
  "config.exportPNGDesc": {
    fr: "Télécharger l'image du canvas",
    en: "Download canvas image"
  },
  "config.actions": {
    fr: "Actions",
    en: "Actions"
  },
  "config.exportCurrent": {
    fr: "Exporter la configuration actuelle",
    en: "Export current configuration"
  },
  "config.importFile": {
    fr: "Importer un fichier .visualgrid",
    en: "Import a .visualgrid file"
  },
  "config.close": {
    fr: "Fermer",
    en: "Close"
  },
  "config.default": {
    fr: "Par défaut",
    en: "Default"
  },
  "action.importExport": {
    fr: "Import/Export",
    en: "Import/Export"
  },
  "config.importFromSaved": {
    fr: "Charger depuis les configs sauvegardées",
    en: "Load from saved configs"
  },
  "config.importFromSavedDesc": {
    fr: "Sélectionner une config sauvegardée",
    en: "Select a saved configuration"
  },
  "config.importFromFile": {
    fr: "Charger depuis un fichier",
    en: "Load from file"
  },
  "config.importFromFileDesc": {
    fr: "Importer un fichier .mgrd",
    en: "Import a .mgrd file"
  },
  "config.savedConfigs": {
    fr: "Configurations sauvegardées",
    en: "Saved configurations"
  },
  "config.savedConfigsDesc": {
    fr: "Choisissez une configuration à charger ou supprimez-en une",
    en: "Choose a configuration to load or delete one"
  },
  "config.loaded": {
    fr: "Configuration chargée avec succès",
    en: "Configuration loaded successfully"
  },
  "config.loadError": {
    fr: "Erreur lors du chargement de la configuration",
    en: "Error loading configuration"
  },
  "config.invalidMultiGrid": {
    fr: "Cette configuration n'est pas une configuration MultiGrid valide",
    en: "This is not a valid MultiGrid configuration"
  },
  "config.deleteConfirm": {
    fr: "Êtes-vous sûr de vouloir supprimer la configuration \"{name}\" ?",
    en: "Are you sure you want to delete the configuration \"{name}\"?"
  },
  "config.deleted": {
    fr: "Configuration supprimée avec succès",
    en: "Configuration deleted successfully"
  },
  "config.deleteError": {
    fr: "Erreur lors de la suppression",
    en: "Error deleting configuration"
  },
  "config.invalidFileExtension": {
    fr: "Seuls les fichiers .mgrd sont acceptés",
    en: "Only .mgrd files are accepted"
  },
  "config.rename": {
    fr: "Renommer",
    en: "Rename"
  },
  "config.renamed": {
    fr: "Configuration renommée avec succès",
    en: "Configuration renamed successfully"
  },
  "config.renameError": {
    fr: "Erreur lors du renommage",
    en: "Error renaming configuration"
  },
  "config.setAsDefault": {
    fr: "Définir comme défaut",
    en: "Set as default"
  },
  "config.setDefaultError": {
    fr: "Erreur lors de la définition comme défaut",
    en: "Error setting as default"
  },
  "config.nameRequired": {
    fr: "Le nom ne peut pas être vide",
    en: "Name cannot be empty"
  },
  "config.importedAndSaved": {
    fr: "Configuration \"{name}\" importée et sauvegardée",
    en: "Configuration \"{name}\" imported and saved"
  },
  "config.delete": {
    fr: "Supprimer",
    en: "Delete"
  },

  // Logo Management
  "logo.title": {
    fr: "Logo",
    en: "Logo"
  },
  "logo.description": {
    fr: "Ajouter et gérer des logos",
    en: "Add and manage logos"
  },
  "logo.import": {
    fr: "Importer un logo",
    en: "Import a logo"
  },
  "logo.imported": {
    fr: "Logos importés",
    en: "Imported logos"
  },
  "logo.width": {
    fr: "Largeur",
    en: "Width"
  },
  "logo.height": {
    fr: "Hauteur",
    en: "Height"
  },
  // Text Management
  "text.title": {
    fr: "Texte",
    en: "Text"
  },
  "text.description": {
    fr: "Ajouter et gérer du texte",
    en: "Add and manage text"
  },
  "text.elements": {
    fr: "Éléments de texte",
    en: "Text elements"
  },
  "text.placeholder": {
    fr: "Entrez votre texte...",
    en: "Enter your text..."
  },
  "text.size": {
    fr: "Taille",
    en: "Size"
  },
  "text.font": {
    fr: "Police",
    en: "Font"
  },
  "text.weight": {
    fr: "Épaisseur",
    en: "Weight"
  },
  "text.style": {
    fr: "Style",
    en: "Style"
  },
  "text.stroke": {
    fr: "Contour supplémentaire",
    en: "Additional stroke"
  },
  "text.light": {
    fr: "Léger",
    en: "Light"
  },
  "text.normal": {
    fr: "Normal",
    en: "Normal"
  },
  "text.bold": {
    fr: "Gras",
    en: "Bold"
  },
  "text.ultrabold": {
    fr: "Ultra-Gras",
    en: "Ultra-Bold"
  },
  "text.extrabold": {
    fr: "Extra-Épais",
    en: "Extra-Bold"
  },
  "text.tips": {
    fr: "• Cliquez sur le canvas pour positionner\n• Utilisez les flèches pour déplacer (Shift = 10px)\n• Le texte sélectionné est entouré en vert",
    en: "• Click on the canvas to position\n• Use arrow keys to move (Shift = 10px)\n• Selected text is outlined in green"
  },

  // Grid Offset Controls
  "config.gridOffset": {
    fr: "Offset de la grille",
    en: "Grid Offset"
  },
  "config.gridOffsetX": {
    fr: "Offset X",
    en: "Offset X"
  },
  "config.gridOffsetY": {
    fr: "Offset Y",
    en: "Offset Y"
  },
  "config.gridOffsetDesc": {
    fr: "Permet de décaler la grille par rapport à son origine\nUtilisez les champs numériques pour des valeurs précises ou hors plage",
    en: "Allows shifting the grid from its origin\nUse numeric fields for precise or out-of-range values"
  },

  // Direction des dégradés
  "config.rampDirection": {
    fr: "Direction du dégradé",
    en: "Ramp Direction"
  },
  "config.horizontal": {
    fr: "Horizontal",
    en: "Horizontal"
  },
  "config.vertical": {
    fr: "Vertical",
    en: "Vertical"
  },

  // Multi-Grid
  "multigrid.title": {
    fr: "MultiGrid",
    en: "MultiGrid"
  },
  "multigrid.description": {
    fr: "Mode multi-grilles",
    en: "Multi-grid mode"
  },
  "multigrid.canvas": {
    fr: "Configuration du Canvas",
    en: "Canvas Configuration"
  },
  "multigrid.grids": {
    fr: "Grilles",
    en: "Grids"
  },
  "multigrid.noGrids": {
    fr: "Aucune grille créée. Cliquez sur + pour ajouter une grille.",
    en: "No grids created. Click + to add a grid."
  },
  "multigrid.gridParams": {
    fr: "Paramètres de la grille",
    en: "Grid Parameters"
  },
  "multigrid.bgColor": {
    fr: "Couleur de fond",
    en: "Background Color"
  },
  "multigrid.position": {
    fr: "Position",
    en: "Position"
  },
  "multigrid.positionX": {
    fr: "Position X",
    en: "Position X"
  },
  "multigrid.positionY": {
    fr: "Position Y",
    en: "Position Y"
  },
  "multigrid.dragTip": {
    fr: "Conseil: Vous pouvez déplacer la grille en la faisant glisser sur le canvas.",
    en: "Tip: You can move the grid by dragging it on the canvas."
  },
  "multigrid.newGrid": {
    fr: "Nouvelle grille ajoutée",
    en: "New grid added"
  },
  "multigrid.gridDeleted": {
    fr: "Grille supprimée",
    en: "Grid deleted"
  },
  "multigrid.gridDuplicated": {
    fr: "Grille dupliquée",
    en: "Grid duplicated"
  },
  "multigrid.gridCopied": {
    fr: "Grille copiée dans le presse-papiers",
    en: "Grid copied to clipboard"
  },
  "multigrid.gridPasted": {
    fr: "Grille collée",
    en: "Grid pasted"
  },
  "multigrid.noCopiedGrid": {
    fr: "Aucune grille dans le presse-papiers",
    en: "No grid in clipboard"
  },
  "multigrid.duplicateGrid": {
    fr: "Dupliquer la grille",
    en: "Duplicate grid"
  },
  "multigrid.deleteGrid": {
    fr: "Supprimer la grille",
    en: "Delete grid"
  },

  // Pixel Map Mode (Premium)
  "config.pixelMapMode": {
    fr: "Pixel Map",
    en: "Pixel Map"
  },
  "config.pixelMapMode.mainScreenText": {
    fr: "Texte principal",
    en: "Main Screen Text"
  },
  "config.pixelMapMode.position": {
    fr: "Position (X, Y)",
    en: "Position (X, Y)"
  },
  "config.pixelMapMode.resolution": {
    fr: "Résolution mire",
    en: "Test Pattern Resolution"
  },
  "config.pixelMapMode.panel": {
    fr: "Taille panneaux",
    en: "Panel Size"
  },
  "config.pixelMapMode.size": {
    fr: "Taille",
    en: "Size"
  },

  "multigrid.exportSuccess": {
    fr: "Canvas exporté avec succès",
    en: "Canvas exported successfully"
  },
  "multigrid.exportError": {
    fr: "Erreur lors de l'exportation",
    en: "Error during export"
  },
  "multigrid.configSaved": {
    fr: "Configuration sauvegardée",
    en: "Configuration saved"
  },
  "multigrid.saveError": {
    fr: "Erreur lors de la sauvegarde",
    en: "Error during save"
  },
  "multigrid.gridDefaultName": {
    fr: "Grille",
    en: "Grid"
  },
  "multigrid.gridName": {
    fr: "Nom",
    en: "Name"
  },
  "multigrid.recapTitle": {
    fr: "Récapitulatif",
    en: "Summary"
  },
  "multigrid.recapCanvasSize": {
    fr: "Taille Canvas",
    en: "Canvas Size"
  },
  "multigrid.recapTotalPixels": {
    fr: "Total Pixels",
    en: "Total Pixels"
  },
  "multigrid.recapGridCount": {
    fr: "Nombre de grilles",
    en: "Grid Count"
  },
  "multigrid.previewControls": {
    fr: "Contrôles de l'aperçu",
    en: "Preview Controls"
  },
  "multigrid.zoom": {
    fr: "Zoom",
    en: "Zoom"
  },
  "multigrid.animation": {
    fr: "Animation",
    en: "Animation"
  },
  "multigrid.snap": {
    fr: "Alignement magnétique",
    en: "Snap to grids"
  },
  "multigrid.canvasConfig": {
    fr: "Configuration du Canvas",
    en: "Canvas Configuration"
  },
  "multigrid.start": {
    fr: "Démarrer",
    en: "Start"
  },
  "multigrid.stop": {
    fr: "Arrêter",
    en: "Stop"
  },
  "multigrid.showName": {
    fr: "Afficher le nom",
    en: "Show name"
  },
  "multigrid.doubleClickToEdit": {
    fr: "Double-clic pour éditer",
    en: "Double-click to edit"
  },
  "multigrid.editGridName": {
    fr: "Modifier le nom de la grille",
    en: "Edit grid name"
  },
  "multigrid.editGridNameDesc": {
    fr: "Modifiez le nom de la grille qui sera affiché sur la mire.",
    en: "Edit the grid name that will be displayed on the test pattern."
  },
  "multigrid.resetNamePosition": {
    fr: "Réinitialiser la position",
    en: "Reset position"
  },
  "multigrid.showLEDNumbers": {
    fr: "Afficher les numéros LED",
    en: "Show LED numbers"
  },
  "multigrid.arrowTip": {
    fr: "Utilisez les flèches pour déplacer la grille (Shift=10px, Ctrl=5px)",
    en: "Use arrow keys to move the grid (Shift=10px, Ctrl=5px)"
  },
  "multigrid.patternMode": {
    fr: "Mode de motif",
    en: "Pattern Mode"
  },
  "multigrid.customPattern": {
    fr: "Motif",
    en: "Pattern"
  },
  "multigrid.solidColor": {
    fr: "Couleur unie",
    en: "Solid Color"
  },
  "multigrid.standardPattern": {
    fr: "Mire standard",
    en: "Standard Test Pattern"
  },
  "multigrid.logoScale": {
    fr: "Taille du logo",
    en: "Logo Size"
  },
  "multigrid.textScale": {
    fr: "Taille du texte",
    en: "Text Size"
  },
  "multigrid.invalidCalculation": {
    fr: "Calcul invalide",
    en: "Invalid calculation"
  },
  "multigrid.canvasPattern": {
    fr: "Motif du canvas",
    en: "Canvas Pattern"
  },
  "multigrid.canvasPatternDesc": {
    fr: "Le motif couvre tout le canvas. Les mires deviennent des fenêtres transparentes.",
    en: "The pattern covers the entire canvas. Grids become transparent windows."
  },
  "multigrid.canvasPatternNone": {
    fr: "Aucun (motifs par mire)",
    en: "None (per-grid patterns)"
  },
  "multigrid.canvasPatternActive": {
    fr: "Un motif est défini au niveau du canvas. Les mires sont des fenêtres transparentes vers ce motif.",
    en: "A canvas-level pattern is active. Grids are transparent windows into this pattern."
  },
  "multigrid.animSpeed": {
    fr: "Vitesse",
    en: "Speed"
  },

  // Additional config options (without duplicates)
  "config.showDimensions": { fr: "Afficher dimensions", en: "Show Dimensions" },
  "config.dalleWidth": { fr: "Largeur Dalle", en: "Slab Width" },
  "config.dalleHeight": { fr: "Hauteur Dalle", en: "Slab Height" },
  "config.display": { fr: "Affichage", en: "Display" },
  "config.panelConfig": { fr: "Configuration des dalles", en: "Panel Configuration" },
  "config.gridConfigTitle": { fr: "Configuration de la Grille", en: "Grid Configuration" },

  // Snake Game translations
  "snake.title": {
    fr: "🐍 Classement Snake",
    en: "🐍 Snake Leaderboard"
  },
  "snake.description": {
    fr: "Les meilleurs scores du jeu Snake",
    en: "Best Snake game scores"
  },
  "snake.refresh": {
    fr: "Actualiser",
    en: "Refresh"
  },
  "snake.players": {
    fr: "Joueurs",
    en: "Players"
  },
  "snake.games": {
    fr: "Parties",
    en: "Games"
  },
  "snake.record": {
    fr: "Record",
    en: "Record"
  },
  "snake.average": {
    fr: "Moyenne",
    en: "Average"
  },
  "snake.noScores": {
    fr: "Aucun score enregistré pour le moment.",
    en: "No scores recorded yet."
  },
  "snake.firstScore": {
    fr: "Soyez le premier à jouer et enregistrer votre score !",
    en: "Be the first to play and record your score!"
  },
  "snake.champion": {
    fr: "👑 Champion",
    en: "👑 Champion"
  },
  "snake.panels": {
    fr: "panneaux",
    en: "panels"
  },
  "snake.points": {
    fr: "points",
    en: "points"
  },
  "snake.submitScore": {
    fr: "Envoyer le score",
    en: "Submit Score"
  },
  "snake.victory": {
    fr: "🎉 Victoire !",
    en: "🎉 Victory!"
  },
  "snake.gameOver": {
    fr: "Partie terminée",
    en: "Game Over"
  },
  "snake.victoryMessage": {
    fr: "Félicitations ! Vous avez terminé le jeu avec succès.",
    en: "Congratulations! You have successfully completed the game."
  },
  "snake.gameOverMessage": {
    fr: "Votre partie est terminée. Souhaitez-vous enregistrer votre score ?",
    en: "Your game is over. Would you like to record your score?"
  },
  "snake.finalScore": {
    fr: "Score final :",
    en: "Final score:"
  },
  "snake.totalPanels": {
    fr: "Panneaux totaux :",
    en: "Total panels :"
  },
  "snake.grid": {
    fr: "Grille :",
    en: "Grid :"
  },
  "snake.playerName": {
    fr: "Votre nom",
    en: "Your name"
  },
  "snake.enterName": {
    fr: "Entrez votre nom...",
    en: "Enter your name..."
  },
  "snake.save": {
    fr: "Enregistrer",
    en: "Save"
  },
  "snake.cancel": {
    fr: "Annuler",
    en: "Cancel"
  },
  "snake.saving": {
    fr: "Envoi...",
    en: "Saving..."
  },
  "snake.scoreRecorded": {
    fr: "Score enregistré !",
    en: "Score recorded !"
  },
  "snake.scoreRecordedMessage": {
    fr: "Votre score a été ajouté au classement.",
    en: "Your score has been added to the leaderboard."
  },
  "snake.newPersonalRecord": {
    fr: "🎉 Nouveau record personnel ! Score: {score} points",
    en: "🎉 New personal record! Score: {score} points"
  },
  "snake.scoreSubmitted": {
    fr: "Score enregistré ! Score: {score} points",
    en: "Score recorded! Score: {score} points"
  },
  "snake.apiUnavailable": {
    fr: "API non disponible en mode développement. Redémarrez le serveur.",
    en: "API unavailable in development mode. Restart the server."
  },
  "snake.loadError": {
    fr: "Impossible de charger le classement",
    en: "Unable to load leaderboard"
  },
  "snake.startGame": {
    fr: "Start Snake",
    en: "Start Snake"
  },
  "snake.stopGame": {
    fr: "Stop Snake",
    en: "Stop Snake"
  },
  "snake.resetGame": {
    fr: "Reset Snake",
    en: "Reset Snake"
  },
  "snake.score": {
    fr: "Score",
    en: "Score"
  },
  "snake.state": {
    fr: "État",
    en: "State"
  },
  "snake.playing": {
    fr: "En cours",
    en: "Playing"
  },
  "snake.stopped": {
    fr: "Arrêté",
    en: "Stopped"
  },
  "multigrid.multiplayerMode": {
    fr: "Mode Multijoueur:",
    en: "Multiplayer Mode:"
  },
  "multigrid.multiplayerDesc": {
    fr: "Créez plusieurs grilles avec le motif Snake Game pour jouer jusqu'à 4 joueurs simultanément !",
    en: "Create multiple grids with Snake Game pattern to play up to 4 players simultaneously !"
  },

  // External Display / Affichage Externe
  "external.button": {
    fr: "Affichage Externe",
    en: "External Display"
  },
  "external.connected": {
    fr: "Écran externe connecté",
    en: "External screen connected"
  },
  "external.fullscreen": {
    fr: "(Plein écran)",
    en: "(Fullscreen)"
  },
  "external.reconnecting": {
    fr: "Reconnexion...",
    en: "Reconnecting..."
  },
  "external.synchronized": {
    fr: "Synchronisé",
    en: "Synchronized"
  },
  "external.quit": {
    fr: "Quitter",
    en: "Quit"
  },
  "external.indicator": {
    fr: "Écran Externe - Synchronisé",
    en: "External Screen - Synchronized"
  },
  "external.fullscreenTip": {
    fr: "Pressez F11 pour le plein écran",
    en: "Press F11 for fullscreen"
  },
  "external.openSuccess": {
    fr: "🖥️ Affichage externe ouvert sur {screenName} ({width}×{height})",
    en: "🖥️ External display opened on {screenName} ({width}×{height})"
  },
  "external.electronSuccess": {
    fr: "🖥️ Affichage externe Electron sur {screenName} ({width}×{height})",
    en: "🖥️ Electron external display on {screenName} ({width}×{height})"
  },
  "external.noScreen": {
    fr: "Aucun écran disponible pour l'affichage externe.",
    en: "No screen available for external display."
  },
  "external.popupBlocked": {
    fr: "❌ Impossible d'ouvrir l'affichage externe. Vérifiez les paramètres de popup.",
    en: "❌ Unable to open external display. Check popup settings."
  },
  "external.generalError": {
    fr: "Erreur lors de l'ouverture de l'affichage externe",
    en: "Error opening external display"
  },
  "external.screenName": {
    fr: "Écran Principal",
    en: "Primary Screen"
  },
  "external.screenNumber": {
    fr: "Écran {number}",
    en: "Display {number}"
  },
  "external.singleDisplay": {
    fr: "Un seul écran détecté. L'affichage externe en plein écran nécessite plusieurs écrans connectés.",
    en: "Only one display detected. External display fullscreen requires multiple connected displays."
  },

  // Snake MultiGrid Mode
  "snake.multiGrid.title": {
    fr: "🐍 Snake Game Multijoueur",
    en: "🐍 Multiplayer Snake Game"
  },
  "snake.multiGrid.description": {
    fr: "Mode multijoueur jusqu'à 4 joueurs simultanés",
    en: "Multiplayer mode up to 4 simultaneous players"
  },
  "snake.multiGrid.player": {
    fr: "Joueur",
    en: "Player"
  },
  "snake.multiGrid.player1": {
    fr: "Joueur 1",
    en: "Player 1"
  },
  "snake.multiGrid.player2": {
    fr: "Joueur 2",
    en: "Player 2"
  },
  "snake.multiGrid.player3": {
    fr: "Joueur 3",
    en: "Player 3"
  },
  "snake.multiGrid.player4": {
    fr: "Joueur 4",
    en: "Player 4"
  },

  // Control sets for each player
  "snake.multiGrid.controls": {
    fr: "Contrôles",
    en: "Controls"
  },
  "snake.multiGrid.controlSet1": {
    fr: "ZQSD",
    en: "WASD"
  },
  "snake.multiGrid.controlSet2": {
    fr: "Flèches directionnelles",
    en: "Arrow keys"
  },
  "snake.multiGrid.controlSet3": {
    fr: "IKJL",
    en: "IKJL"
  },
  "snake.multiGrid.controlSet4": {
    fr: "TGFH",
    en: "TGFH"
  },

  // Control instructions
  "snake.multiGrid.controlInstructions": {
    fr: "Contrôles Snake Game",
    en: "Snake Game Controls"
  },
  "snake.multiGrid.keys.up": {
    fr: "Haut",
    en: "Up"
  },
  "snake.multiGrid.keys.down": {
    fr: "Bas",
    en: "Down"
  },
  "snake.multiGrid.keys.left": {
    fr: "Gauche",
    en: "Left"
  },
  "snake.multiGrid.keys.right": {
    fr: "Droite",
    en: "Right"
  },

  // Game states and status
  "snake.multiGrid.status.waiting": {
    fr: "En attente",
    en: "Waiting"
  },
  "snake.multiGrid.status.playing": {
    fr: "En cours",
    en: "Playing"
  },
  "snake.multiGrid.status.gameOver": {
    fr: "Game Over",
    en: "Game Over"
  },
  "snake.multiGrid.status.victory": {
    fr: "Victoire",
    en: "Victory"
  },

  // Buttons and actions
  "snake.multiGrid.start": {
    fr: "Démarrer",
    en: "Start"
  },
  "snake.multiGrid.stop": {
    fr: "Arrêter",
    en: "Stop"
  },
  "snake.multiGrid.reset": {
    fr: "Réinitialiser",
    en: "Reset"
  },
  "snake.multiGrid.startAll": {
    fr: "Démarrer tous",
    en: "Start All"
  },
  "snake.multiGrid.stopAll": {
    fr: "Arrêter tous",
    en: "Stop All"
  },
  "snake.multiGrid.resetAll": {
    fr: "Réinitialiser tous",
    en: "Reset All"
  },

  // Global controls
  "snake.multiGrid.globalControls": {
    fr: "Contrôles globaux",
    en: "Global controls"
  },
  "snake.multiGrid.globalButton": {
    fr: "Réinitialiser et démarrer tous les jeux Snake (Espace)",
    en: "Reset and start all Snake games (Space)"
  },
  "snake.multiGrid.spaceKey": {
    fr: "Barre Espace",
    en: "Space Bar"
  },
  "snake.multiGrid.gamepadButton": {
    fr: "Bouton Gamepad",
    en: "Gamepad Button"
  },

  // Success messages
  "snake.multiGrid.allStarted": {
    fr: "{count} jeu(x) Snake réinitialisé(s) et démarré(s)!",
    en: "{count} Snake game(s) reset and started!"
  },
  "snake.multiGrid.allStopped": {
    fr: "{count} jeu(x) Snake arrêté(s)!",
    en: "{count} Snake game(s) stopped!"
  },
  "snake.multiGrid.gameStarted": {
    fr: "Snake Game réinitialisé et démarré!",
    en: "Snake Game reset and started!"
  },
  "snake.multiGrid.gameReset": {
    fr: "Snake Game réinitialisé!",
    en: "Snake Game reset!"
  },

  // Score display
  "snake.multiGrid.score": {
    fr: "Score",
    en: "Score"
  },
  "snake.multiGrid.currentScore": {
    fr: "Score : {score}",
    en: "Score: {score}"
  },

  // Grid information
  "snake.multiGrid.gridInfo": {
    fr: "Grille {gridNumber}",
    en: "Grid {gridNumber}"
  },
  "snake.multiGrid.playerControls": {
    fr: "P{playerNumber}: {controls}",
    en: "P{playerNumber}: {controls}"
  },

  // Pattern selection
  "snake.multiGrid.pattern": {
    fr: "🐍 Snake Game",
    en: "🐍 Snake Game"
  },
  "snake.multiGrid.patternDescription": {
    fr: "Jeu interactif multijoueur intégré",
    en: "Integrated multiplayer interactive game"
  },

  // Auto-configuration messages
  "snake.multiGrid.autoConfig": {
    fr: "Configuration automatique activée pour Snake",
    en: "Auto-configuration enabled for Snake"
  },
  "snake.multiGrid.elementsDisabled": {
    fr: "Grille, logo, sonar et nom désactivés automatiquement",
    en: "Grid, logo, sonar and name automatically disabled"
  },

  // Movement and controls
  "snake.multiGrid.movement": {
    fr: "Mouvement",
    en: "Movement"
  },
  "snake.multiGrid.constantMovement": {
    fr: "Mouvement constant garanti",
    en: "Constant movement guaranteed"
  },
  "snake.multiGrid.instantDirection": {
    fr: "Changement de direction instantané",
    en: "Instant direction change"
  },

  // Competition and multiplayer
  "snake.multiGrid.competition": {
    fr: "Compétition",
    en: "Competition"
  },
  "snake.multiGrid.multiplayer": {
    fr: "Multijoueur",
    en: "Multiplayer"
  },
  "snake.multiGrid.simultaneous": {
    fr: "2-4 joueurs simultanés",
    en: "2-4 simultaneous players"
  },
  "snake.multiGrid.independentSessions": {
    fr: "Sessions indépendantes",
    en: "Independent sessions"
  },
  "snake.multiGrid.realTimeCompetition": {
    fr: "Compétition temps réel",
    en: "Real-time competition"
  },

  // Error and warning messages
  "snake.multiGrid.error.noActiveGames": {
    fr: "Aucun jeu Snake actif trouvé",
    en: "No active Snake games found"
  },
  "snake.multiGrid.error.gridNotFound": {
    fr: "Grille non trouvée",
    en: "Grid not found"
  },
  "snake.multiGrid.warning.arrowKeysDisabled": {
    fr: "Navigation par flèches désactivée pendant le jeu",
    en: "Arrow key navigation disabled during game"
  },

  // Performance and optimization
  "snake.multiGrid.performance": {
    fr: "Performance",
    en: "Performance"
  },
  "snake.multiGrid.timerOptimized": {
    fr: "Timer global optimisé",
    en: "Optimized global timer"
  },
  "snake.multiGrid.renderOptimized": {
    fr: "Rendu optimisé par grille",
    en: "Optimized per-grid rendering"
  },

  // Setup and configuration
  "snake.multiGrid.setup": {
    fr: "Configuration",
    en: "Setup"
  },
  "snake.multiGrid.idealSetup": {
    fr: "Configuration idéale",
    en: "Ideal setup"
  },
  "snake.multiGrid.gridLayout": {
    fr: "Disposition des grilles",
    en: "Grid layout"
  },
  "snake.multiGrid.competition.local": {
    fr: "Compétition Locale",
    en: "Local Competition"
  },
  "snake.multiGrid.demo.public": {
    fr: "Démonstrations Publiques",
    en: "Public Demonstrations"
  },
  "snake.multiGrid.test.installation": {
    fr: "Tests d'Installation",
    en: "Installation Tests"
  },

  // Tips and instructions
  "snake.multiGrid.tips": {
    fr: "Conseils",
    en: "Tips"
  },
  "snake.multiGrid.tip.autoAssignment": {
    fr: "Les contrôles sont assignés automatiquement",
    en: "Controls are automatically assigned"
  },
  "snake.multiGrid.tip.noRestart": {
    fr: "Pas de redémarrage par touches après Game Over",
    en: "No key restart after Game Over"
  },
  "snake.multiGrid.tip.globalReset": {
    fr: "Utilisez le bouton vert pour reset global",
    en: "Use green button for global reset"
  },
  "snake.multiGrid.tip.smoothMovement": {
    fr: "Mouvement fluide garanti",
    en: "Smooth movement guaranteed"
  },

  // Advanced features
  "snake.multiGrid.advanced": {
    fr: "Fonctionnalités avancées",
    en: "Advanced features"
  },
  "snake.multiGrid.antiCheat": {
    fr: "Système anti-triche",
    en: "Anti-cheat system"
  },
  "snake.multiGrid.dimensionLock": {
    fr: "Dimensions verrouillées au démarrage",
    en: "Dimensions locked at startup"
  },
  "snake.multiGrid.globalTimer": {
    fr: "Timer global synchronisé",
    en: "Synchronized global timer"
  },
  "snake.multiGrid.atomicUpdates": {
    fr: "Mises à jour atomiques",
    en: "Atomic updates"
  },

  // ========== AUTHENTIFICATION ==========
  "auth.welcome": {
    fr: "Bienvenue",
    en: "Welcome"
  },
  "auth.welcomeLogin": {
    fr: "Connectez-vous ou créez un compte pour continuer",
    en: "Sign in or create an account to continue"
  },
  "auth.welcomeSignup": {
    fr: "Créez votre compte ou connectez-vous",
    en: "Create your account or sign in"
  },
  "auth.login": {
    fr: "Connexion",
    en: "Login"
  },
  "auth.signup": {
    fr: "Inscription",
    en: "Sign up"
  },
  "auth.continueWithGoogle": {
    fr: "Continuer avec Google",
    en: "Continue with Google"
  },
  "auth.signupWithGoogle": {
    fr: "S'inscrire avec Google",
    en: "Sign up with Google"
  },
  "auth.orContinueWith": {
    fr: "Ou continuer avec",
    en: "Or continue with"
  },
  "auth.orSignupWith": {
    fr: "Ou s'inscrire avec",
    en: "Or sign up with"
  },
  "auth.email": {
    fr: "Email",
    en: "Email"
  },
  "auth.password": {
    fr: "Mot de passe",
    en: "Password"
  },
  "auth.emailPlaceholder": {
    fr: "vous@exemple.com",
    en: "you@example.com"
  },
  "auth.passwordPlaceholder": {
    fr: "••••••••",
    en: "••••••••"
  },
  "auth.displayName": {
    fr: "Nom d'affichage",
    en: "Display name"
  },
  "auth.displayNamePlaceholder": {
    fr: "Votre nom",
    en: "Your name"
  },
  "auth.passwordRequirement": {
    fr: "Au moins 6 caractères",
    en: "At least 6 characters"
  },
  "auth.loggingIn": {
    fr: "Connexion en cours...",
    en: "Logging in..."
  },
  "auth.creatingAccount": {
    fr: "Création en cours...",
    en: "Creating account..."
  },
  "auth.signIn": {
    fr: "Se connecter",
    en: "Sign in"
  },
  "auth.createAccount": {
    fr: "Créer un compte",
    en: "Create account"
  },
  "auth.termsAcceptance": {
    fr: "En créant un compte, vous acceptez nos conditions d'utilisation",
    en: "By creating an account, you accept our terms of use"
  },
  "auth.home": {
    fr: "Accueil",
    en: "Home"
  },
  "auth.connectingInProgress": {
    fr: "Connexion en cours...",
    en: "Connecting..."
  },
  "auth.callback.title": {
    fr: "Connexion réussie !",
    en: "Sign in successful!"
  },
  "auth.callback.message": {
    fr: "Vous pouvez maintenant retourner sur l'application VisualGrid",
    en: "You can now return to the VisualGrid application"
  },
  "auth.callback.redirecting": {
    fr: "Redirection vers l'application...",
    en: "Redirecting to application..."
  },
  "auth.callback.manualRedirect": {
    fr: "Si la redirection ne fonctionne pas, fermez cette fenêtre et retournez sur l'application.",
    en: "If the redirect doesn't work, close this window and return to the application."
  },

  // ========== COMPTE UTILISATEUR ==========
  "account.myAccount": {
    fr: "Mon Compte",
    en: "My Account"
  },
  "account.languagePreferences": {
    fr: "Préférences de langue",
    en: "Language Preferences"
  },
  "account.chooseLanguage": {
    fr: "Choisissez votre langue préférée",
    en: "Choose your preferred language"
  },
  "account.language": {
    fr: "Langue",
    en: "Language"
  },
  "account.languageUpdated": {
    fr: "Langue mise à jour !",
    en: "Language updated!"
  },
  "account.french": {
    fr: "Français",
    en: "French"
  },
  "account.english": {
    fr: "Anglais",
    en: "English"
  },
  "account.manageProfile": {
    fr: "Gérez votre profil et votre abonnement VisualGrid",
    en: "Manage your VisualGrid profile and subscription"
  },
  "account.back": {
    fr: "Retour",
    en: "Back"
  },
  "account.profile": {
    fr: "Profil",
    en: "Profile"
  },
  "account.personalInfo": {
    fr: "Vos informations personnelles",
    en: "Your personal information"
  },
  "account.user": {
    fr: "Utilisateur",
    en: "User"
  },
  "account.memberSince": {
    fr: "Membre depuis",
    en: "Member since"
  },
  "account.accountStatus": {
    fr: "Statut du compte",
    en: "Account status"
  },
  "account.active": {
    fr: "Actif",
    en: "Active"
  },
  "account.statistics": {
    fr: "Statistiques",
    en: "Statistics"
  },
  "account.yourActivity": {
    fr: "Votre activité sur VisualGrid",
    en: "Your VisualGrid activity"
  },
  "account.projectsCreated": {
    fr: "Projets créés",
    en: "Projects created"
  },
  "account.patternsGenerated": {
    fr: "Mires générées",
    en: "Patterns generated"
  },
  "account.configurations": {
    fr: "Configurations",
    en: "Configurations"
  },
  "account.exports": {
    fr: "Exports",
    en: "Exports"
  },
  "account.signOut": {
    fr: "Se déconnecter",
    en: "Sign out"
  },
  "account.subscription": {
    fr: "Abonnement",
    en: "Subscription"
  },
  "account.yourPlan": {
    fr: "Votre plan VisualGrid",
    en: "Your VisualGrid plan"
  },
  "account.currentPlan": {
    fr: "Plan actuel",
    en: "Current plan"
  },
  "account.pro": {
    fr: "Pro",
    en: "Pro"
  },
  "account.free": {
    fr: "Free",
    en: "Free"
  },
  "account.gracePeriod": {
    fr: "Mode Grâce",
    en: "Grace Period"
  },
  "account.perMonth": {
    fr: "tous les 6 mois",
    en: "every 6 months"
  },
  "account.activeSubscription": {
    fr: "Abonnement actif",
    en: "Active subscription"
  },
  "account.yourProBenefits": {
    fr: "Vos avantages Pro",
    en: "Your Pro benefits"
  },
  "account.proBenefits": {
    fr: "Avantages du plan Pro",
    en: "Pro plan benefits"
  },
  "account.multiGridAccess": {
    fr: "Accès au MultiGrid",
    en: "MultiGrid access"
  },
  "account.advancedSynoptic": {
    fr: "Interface Synoptique avancée",
    en: "Advanced Synoptic interface"
  },
  "account.highResExports": {
    fr: "Exports haute résolution",
    en: "High resolution exports"
  },
  "account.unlimitedSessions": {
    fr: "Sessions partagées illimitées",
    en: "Unlimited shared sessions"
  },
  "account.prioritySupport": {
    fr: "Support prioritaire",
    en: "Priority support"
  },
  "account.earlyUpdates": {
    fr: "Mises à jour anticipées",
    en: "Early updates"
  },
  "account.manageSubscription": {
    fr: "Gérer l'abonnement",
    en: "Manage subscription"
  },
  "account.loading": {
    fr: "Chargement...",
    en: "Loading..."
  },
  "account.unlockFeatures": {
    fr: "Débloquez toutes les fonctionnalités professionnelles",
    en: "Unlock all professional features"
  },
  "account.upgradeToPro": {
    fr: "Passer en Pro",
    en: "Upgrade to Pro"
  },
  "account.subscriptionDetails": {
    fr: "Détails de l'abonnement",
    en: "Subscription details"
  },
  "account.amount": {
    fr: "Montant",
    en: "Amount"
  },
  "account.subscriptionType": {
    fr: "Type d'abonnement",
    en: "Subscription type"
  },
  "account.monthly": {
    fr: "Tous les 6 mois",
    en: "Every 6 months"
  },
  "account.paymentMethod": {
    fr: "Méthode de paiement",
    en: "Payment method"
  },
  "account.nextBilling": {
    fr: "Prochaine facturation",
    en: "Next billing"
  },
  "account.noActiveSubscription": {
    fr: "Aucun abonnement actif",
    en: "No active subscription"
  },
  "account.upgradeForAdvanced": {
    fr: "Passez en Pro pour accéder aux fonctionnalités avancées",
    en: "Upgrade to Pro to access advanced features"
  },
  "account.testMode": {
    fr: "Mode Test",
    en: "Test Mode"
  },
  "account.development": {
    fr: "Développement",
    en: "Development"
  },
  "account.testModeDesc": {
    fr: "Outils pour tester rapidement les différents états du système",
    en: "Tools to quickly test different system states"
  },
  "account.downgradeToFree": {
    fr: "⬇️ Repasser en Free",
    en: "⬇️ Downgrade to Free"
  },
  "account.downgradeHint": {
    fr: "Utile pour tester le paywall et la page Pro sans recréer un compte",
    en: "Useful for testing the paywall and Pro page without recreating an account"
  },
  "account.userNotLoggedIn": {
    fr: "Utilisateur non connecté",
    en: "User not logged in"
  },
  "account.billingServiceNotConfigured": {
    fr: "Service de facturation non configuré. Contactez le support.",
    en: "Billing service not configured. Contact support."
  },
  "account.noStripeSubscription": {
    fr: "Aucun abonnement Stripe trouvé. Veuillez contacter le support.",
    en: "No Stripe subscription found. Please contact support."
  },
  "account.sessionExpired": {
    fr: "Session expirée. Reconnectez-vous.",
    en: "Session expired. Please sign in again."
  },
  "account.redirectingToStripe": {
    fr: "Redirection vers le portail Stripe...",
    en: "Redirecting to Stripe portal..."
  },
  "account.requestTimeout": {
    fr: "La requête a expiré. Vérifiez votre connexion internet.",
    en: "Request timed out. Check your internet connection."
  },
  "account.stripePortalNotConfigured": {
    fr: "Le portail client Stripe n'est pas configuré. Contactez l'administrateur.",
    en: "Stripe customer portal is not configured. Contact administrator."
  },
  "account.planUpdatedToFree": {
    fr: "Plan mis à jour en Free !",
    en: "Plan updated to Free!"
  },
  "account.downgradeError": {
    fr: "Erreur lors du downgrade : ",
    en: "Error during downgrade: "
  },

  // ========== LANDING PAGE ==========
  "landing.hero.title": {
    fr: "Générateur de Mires LED",
    en: "LED Test Pattern Generator"
  },
  "landing.hero.subtitle": {
    fr: "Professionnel",
    en: "Professional"
  },
  "landing.hero.description": {
    fr: "Créez, testez et gérez vos configurations d'écrans LED avec une interface intuitive et puissante. Générez des mires de test professionnelles, visualisez vos LED walls en temps réel et gérez des configurations multi-écrans complexes.",
    en: "Create, test and manage your LED screen configurations with an intuitive and powerful interface. Generate professional test patterns, visualize your LED walls in real-time and manage complex multi-screen configurations."
  },
  "landing.hero.startFree": {
    fr: "Créer ma test pattern",
    en: "Create my test pattern"
  },
  "landing.hero.discoverPro": {
    fr: "Découvrir Pro",
    en: "Discover Pro"
  },
  "landing.features.title": {
    fr: "Fonctionnalités Principales",
    en: "Main Features"
  },
  "landing.features.subtitle": {
    fr: "Des outils professionnels pour vos projets LED",
    en: "Professional tools for your LED projects"
  },
  "landing.features.testPattern.title": {
    fr: "Générateur de Mires LED",
    en: "LED Test Pattern Generator"
  },
  "landing.features.testPattern.desc": {
    fr: "Créez et testez des mires personnalisées pour vos écrans LED professionnels",
    en: "Create and test custom patterns for your professional LED screens"
  },
  "landing.features.synoptic.title": {
    fr: "Interface Synoptique",
    en: "Synoptic Interface"
  },
  "landing.features.synoptic.desc": {
    fr: "Visualisez et gérez vos configurations LED wall en temps réel",
    en: "Visualize and manage your LED wall configurations in real-time"
  },
  "landing.features.multigrid.title": {
    fr: "MultiGrid Avancé",
    en: "Advanced MultiGrid"
  },
  "landing.features.multigrid.desc": {
    fr: "Gestion multi-écrans et configurations complexes",
    en: "Multi-screen management and complex configurations"
  },
  "landing.pricing.title": {
    fr: "Passez à VisualGrid Pro",
    en: "Upgrade to VisualGrid Pro"
  },
  "landing.pricing.subtitle": {
    fr: "Débloquez toutes les fonctionnalités avancées pour vos projets professionnels",
    en: "Unlock all advanced features for your professional projects"
  },
  "landing.pricing.versionPro": {
    fr: "Version Pro",
    en: "Pro Version"
  },
  "landing.pricing.allFeatures": {
    fr: "Toutes les fonctionnalités avancées",
    en: "All advanced features"
  },
  "landing.pricing.fullSynoptic": {
    fr: "Interface Synoptique complète",
    en: "Complete Synoptic interface"
  },
  "landing.pricing.unlimitedMultiGrid": {
    fr: "MultiGrid sans limites",
    en: "Unlimited MultiGrid"
  },
  "landing.header.synoptic": {
    fr: "Synoptique",
    en: "Synoptic"
  },
  "landing.header.myAccount": {
    fr: "Mon Compte",
    en: "My Account"
  },
  "landing.footer.subtitle": {
    fr: "LED Test Pattern Generator Pro",
    en: "LED Test Pattern Generator Pro"
  },

  // Landing - Detailed Features
  "landing.detailed.title": {
    fr: "Fonctionnalités Complètes",
    en: "Complete Features"
  },
  "landing.detailed.subtitle": {
    fr: "Tout ce dont vous avez besoin pour vos tests LED professionnels",
    en: "Everything you need for professional LED testing"
  },
  "landing.detailed.freeTitle": {
    fr: "Gratuit - Accès Complet",
    en: "Free - Full Access"
  },
  "landing.detailed.proTitle": {
    fr: "Pro - Fonctionnalités Avancées",
    en: "Pro - Advanced Features"
  },
  "landing.detailed.free": {
    fr: "Gratuit",
    en: "Free"
  },
  "landing.detailed.pro": {
    fr: "Pro",
    en: "Pro"
  },
  "landing.detailed.patterns30": {
    fr: "60+ Mires Standards & Personnalisés",
    en: "60+ Standard & Custom Patterns"
  },
  "landing.detailed.patterns30.desc": {
    fr: "PLUGE, Zone Plate, SMPTE, Crosshatch, Color Bars et bien plus",
    en: "PLUGE, Zone Plate, SMPTE, Crosshatch, Color Bars and more"
  },
  "landing.detailed.ledWall": {
    fr: "Mode LED Wall",
    en: "LED Wall Mode"
  },
  "landing.detailed.ledWall.desc": {
    fr: "Configuration dalle par dalle avec calcul automatique de résolution",
    en: "Panel-by-panel configuration with automatic resolution calculation"
  },
  "landing.detailed.selfTest": {
    fr: "Self-Test Interactif",
    en: "Interactive Self-Test"
  },
  "landing.detailed.selfTest.desc": {
    fr: "Navigation dalle par dalle, mode PCB, mode 'traîné'",
    en: "Panel-by-panel navigation, PCB mode, 'drag' mode"
  },
  "landing.detailed.texts": {
    fr: "Textes Illimités",
    en: "Unlimited Texts"
  },
  "landing.detailed.texts.desc": {
    fr: "22 polices, personnalisation complète (taille, couleur, contour)",
    en: "22 fonts, full customization (size, color, outline)"
  },
  "landing.detailed.logos": {
    fr: "Logos Multiples",
    en: "Multiple Logos"
  },
  "landing.detailed.logos.desc": {
    fr: "Import illimité, contrôle opacité, alignement automatique",
    en: "Unlimited import, opacity control, automatic alignment"
  },
  "landing.detailed.externalDisplay": {
    fr: "Affichage Externe",
    en: "External Display"
  },
  "landing.detailed.externalDisplay.desc": {
    fr: "Multi-écrans natif avec synchronisation temps réel",
    en: "Native multi-screen with real-time sync"
  },
  "landing.detailed.configs": {
    fr: "Configurations",
    en: "Configurations"
  },
  "landing.detailed.configs.desc": {
    fr: "Sauvegarde/chargement local, import/export .visualgrid",
    en: "Local save/load, import/export .visualgrid"
  },
  "landing.detailed.multigrid": {
    fr: "MultiGrid",
    en: "MultiGrid"
  },
  "landing.detailed.multigrid.desc": {
    fr: "Canvas jusqu'à 16K, grilles multiples, drag & drop",
    en: "Canvas up to 16K, multiple grids, drag & drop"
  },
  "landing.detailed.synoptic": {
    fr: "Synoptique",
    en: "Synoptic"
  },
  "landing.detailed.synoptic.desc": {
    fr: "Projets illimités, workflow complet, export PDF/SVG",
    en: "Unlimited projects, complete workflow, PDF/SVG export"
  },
  "landing.detailed.sharedSessions": {
    fr: "Sessions Partagées",
    en: "Shared Sessions"
  },
  "landing.detailed.sharedSessions.desc": {
    fr: "Contrôle distant avec votre téléphone ou tablette, collaboration temps réel, multi-dispositifs",
    en: "Remote control with your phone or tablet, real-time collaboration, multi-device"
  },
  "landing.detailed.support": {
    fr: "Support Prioritaire",
    en: "Priority Support"
  },
  "landing.detailed.support.desc": {
    fr: "Assistance dédiée et mises à jour anticipées",
    en: "Dedicated assistance and early updates"
  },
  "landing.detailed.stats.patterns": {
    fr: "Mires Standards",
    en: "Standard Patterns"
  },
  "landing.detailed.stats.resolution": {
    fr: "Résolution Max",
    en: "Max Resolution"
  },
  "landing.detailed.stats.support": {
    fr: "Support",
    en: "Support"
  },
  "landing.detailed.stats.download": {
    fr: "Téléchargement gratuit",
    en: "Free download"
  },
  "landing.detailed.stats.proMonth": {
    fr: "Pro/6 Mois",
    en: "Pro/6 Months"
  },

  // Landing - Comparison
  "landing.comparison.title": {
    fr: "Comparaison Détaillée",
    en: "Detailed Comparison"
  },
  "landing.comparison.subtitle": {
    fr: "Choisissez le plan qui correspond à vos besoins",
    en: "Choose the plan that fits your needs"
  },
  "landing.comparison.exclusive": {
    fr: "Exclusif",
    en: "Exclusive"
  },
  "landing.comparison.tryFree": {
    fr: "Essayer Gratuitement",
    en: "Try Free"
  },
  "landing.comparison.noCard": {
    fr: "Aucune carte requise",
    en: "No card required"
  },
  "landing.comparison.upgradePro": {
    fr: "Passer en Pro",
    en: "Upgrade to Pro"
  },
  "landing.comparison.cancelAnytime": {
    fr: "Annulation à tout moment",
    en: "Cancel anytime"
  },

  // Grid - Pattern Generator
  "landing.comparison.grid.category": {
    fr: "Grid - Générateur de Mires",
    en: "Grid - Pattern Generator"
  },
  "landing.comparison.grid.patterns": {
    fr: "30+ Mires Standards",
    en: "30+ Standard Patterns"
  },
  "landing.comparison.grid.custom": {
    fr: "13 Motifs Personnalisés",
    en: "13 Custom Patterns"
  },
  "landing.comparison.grid.ledWall": {
    fr: "Mode LED Wall",
    en: "LED Wall Mode"
  },
  "landing.comparison.grid.selfTest": {
    fr: "Self-Test Interactif",
    en: "Interactive Self-Test"
  },
  "landing.comparison.grid.textsLogos": {
    fr: "Textes & Logos Illimités",
    en: "Unlimited Texts & Logos"
  },
  "landing.comparison.grid.sharedSessions": {
    fr: "Sessions Partagées Cloud",
    en: "Cloud Shared Sessions"
  },

  // Display & Export
  "landing.comparison.display.category": {
    fr: "Affichage & Export",
    en: "Display & Export"
  },
  "landing.comparison.display.external": {
    fr: "Affichage Externe",
    en: "External Display"
  },
  "landing.comparison.display.fullscreen": {
    fr: "Mode Plein Écran",
    en: "Fullscreen Mode"
  },
  "landing.comparison.display.hdExport": {
    fr: "Export HD Multi-Grilles",
    en: "HD Multi-Grid Export"
  },

  // MultiGrid
  "landing.comparison.multigrid.category": {
    fr: "MultiGrid",
    en: "MultiGrid"
  },
  "landing.comparison.multigrid.canvas": {
    fr: "Canvas jusqu'à 16K",
    en: "Canvas up to 16K"
  },
  "landing.comparison.multigrid.multiple": {
    fr: "Grilles Multiples",
    en: "Multiple Grids"
  },
  "landing.comparison.multigrid.animated": {
    fr: "Grilles animées illimitées",
    en: "Unlimited animated Grids"
  },
  "landing.comparison.multigrid.resolution": {
    fr: "Résolution de dalle personnalisée",
    en: "Custom panel resolution"
  },
  "landing.comparison.multigrid.export": {
    fr: "Export Grilles Individuelles",
    en: "Individual Grid Export"
  },

  // Synoptic
  "landing.comparison.synoptic.category": {
    fr: "Synoptique",
    en: "Synoptic"
  },
  "landing.comparison.synoptic.projects": {
    fr: "Projets Illimités",
    en: "Unlimited Projects"
  },
  "landing.comparison.synoptic.workflow": {
    fr: "Workflow Complet",
    en: "Complete Workflow"
  },
  "landing.comparison.synoptic.novastar": {
    fr: "Configuration automatique Novastar",
    en: "Novastar automatic configuration"
  },
  "landing.comparison.synoptic.export": {
    fr: "Export PDF/SVG",
    en: "PDF/SVG Export"
  },
  "landing.comparison.synoptic.library": {
    fr: "Bibliothèque de processeurs LED",
    en: "LED processors library"
  },
  "landing.comparison.synoptic.redundancy": {
    fr: "Systeme de redondance",
    en: "Redundancy system"
  },

  // Collaboration & Support
  "landing.comparison.collaboration.category": {
    fr: "Collaboration & Support",
    en: "Collaboration & Support"
  },
  "landing.comparison.collaboration.remote": {
    fr: "Contrôle à Distance",
    en: "Remote Control"
  },
  "landing.comparison.collaboration.support": {
    fr: "Support Prioritaire",
    en: "Priority Support"
  },
  "landing.comparison.collaboration.beta": {
    fr: "Accès Bêta Anticipé",
    en: "Early Beta Access"
  },

  // ========== PAYWALL ==========
  "paywall.pleaseConnect": {
    fr: "Veuillez vous connecter pour passer en Pro",
    en: "Please sign in to upgrade to Pro"
  },
  "paywall.paymentServiceNotConfigured": {
    fr: "Service de paiement non configuré. Contactez le support.",
    en: "Payment service not configured. Contact support."
  },
  "paywall.proFeature": {
    fr: "Fonctionnalité Pro",
    en: "Pro Feature"
  },
  "paywall.upgradeTitle": {
    fr: "Passez à VisualGrid Pro",
    en: "Upgrade to VisualGrid Pro"
  },
  "paywall.unlockFeatures": {
    fr: "Débloquez toutes les fonctionnalités avancées",
    en: "Unlock all advanced features"
  },
  "paywall.fullSynoptic": {
    fr: "Accès complet au Synoptique avancé",
    en: "Full access to advanced Synoptic"
  },
  "paywall.multiGridExternal": {
    fr: "Multi-grilles et affichage externe",
    en: "Multi-grids and external display"
  },
  "paywall.unlimitedSharedSessions": {
    fr: "Sessions partagées illimitées",
    en: "Unlimited shared sessions"
  },
  "paywall.highResExports": {
    fr: "Exports haute résolution",
    en: "High resolution exports"
  },
  "paywall.prioritySupport": {
    fr: "Support prioritaire",
    en: "Priority support"
  },
  "paywall.earlyAccess": {
    fr: "Mises à jour anticipées",
    en: "Early access updates"
  },
  "paywall.perMonth": {
    fr: "Tous les 6 mois",
    en: "Every 6 months"
  },
  "paywall.cancelAnytime": {
    fr: "Annulez à tout moment • Pas d'engagement",
    en: "Cancel anytime • No commitment"
  },
  "paywall.upgradeNow": {
    fr: "Passer en Pro Maintenant",
    en: "Upgrade to Pro Now"
  },
  "paywall.securePayment": {
    fr: "Paiement sécurisé par Stripe • Satisfait ou remboursé 14 jours",
    en: "Secure payment by Stripe • 14-day money-back guarantee"
  },
  "paywall.upgradeError": {
    fr: "Erreur lors de la création de la session de paiement",
    en: "Error creating payment session"
  },
  "paywall.loading": {
    fr: "Chargement...",
    en: "Loading..."
  },

  // ========== PRO PAGE ==========
  "pro.signInToUpgrade": {
    fr: "Connectez-vous pour passer en Pro",
    en: "Sign in to upgrade to Pro"
  },
  "pro.paymentNotConfigured": {
    fr: "Service de paiement non configuré",
    en: "Payment service not configured"
  },
  "pro.sessionExpired": {
    fr: "Session expirée",
    en: "Session expired"
  },
  "pro.visualgridTitle": {
    fr: "VISUALGRID",
    en: "VISUALGRID"
  },
  "pro.professional": {
    fr: "PROFESSIONNEL",
    en: "PROFESSIONAL"
  },
  "pro.unlockPower": {
    fr: "Débloquez la puissance complète de VisualGrid avec des fonctionnalités avancées pour vos projets professionnels.",
    en: "Unlock the full power of VisualGrid with advanced features for your professional projects."
  },
  "pro.securePaymentCancel": {
    fr: "Paiement sécurisé • Annulation à tout moment",
    en: "Secure payment • Cancel anytime"
  },
  "pro.alreadySubscribed": {
    fr: "DÉJÀ ABONNÉ",
    en: "ALREADY SUBSCRIBED"
  },
  "pro.upgradeToPro": {
    fr: "PASSER EN PRO",
    en: "UPGRADE TO PRO"
  },
  "pro.loading": {
    fr: "CHARGEMENT...",
    en: "LOADING..."
  },
  "pro.features": {
    fr: "FONCTIONNALITÉS",
    en: "FEATURES"
  },
  "pro.everythingYouNeed": {
    fr: "Tout ce dont vous avez besoin pour réussir",
    en: "Everything you need to succeed"
  },
  "pro.professionalSynoptic": {
    fr: "Synoptique Professionnel",
    en: "Professional Synoptic"
  },
  "pro.professionalSynopticDesc": {
    fr: "Projets illimités, workflow complet, export PDF/SVG, bibliothèque de processeurs LED",
    en: "Unlimited projects, complete workflow, PDF/SVG export, LED processors library"
  },
  "pro.advancedMultigrid": {
    fr: "MultiGrid Avancé",
    en: "Advanced MultiGrid"
  },
  "pro.advancedMultigridDesc": {
    fr: "Canvas jusqu'à 16K, grilles multiples animées, résolution de dalle personnalisée, export individuel des grilles",
    en: "Canvas up to 16K, multiple animated grids, custom panel resolution, individual grid export"
  },
  "pro.cloudSharedSessions": {
    fr: "Sessions Partagées Cloud",
    en: "Cloud Shared Sessions"
  },
  "pro.cloudSharedSessionsDesc": {
    fr: "Contrôle à distance avec votre téléphone ou tablette, collaboration temps réel, synchronisation multi-dispositifs",
    en: "Remote control with your phone or tablet, real-time collaboration, multi-device synchronization"
  },
  "pro.hdMultigridExport": {
    fr: "Export HD Multi-Grilles",
    en: "HD Multi-Grid Export"
  },
  "pro.hdMultigridExportDesc": {
    fr: "Exports en ultra haute résolution jusqu'à 16K pour tous vos projets MultiGrid et Synoptique",
    en: "Ultra high resolution exports up to 16K for all your MultiGrid and Synoptic projects"
  },
  "pro.remoteControl": {
    fr: "Contrôle à Distance",
    en: "Remote Control"
  },
  "pro.remoteControlDesc": {
    fr: "Pilotez vos grilles depuis n'importe quel appareil avec synchronisation instantanée",
    en: "Control your grids from any device with instant synchronization"
  },
  "pro.prioritySupport": {
    fr: "Support Prioritaire",
    en: "Priority Support"
  },
  "pro.prioritySupportDesc": {
    fr: "Assistance dédiée, mises à jour anticipées et accès bêta aux nouvelles fonctionnalités",
    en: "Dedicated assistance, early updates and beta access to new features"
  },
  "pro.readyToStart": {
    fr: "PRÊT À COMMENCER ?",
    en: "READY TO START?"
  },
  "pro.allFeaturesUnlocked": {
    fr: "Toutes les fonctionnalités débloquées",
    en: "All features unlocked"
  },
  "pro.unlimitedSessionsExports": {
    fr: "Sessions et exports illimités",
    en: "Unlimited sessions and exports"
  },
  "pro.prioritySupport247": {
    fr: "Support prioritaire 24/7",
    en: "24/7 priority support"
  },
  "pro.cancelAnytime": {
    fr: "Annulation à tout moment",
    en: "Cancel anytime"
  },
  "pro.startNow": {
    fr: "COMMENCER MAINTENANT",
    en: "START NOW"
  },
  "pro.manageSubscription": {
    fr: "GÉRER MON ABONNEMENT",
    en: "MANAGE MY SUBSCRIPTION"
  },
  "pro.securePaymentNoCommitment": {
    fr: "Paiement sécurisé • Sans engagement",
    en: "Secure payment • No commitment"
  },
  "pro.upgradeError": {
    fr: "Erreur lors du passage en Pro",
    en: "Error upgrading to Pro"
  },
  "pro.backButton": {
    fr: "Retour",
    en: "Back"
  },

  // ========== SESSIONS ==========
  "sessions.proReserved": {
    fr: "Les sessions partagées sont réservées aux utilisateurs PRO",
    en: "Shared sessions are reserved for PRO users"
  },
  "sessions.proRequired": {
    fr: "Accès Pro requis",
    en: "Pro access required"
  },
  "sessions.proFeature": {
    fr: "Fonctionnalité PRO",
    en: "PRO Feature"
  },
  "sessions.proFeatureDesc": {
    fr: "Les sessions partagées sont réservées aux utilisateurs PRO",
    en: "Shared sessions are reserved for PRO users"
  },
  "sessions.proFeatureAllows": {
    fr: "Cette fonctionnalité PRO vous permet de :",
    en: "This PRO feature allows you to:"
  },
  "sessions.allowsYouTo": {
    fr: "Être pro c'est aussi :",
    en: "Being pro is also :"
  },
  "sessions.shareRealtime": {
    fr: "Soutenir le développement de VisualGrid",
    en: "Support the development of VisualGrid"
  },
  "sessions.remoteControl": {
    fr: "Contrôler à distance votre mire depuis un téléphone ou tablette",
    en: "Remote control your test pattern from a phone or tablet"
  },
  "sessions.collaborateTeam": {
    fr: "Créez de puissants synoptiques LED",
    en: "Create powerful LED synoptics"
  },
  "sessions.activeSession": {
    fr: "Session Active",
    en: "Active Session"
  },
  "sessions.waiting": {
    fr: "En attente",
    en: "Waiting"
  },
  "sessions.cloudSession": {
    fr: "Session Cloud - Accessible partout",
    en: "Cloud Session - Accessible everywhere"
  },
  "sessions.sessionCode": {
    fr: "Code de Session",
    en: "Session Code"
  },
  "sessions.copyCode": {
    fr: "Copier le Code",
    en: "Copy Code"
  },
  "sessions.connectedDevices": {
    fr: "Appareils connectés",
    en: "Connected devices"
  },
  "sessions.you": {
    fr: "vous",
    en: "you"
  },
  "sessions.server": {
    fr: "🖥️ Server",
    en: "🖥️ Server"
  },
  "sessions.remote": {
    fr: "📱 Remote",
    en: "📱 Remote"
  },
  "sessions.waitingRemote": {
    fr: "En attente de connexion remote...",
    en: "Waiting for remote connection..."
  },
  "sessions.shareCodeToConnect": {
    fr: "Partagez le code pour connecter un appareil",
    en: "Share the code to connect a device"
  },
  "sessions.shareSessionCode": {
    fr: "📤 Partager le Code de Session",
    en: "📤 Share Session Code"
  },
  "sessions.endSession": {
    fr: "🔴 TERMINER LA SESSION",
    en: "🔴 END SESSION"
  },
  "sessions.disconnect": {
    fr: "🚪 SE DÉCONNECTER",
    en: "🚪 DISCONNECT"
  },
  "sessions.endWarning": {
    fr: "⚠️ Attention : Terminer la session déconnectera tous les appareils connectés.",
    en: "⚠️ Warning: Ending the session will disconnect all connected devices."
  },
  "sessions.disconnectInfo": {
    fr: "ℹ️ Info : Vous déconnecter de cette session partagée.",
    en: "ℹ️ Info: You will disconnect from this shared session."
  },
  "sessions.detectingDevice": {
    fr: "Détection de l'appareil...",
    en: "Detecting device..."
  },
  "sessions.createCloudSession": {
    fr: "Créer une Session Cloud",
    en: "Create Cloud Session"
  },
  "sessions.createSessionDesc": {
    fr: "Contrôlez VisualGrid depuis n'importe quel appareil, affichez votre mire ici !",
    en: "Control VisualGrid from any device, display your pattern here!"
  },
  "sessions.creating": {
    fr: "Création en cours...",
    en: "Creating..."
  },
  "sessions.createSession": {
    fr: "Créer une Session",
    en: "Create Session"
  },
  "sessions.controlSession": {
    fr: "Contrôler une Session",
    en: "Control a Session"
  },
  "sessions.controlSessionDesc": {
    fr: "Saisissez le code pour contrôler VisualGrid à distance",
    en: "Enter the code to control VisualGrid remotely"
  },
  "sessions.sessionCodeLabel": {
    fr: "Code de session",
    en: "Session code"
  },
  "sessions.sessionCodePlaceholder": {
    fr: "Ex: ABC123",
    en: "Ex: ABC123"
  },
  "sessions.join": {
    fr: "Rejoindre",
    en: "Join"
  },
  "sessions.remoteConnected": {
    fr: "remote(s)",
    en: "remote(s)"
  },
  "sessions.remoteJoined": {
    fr: "connecté comme remote",
    en: "connected as remote"
  },
  "sessions.remoteDisconnected": {
    fr: "Remote déconnectée",
    en: "Remote disconnected"
  },
  "sessions.sessionCreated": {
    fr: "créée !",
    en: "created!"
  },
  "sessions.connectedTo": {
    fr: "Connecté à la session",
    en: "Connected to session"
  },
  "sessions.deviceConnected": {
    fr: "Appareil déconnecté",
    en: "Device disconnected"
  },
  "sessions.sessionTerminated": {
    fr: "Session terminée par le serveur",
    en: "Session terminated by server"
  },
  "sessions.connectionLost": {
    fr: "Connexion perdue",
    en: "Connection lost"
  },
  "sessions.enterSessionCode": {
    fr: "Veuillez saisir un code de session",
    en: "Please enter a session code"
  },
  "sessions.codeCopied": {
    fr: "Code copié dans le presse-papier",
    en: "Code copied to clipboard"
  },
  "sessions.linkCopied": {
    fr: "Lien de session copié",
    en: "Session link copied"
  },

  // ========== SYNOPTIQUE ==========
  "synoptic.projectName": {
    fr: "Nom du projet",
    en: "Project name"
  },
  "synoptic.patternName": {
    fr: "Nom de la mire (optionnel)",
    en: "Pattern name (optional)"
  },
  "synoptic.patternNotCaptured": {
    fr: "Image de la mire non capturée",
    en: "Pattern image not captured"
  },
  "synoptic.clickToOpenEquipment": {
    fr: "Cliquer pour ouvrir le panneau équipements",
    en: "Click to open equipment panel"
  },
  "synoptic.clickToHideLeft": {
    fr: "Cliquer pour masquer le panneau gauche",
    en: "Click to hide left panel"
  },
  "synoptic.patternConfigDetected": {
    fr: "Configuration de mire détectée !",
    en: "Pattern configuration detected!"
  },
  "synoptic.patternImported": {
    fr: "Mire importée !",
    en: "Pattern imported!"
  },
  "synoptic.noPanelTypeAvailable": {
    fr: "Aucun type de panneau disponible",
    en: "No panel type available"
  },
  "synoptic.converting": {
    fr: "Conversion en cours...",
    en: "Converting..."
  },
  "synoptic.patternConverted": {
    fr: "Mire convertie !",
    en: "Pattern converted!"
  },
  "synoptic.noPanelFound": {
    fr: "Aucun panneau correspondant trouvé",
    en: "No matching panel found"
  },
  "synoptic.noNovastarProcessor": {
    fr: "Aucun processeur Novastar détecté",
    en: "No Novastar processor detected"
  },
  "synoptic.pagesCopied": {
    fr: "Pages copiées !",
    en: "Pages copied!"
  },
  "synoptic.alreadyConnected": {
    fr: "Ce panneau est déjà connecté à ce port",
    en: "This panel is already connected to this port"
  },
  "synoptic.groupIndivisible": {
    fr: "Groupe indissociable",
    en: "Indivisible group"
  },

  // ========== SYNOPTIC SHARE ==========
  "synoptic.share": {
    fr: "Partager",
    en: "Share"
  },
  "synoptic.share.title": {
    fr: "Partager le projet",
    en: "Share project"
  },
  "synoptic.share.description": {
    fr: "Rendez votre projet accessible en consultation via un lien de partage unique.",
    en: "Make your project viewable via a unique share link."
  },
  "synoptic.share.private": {
    fr: "Privé",
    en: "Private"
  },
  "synoptic.share.public": {
    fr: "Public",
    en: "Public"
  },
  "synoptic.share.privateDesc": {
    fr: "Seul vous pouvez accéder à ce projet.",
    en: "Only you can access this project."
  },
  "synoptic.share.publicDesc": {
    fr: "Toute personne disposant du lien peut consulter ce projet.",
    en: "Anyone with the link can view this project."
  },
  "synoptic.share.copyLink": {
    fr: "Copier le lien",
    en: "Copy link"
  },
  "synoptic.share.linkCopied": {
    fr: "Lien copié !",
    en: "Link copied!"
  },
  "synoptic.share.linkCopiedDesc": {
    fr: "Le lien de partage a été copié dans le presse-papiers.",
    en: "The share link has been copied to clipboard."
  },
  "synoptic.share.toggleError": {
    fr: "Erreur lors du changement de visibilité",
    en: "Error changing visibility"
  },
  "synoptic.share.mustBeSaved": {
    fr: "Le projet doit être sauvegardé avant de pouvoir être partagé.",
    en: "The project must be saved before it can be shared."
  },
  "synoptic.share.readOnlyBanner": {
    fr: "Mode consultation",
    en: "View only"
  },
  "synoptic.share.readOnlyDesc": {
    fr: "Vous consultez un projet partagé par {author}. Aucune modification possible.",
    en: "You are viewing a project shared by {author}. No modifications allowed."
  },
  "synoptic.share.projectNotFound": {
    fr: "Projet introuvable",
    en: "Project not found"
  },
  "synoptic.share.projectNotFoundDesc": {
    fr: "Ce lien de partage n'existe pas ou le projet n'est plus public.",
    en: "This share link does not exist or the project is no longer public."
  },
  "synoptic.share.loading": {
    fr: "Chargement du projet partagé...",
    en: "Loading shared project..."
  },
  "synoptic.share.openInApp": {
    fr: "Ouvrir dans VisualGrid",
    en: "Open in VisualGrid"
  },
  "synoptic.share.madePublic": {
    fr: "Projet rendu public",
    en: "Project made public"
  },
  "synoptic.share.madePrivate": {
    fr: "Projet rendu privé",
    en: "Project made private"
  },
  "synoptic.share.viewOnly": {
    fr: "Consultation uniquement",
    en: "View only"
  },
  "synoptic.share.mireDisabled": {
    fr: "L'étape Mire n'est pas disponible en mode consultation",
    en: "The Mire step is not available in view-only mode"
  },
  "synoptic.share.readOnlySidebar": {
    fr: "Consultation uniquement — L'ajout d'éléments est désactivé",
    en: "View only — Adding elements is disabled"
  },
  "synoptic.share.readOnlyExport": {
    fr: "Les informations du projet ne sont pas modifiables en mode consultation",
    en: "Project information is not editable in view-only mode"
  },
  "synoptic.share.readOnlyPages": {
    fr: "L'ajout de pages est désactivé en mode consultation",
    en: "Adding pages is disabled in view-only mode"
  },
  "synoptic.share.readOnlyCopy": {
    fr: "La copie d'éléments est désactivée en mode consultation",
    en: "Copying elements is disabled in view-only mode"
  },
  "synoptic.share.readOnlyCabling": {
    fr: "La modification des câblages est désactivée en mode consultation",
    en: "Cabling modifications are disabled in view-only mode"
  },
  "synoptic.viewer.noPages": {
    fr: "Aucune page à afficher",
    en: "No page to display"
  },
  "synoptic.viewer.renderError": {
    fr: "Impossible de générer l'aperçu de cette page",
    en: "Could not render this page preview"
  },

  // ========== SYNOPTIC PROPERTIES PANEL ==========
  "synoptic.properties": {
    fr: "Propriétés",
    en: "Properties"
  },
  "synoptic.properties.noSelection": {
    fr: "Aucun élément sélectionné",
    en: "No element selected"
  },
  "synoptic.properties.processor": {
    fr: "Processeur",
    en: "Processor"
  },
  "synoptic.properties.panel": {
    fr: "Panneau",
    en: "Panel"
  },
  "synoptic.properties.cabinet": {
    fr: "Armoire",
    en: "Cabinet"
  },
  "synoptic.properties.mire": {
    fr: "Mire",
    en: "Pattern"
  },
  "synoptic.properties.resolution": {
    fr: "Résolution",
    en: "Resolution"
  },
  "synoptic.properties.panels": {
    fr: "Panneaux",
    en: "Panels"
  },
  "synoptic.properties.dimensions": {
    fr: "Dimensions",
    en: "Dimensions"
  },
  "synoptic.properties.pixelPitch": {
    fr: "Pitch pixel",
    en: "Pixel pitch"
  },
  "synoptic.properties.brightness": {
    fr: "Luminosité",
    en: "Brightness"
  },
  "synoptic.properties.power": {
    fr: "Consommation",
    en: "Power"
  },
  "synoptic.properties.totalPower": {
    fr: "Consommation totale",
    en: "Total power"
  },
  "synoptic.properties.ports": {
    fr: "Ports",
    en: "Ports"
  },
  "synoptic.properties.outlets": {
    fr: "Prises",
    en: "Outlets"
  },
  "synoptic.properties.panelType": {
    fr: "Type de panneau",
    en: "Panel type"
  },
  "synoptic.properties.dragPanelHint": {
    fr: "Glissez un panneau ici pour définir le type",
    en: "Drag a panel here to set the type"
  },
  "synoptic.properties.group": {
    fr: "Groupe",
    en: "Group"
  },
  "synoptic.properties.createGroup": {
    fr: "Créer un groupe",
    en: "Create group"
  },
  "synoptic.properties.ungroupElements": {
    fr: "Dissocier le groupe",
    en: "Ungroup elements"
  },
  "synoptic.properties.opacity": {
    fr: "Opacité",
    en: "Opacity"
  },
  "synoptic.properties.position": {
    fr: "Position",
    en: "Position"
  },
  "synoptic.properties.size": {
    fr: "Taille",
    en: "Size"
  },

  // ========== PROJECT STATISTICS ==========
  "synoptic.stats.title": {
    fr: "Statistiques du projet",
    en: "Project Statistics"
  },
  "synoptic.stats.totalPanels": {
    fr: "Panneaux :",
    en: "Total panels :"
  },
  "synoptic.stats.dataCables": {
    fr: "Câbles Data",
    en: "Data cables"
  },
  "synoptic.stats.dataLinks": {
    fr: "Câbles Data",
    en: "Data cables"
  },
  "synoptic.stats.firstData": {
    fr: "First Data",
    en: "First Data"
  },
  "synoptic.stats.firstPower": {
    fr: "First Power",
    en: "First Power"
  },
  "synoptic.stats.powerCables": {
    fr: "Câbles Power",
    en: "Power cables"
  },
  "synoptic.stats.processors": {
    fr: "Processeurs",
    en: "Processors"
  },
  "synoptic.stats.cabinets": {
    fr: "Armoires",
    en: "Cabinets"
  },

  // ========== TOASTS / MESSAGES ==========
  "toast.error": {
    fr: "Erreur",
    en: "Error"
  },
  "toast.success": {
    fr: "Succès",
    en: "Success"
  },
  "toast.info": {
    fr: "Information",
    en: "Information"
  },
  "toast.warning": {
    fr: "Attention",
    en: "Warning"
  },

  // ========== SELF-TEST MODULE ==========
  "selfTest.title": {
    fr: "Module Self-Test",
    en: "Self-Test Module"
  },
  "selfTest.description": {
    fr: "Test individuel des panneaux LED avec navigation interactive",
    en: "Individual LED panel testing with interactive navigation"
  },
  "selfTest.positionX": {
    fr: "Position X (Longueur)",
    en: "Position X (Length)"
  },
  "selfTest.positionY": {
    fr: "Position Y (Largeur)",
    en: "Position Y (Width)"
  },
  "selfTest.dragMode": {
    fr: "Mode \"Traîné\"",
    en: "Drag Mode"
  },
  "selfTest.showOutlines": {
    fr: "Afficher les contours",
    en: "Show Outlines"
  },
  "selfTest.pcbMode": {
    fr: "Mode PCB (subdivision)",
    en: "PCB Mode (subdivision)"
  },
  "selfTest.pcbModeDesc": {
    fr: "Divise les panneaux cyan en 4 zones",
    en: "Divides cyan panels into 4 zones"
  },
  "selfTest.turnOffAll": {
    fr: "Éteindre tous",
    en: "Turn Off All"
  },
  "selfTest.turnOnAll": {
    fr: "Allumer tous",
    en: "Turn On All"
  },
  "selfTest.keyboardNavTip": {
    fr: "💡 Utilisez les flèches du clavier en mode plein écran pour naviguer entre les panneaux",
    en: "💡 Use keyboard arrows in fullscreen mode to navigate between panels"
  },
  "selfTest.clickPanelTip": {
    fr: "🖱️ Cliquez directement sur un panneau dans l'aperçu pour le sélectionner",
    en: "🖱️ Click directly on a panel in the preview to select it"
  },
  "selfTest.spaceTip": {
    fr: "🎨 Appuyez sur Espace pour activer/désactiver le panneau en cyan",
    en: "🎨 Press Space to toggle the panel in cyan"
  },
  "selfTest.enterTip": {
    fr: "⌨️ Appuyez sur Entrée pour activer le mode PCB automatiquement",
    en: "⌨️ Press Enter to activate PCB mode automatically"
  },
  "selfTest.subdivisionTip": {
    fr: "🔴 Appuyez sur Entrée pour marquer un quadrant en rouge (PCB défaillant)",
    en: "🔴 Press Enter to mark a quadrant in red (faulty PCB)"
  },

  // ========== ACTIONS GÉNÉRALES ==========
  "action.save": {
    fr: "Sauvegarder",
    en: "Save"
  },
  "action.load": {
    fr: "Charger",
    en: "Load"
  },
  "action.export": {
    fr: "Exporter",
    en: "Export"
  },
  "action.import": {
    fr: "Importer",
    en: "Import"
  },
  "action.exportPNG": {
    fr: "Exporter PNG",
    en: "Export PNG"
  },
  "action.exportVisualGrid": {
    fr: "Exporter .visualgrid",
    en: "Export .visualgrid"
  },
  "action.importVisualGrid": {
    fr: "Importer .visualgrid",
    en: "Import .visualgrid"
  },

  "synoptic.a3Delimitation": {
    fr: "Délimitation A3",
    en: "A3 Delimitation"
  },
  "synoptic.exportCartridge": {
    fr: "Cartouche d'export",
    en: "Export Cartridge"
  },
  "synoptic.customizeCartridge": {
    fr: "Personnalisez les informations du cartouche en bas de page",
    en: "Customize cartridge information at the bottom of the page"
  },
  "synoptic.agency": {
    fr: "Agence/Client",
    en: "Agency/Client"
  },
  "synoptic.agencyName": {
    fr: "Nom agence",
    en: "Agency name"
  },
  "synoptic.client": {
    fr: "Client",
    en: "Client"
  },
  "synoptic.clientName": {
    fr: "Nom client",
    en: "Client name"
  },
  "synoptic.event": {
    fr: "Événement",
    en: "Event"
  },
  "synoptic.eventName": {
    fr: "Nom de l'événement",
    en: "Event name"
  },
  "synoptic.location": {
    fr: "Lieu",
    en: "Location"
  },
  "synoptic.suite": {
    fr: "Suite",
    en: "Suite"
  },
  "synoptic.what": {
    fr: "Quoi",
    en: "What"
  },
  "synoptic.description": {
    fr: "Description",
    en: "Description"
  },
  "synoptic.legend": {
    fr: "Légende synoptique",
    en: "Synoptic legend"
  },
  "synoptic.legendShort": {
    fr: "Légende",
    en: "Legend"
  },
  "synoptic.date": {
    fr: "Date",
    en: "Date"
  },
  "synoptic.from": {
    fr: "De",
    en: "From"
  },
  "synoptic.name": {
    fr: "Nom",
    en: "Name"
  },
  "synoptic.exportPDF": {
    fr: "Exporter en PDF",
    en: "Export as PDF"
  },
  "synoptic.exportSVG": {
    fr: "Exporter en SVG",
    en: "Export as SVG"
  },
  "workspace.empty": {
    fr: "Workspace vide",
    en: "Empty Workspace"
  },
  "workspace.startAddingProcessors": {
    fr: "Commencez par ajouter des processeurs depuis le panel de gauche",
    en: "Start by adding processors from the left panel"
  },

  // ========== AUTH COMPONENTS ==========
  "authButton.myAccount": {
    fr: "Mon Compte",
    en: "My Account"
  },
  "authButton.signIn": {
    fr: "Se connecter",
    en: "Sign In"
  },
  "authButton.loading": {
    fr: "Chargement...",
    en: "Loading..."
  },

  // ========== GOOGLE SIGN IN ==========
  "googleSignIn.continueWith": {
    fr: "Continuer avec Google",
    en: "Continue with Google"
  },
  "googleSignIn.signingIn": {
    fr: "Connexion en cours...",
    en: "Signing in..."
  },

  // ========== REQUIRE AUTH ==========
  "requireAuth.loading": {
    fr: "Chargement...",
    en: "Loading..."
  },

  // ========== REQUIRE PRO ==========
  "requirePro.checkingSubscription": {
    fr: "Vérification de votre abonnement...",
    en: "Checking your subscription..."
  },
  "requirePro.proFeature": {
    fr: "Fonctionnalité Pro",
    en: "Pro Feature"
  },
  "requirePro.signInToAccess": {
    fr: "Connectez-vous pour accéder aux fonctionnalités avancées.",
    en: "Sign in to access advanced features."
  },
  "requirePro.graceModeActive": {
    fr: "Mode Grâce Activé",
    en: "Grace Mode Active"
  },
  "requirePro.graceModeDesc": {
    fr: "Vous utilisez les fonctionnalités Pro en mode hors ligne. Reconnectez-vous pour synchroniser votre abonnement.",
    en: "You are using Pro features in offline mode. Reconnect to sync your subscription."
  },

  // ========== SYNOPTIC PROJECTS ==========
  "synoptic.projects.title": {
    fr: "Mes Synoptiques",
    en: "My Synoptics"
  },
  "synoptic.projects.description": {
    fr: "Sélectionnez un projet existant ou créez-en un nouveau",
    en: "Select an existing project or create a new one"
  },
  "synoptic.projects.myProjects": {
    fr: "Mes projets",
    en: "My projects"
  },
  "synoptic.projects.search": {
    fr: "Rechercher un projet...",
    en: "Search for a project..."
  },
  "synoptic.projects.creating": {
    fr: "Création...",
    en: "Creating..."
  },
  "synoptic.projects.newProject": {
    fr: "Nouveau projet",
    en: "New project"
  },
  "synoptic.projects.createFirst": {
    fr: "Créer mon premier projet",
    en: "Create my first project"
  },
  "synoptic.projects.noProjects": {
    fr: "Aucun projet",
    en: "No projects"
  },
  "synoptic.projects.noProjectsFound": {
    fr: "Aucun projet trouvé",
    en: "No projects found"
  },
  "synoptic.projects.tryAnotherSearch": {
    fr: "Essayez une autre recherche ou créez un nouveau projet",
    en: "Try another search or create a new project"
  },
  "synoptic.projects.createFirstSynoptic": {
    fr: "Créez votre premier synoptique pour commencer",
    en: "Create your first synoptic to get started"
  },
  "synoptic.projects.deleteConfirm": {
    fr: "Êtes-vous sûr de vouloir supprimer le projet \"{name}\" ?\\n\\nCette action est irréversible.",
    en: "Are you sure you want to delete the project \"{name}\"?\\n\\nThis action is irreversible."
  },

  // Project card
  "synoptic.card.open": {
    fr: "Ouvrir",
    en: "Open"
  },
  "synoptic.card.modified": {
    fr: "Modifié",
    en: "Modified"
  },
  "synoptic.card.actions": {
    fr: "Actions",
    en: "Actions"
  },
  "synoptic.card.rename": {
    fr: "Renommer",
    en: "Rename"
  },
  "synoptic.card.duplicate": {
    fr: "Dupliquer",
    en: "Duplicate"
  },
  "synoptic.card.delete": {
    fr: "Supprimer",
    en: "Delete"
  },
  "synoptic.card.copy": {
    fr: "copie",
    en: "copy"
  },

  // Time relative
  "time.now": {
    fr: "à l'instant",
    en: "just now"
  },
  "time.minutesAgo": {
    fr: "il y a {n}min",
    en: "{n}min ago"
  },
  "time.hoursAgo": {
    fr: "il y a {n}h",
    en: "{n}h ago"
  },
  "time.daysAgo": {
    fr: "il y a {n}j",
    en: "{n}d ago"
  },

  // Project welcome
  "synoptic.welcome.title": {
    fr: "Bienvenue dans l'Interface Synoptique",
    en: "Welcome to the Synoptic Interface"
  },
  "synoptic.welcome.subtitle": {
    fr: "Créez un nouveau projet ou ouvrez un projet existant pour commencer",
    en: "Create a new project or open an existing one to get started"
  },
  "synoptic.welcome.newProject": {
    fr: "Nouveau Projet",
    en: "New Project"
  },
  "synoptic.welcome.newProjectDesc": {
    fr: "Démarrez un nouveau synoptique LED de zéro",
    en: "Start a new LED synoptic from scratch"
  },
  "synoptic.welcome.myProjects": {
    fr: "Mes Projets",
    en: "My Projects"
  },
  "synoptic.welcome.projectsAvailable": {
    fr: "{count} projet{plural} disponible{plural}",
    en: "{count} project{plural} available"
  },
  "synoptic.welcome.noProjectsYet": {
    fr: "Aucun projet pour le moment",
    en: "No projects yet"
  },
  "synoptic.welcome.loadingProjects": {
    fr: "Chargement de vos projets...",
    en: "Loading your projects..."
  },
  "synoptic.welcome.recentProjects": {
    fr: "Projets récents",
    en: "Recent projects"
  },
  "synoptic.welcome.noProjectsCreated": {
    fr: "Aucun projet créé",
    en: "No projects created"
  },
  "synoptic.welcome.createFirstProject": {
    fr: "Créez votre premier projet synoptique pour commencer à concevoir vos installations LED professionnelles",
    en: "Create your first synoptic project to start designing your professional LED installations"
  },

  // Project dialog
  "synoptic.dialog.newProject": {
    fr: "Nouveau Projet Synoptique",
    en: "New Synoptic Project"
  },
  "synoptic.dialog.newProjectDesc": {
    fr: "Donnez un nom à votre nouveau projet. Vous pourrez le modifier plus tard.",
    en: "Give your new project a name. You can change it later."
  },
  "synoptic.dialog.projectName": {
    fr: "Nom du projet",
    en: "Project name"
  },
  "synoptic.dialog.projectNamePlaceholder": {
    fr: "Mon projet synoptique...",
    en: "My synoptic project..."
  },
  "synoptic.dialog.cancel": {
    fr: "Annuler",
    en: "Cancel"
  },
  "synoptic.dialog.create": {
    fr: "Créer le projet",
    en: "Create project"
  },
  "synoptic.dialog.renameProject": {
    fr: "Renommer le projet",
    en: "Rename project"
  },
  "synoptic.dialog.renaming": {
    fr: "Renommage...",
    en: "Renaming..."
  },
  "synoptic.dialog.rename": {
    fr: "Renommer",
    en: "Rename"
  },

  // Save indicator
  "synoptic.save.errorSaving": {
    fr: "Erreur de sauvegarde",
    en: "Save error"
  },
  "synoptic.save.errorDesc": {
    fr: "Vos modifications sont sauvegardées localement",
    en: "Your changes are saved locally"
  },
  "synoptic.save.saving": {
    fr: "Sauvegarde...",
    en: "Saving..."
  },
  "synoptic.save.saved": {
    fr: "Sauvegardé {time}",
    en: "Saved {time}"
  },
  "synoptic.save.lastSave": {
    fr: "Dernière sauvegarde : {time}",
    en: "Last save: {time}"
  },
  "synoptic.save.clickToForce": {
    fr: "Cliquer pour forcer une sauvegarde",
    en: "Click to force save"
  },
  "synoptic.save.notSaved": {
    fr: "Non sauvegardé",
    en: "Not saved"
  },
  "synoptic.save.clickToSave": {
    fr: "Cliquer pour sauvegarder",
    en: "Click to save"
  },
  "synoptic.save.autoSave": {
    fr: "Auto-sauvegarde après 6s d'inactivité",
    en: "Auto-save after 6s of inactivity"
  },
  "synoptic.save": {
    fr: "Sauvegarder",
    en: "Save"
  },
  "synoptic.saveDesc": {
    fr: "Sauvegarder dans le Cloud et le fichier local",
    en: "Save to Cloud and local file"
  },
  "synoptic.saveAs": {
    fr: "Sauvegarder sous...",
    en: "Save As..."
  },
  "synoptic.saveAsDesc": {
    fr: "Sauvegarder sous un nouveau nom",
    en: "Save under a new name"
  },
  "synoptic.saveAsDescription": {
    fr: "Choisissez un nom pour votre projet",
    en: "Choose a name for your project"
  },
  "synoptic.saveAsError": {
    fr: "Erreur lors de la sauvegarde",
    en: "Error saving"
  },
  "synoptic.savedAs": {
    fr: "Projet sauvegardé sous un nouveau nom",
    en: "Project saved under a new name"
  },
  "synoptic.savedToCloud": {
    fr: "Projet sauvegardé dans le Cloud",
    en: "Project saved to Cloud"
  },
  "synoptic.savedToCloudAndFile": {
    fr: "Projet sauvegardé dans le Cloud et le fichier local",
    en: "Project saved to Cloud and local file"
  },
  "synoptic.saveError": {
    fr: "Erreur lors de la sauvegarde",
    en: "Error saving"
  },
  "synoptic.saveLocalFileError": {
    fr: "Erreur lors de la sauvegarde du fichier local",
    en: "Error saving local file"
  },
  "synoptic.loadFromCloud": {
    fr: "Charger depuis le Cloud",
    en: "Load from Cloud"
  },
  "synoptic.loadFromCloudDesc": {
    fr: "Ouvrir un projet cloud existant",
    en: "Open an existing cloud project"
  },
  "synoptic.saveToCloud": {
    fr: "Sauvegarder dans le Cloud",
    en: "Save to Cloud"
  },
  "synoptic.saveToCloudDesc": {
    fr: "Sauvegarder le projet actuel",
    en: "Save current project"
  },
  "synoptic.importFromFile": {
    fr: "Importer un fichier .vgsyn",
    en: "Import a .vgsyn file"
  },
  "synoptic.importFromFileDesc": {
    fr: "Charger depuis un fichier local",
    en: "Load from a local file"
  },
  "synoptic.exportToFile": {
    fr: "Exporter en .vgsyn",
    en: "Export to .vgsyn"
  },
  "synoptic.exportToFileDesc": {
    fr: "Télécharger le projet actuel",
    en: "Download current project"
  },
  "synoptic.exportedToFile": {
    fr: "Synoptique exporté en fichier .vgsyn",
    en: "Synoptic exported to .vgsyn file"
  },
  "synoptic.exportFileError": {
    fr: "Erreur lors de l'export du fichier",
    en: "Error exporting file"
  },
  "synoptic.importedFromFile": {
    fr: "Synoptique importé avec succès",
    en: "Synoptic imported successfully"
  },
  "synoptic.importError": {
    fr: "Erreur lors de l'import du synoptique",
    en: "Error importing synoptic"
  },
  "synoptic.importFileError": {
    fr: "Erreur lors de l'import du fichier",
    en: "Error importing file"
  },
  "synoptic.invalidFileExtension": {
    fr: "Seuls les fichiers .vgsyn sont acceptés",
    en: "Only .vgsyn files are accepted"
  },
  "synoptic.invalidFormat": {
    fr: "Format de fichier invalide (doit être un synoptique VisualGrid)",
    en: "Invalid file format (must be a VisualGrid synoptic)"
  },
  "synoptic.invalidFile": {
    fr: "Fichier de synoptique invalide",
    en: "Invalid synoptic file"
  },
  "time.secondsAgo": {
    fr: "il y a {n}s",
    en: "{n}s ago"
  },

  // ========== CONFIRMATIONS ==========
  "confirm.deleteConfig": {
    fr: "Êtes-vous sûr de vouloir supprimer cette configuration ?",
    en: "Are you sure you want to delete this configuration?"
  },
  "confirm.resetAll": {
    fr: "Attention: Cela va réinitialiser TOUTE la configuration, les textes et les logos. Êtes-vous sûr de vouloir continuer?",
    en: "Warning: This will reset ALL configuration, texts and logos. Are you sure you want to continue?"
  },
  "confirm.resetMultiGrid": {
    fr: "Attention: Cela va réinitialiser TOUTE la configuration MultiGrid, toutes les grilles et les paramètres du canvas. Êtes-vous sûr de vouloir continuer?",
    en: "Warning: This will reset ALL MultiGrid configuration, all grids and canvas settings. Are you sure you want to continue?"
  },
  "confirm.title": {
    fr: "Confirmation",
    en: "Confirmation"
  },
  "confirm.downgrade": {
    fr: "Êtes-vous sûr de vouloir repasser en Free ? Vous perdrez l'accès aux fonctionnalités Pro.",
    en: "Are you sure you want to downgrade to Free? You will lose access to Pro features."
  },
  "confirm.downgradeTest": {
    fr: "🧪 MODE TEST\n\nVoulez-vous vraiment revenir en plan Free ?\n\nCeci est utile pour tester le paywall rapidement.\n\nNote : En production, utilisez le Customer Portal pour annuler.",
    en: "🧪 TEST MODE\n\nDo you really want to return to Free plan?\n\nThis is useful for quickly testing the paywall.\n\nNote: In production, use the Customer Portal to cancel."
  },

  // ========== TOAST MESSAGES ==========
  "toast.configDeleted": {
    fr: "Configuration supprimée avec succès",
    en: "Configuration deleted successfully"
  },
  "toast.configLoaded": {
    fr: "Configuration \"{name}\" chargée",
    en: "Configuration \"{name}\" loaded"
  },
  "toast.configLoadedComplete": {
    fr: "Configuration \"{name}\" chargée avec tous ses paramètres",
    en: "Configuration \"{name}\" loaded with all its parameters"
  },
  "toast.configSaveError": {
    fr: "Erreur lors de la sauvegarde: {error}",
    en: "Save error: {error}"
  },
  "toast.configDeleteError": {
    fr: "Erreur lors de la suppression: {error}",
    en: "Delete error: {error}"
  },
  "toast.configDeleteGenericError": {
    fr: "Erreur lors de la suppression de la configuration",
    en: "Error deleting configuration"
  },
  "toast.exportError": {
    fr: "Erreur lors de l'exportation: {error}",
    en: "Export error: {error}"
  },
  "toast.importSuccess": {
    fr: "Configuration importée avec succès {source}",
    en: "Configuration imported successfully {source}"
  },
  "toast.importError": {
    fr: "Impossible d'importer: format non supporté ({format})",
    en: "Cannot import: unsupported format ({format})"
  },
  "toast.externalDisplayWeb": {
    fr: "🌐 Affichage externe Web sur {name} ({width}×{height})",
    en: "🌐 External web display on {name} ({width}×{height})"
  },
  "toast.panelsGenerated": {
    fr: "{count} panneaux-mires générés et groupés !",
    en: "{count} test pattern panels generated and grouped!"
  },
  "toast.patternAdded": {
    fr: "Mire \"{name}\" ajoutée !",
    en: "Pattern \"{name}\" added!"
  },
  "toast.patternsAdded": {
    fr: "{count} mire{plural} ajoutée{plural} au workspace !",
    en: "{count} pattern{plural} added to workspace!"
  },
  "toast.patternRemoved": {
    fr: "Mire \"{name}\" retirée",
    en: "Pattern \"{name}\" removed"
  },
  "toast.patternUpdated": {
    fr: "Mire \"{name}\" mise à jour !",
    en: "Pattern \"{name}\" updated!"
  },
  "toast.snakeGamesStarted": {
    fr: "{count} jeu(x) Snake réinitialisé(s) et démarré(s)!",
    en: "{count} Snake game(s) reset and started!"
  },
  "toast.snakeGamesStopped": {
    fr: "{count} jeu(x) Snake arrêté(s)!",
    en: "{count} Snake game(s) stopped!"
  },
  "toast.exportingMultiple": {
    fr: "Exportation en cours : canvas entier + {count} grilles individuelles...",
    en: "Exporting: full canvas + {count} individual grids..."
  },
  "toast.exportingCanvas": {
    fr: "Exportation du canvas entier en cours...",
    en: "Exporting full canvas..."
  },
  "toast.canvasExported": {
    fr: "Canvas exporté avec succès",
    en: "Canvas exported successfully"
  },
  "toast.exportSuccess": {
    fr: "{count} fichiers exportés avec succès : 1 canvas entier + {grids} grilles individuelles",
    en: "{count} files exported successfully: 1 full canvas + {grids} individual grids"
  },
  "export.png.dialog.title": {
    fr: "Choisir le mode d'export PNG",
    en: "Choose PNG export mode"
  },
  "export.png.dialog.description": {
    fr: "Sélectionnez ce que vous souhaitez exporter",
    en: "Select what you want to export"
  },
  "export.png.dialog.fullCanvas": {
    fr: "Canvas complet",
    en: "Full Canvas"
  },
  "export.png.dialog.fullCanvas.desc": {
    fr: "Exporter tout le canvas en une seule image PNG",
    en: "Export the entire canvas as a single PNG image"
  },
  "export.png.dialog.individualGrids": {
    fr: "Grilles individuelles",
    en: "Individual Grids"
  },
  "export.png.dialog.individualGrids.desc": {
    fr: "Exporter chaque grille séparément en fichiers PNG",
    en: "Export each grid separately as PNG files"
  },
  "toast.exportPartial": {
    fr: "Export partiel : {success} fichiers exportés avec succès, {failed} échecs. Voir la console pour plus de détails.",
    en: "Partial export: {success} files exported successfully, {failed} failures. See console for details."
  },
  "toast.deviceConnectedRemote": {
    fr: "📱 {name} connecté comme remote",
    en: "📱 {name} connected as remote"
  },
  "toast.deviceConnected": {
    fr: "📱 {name} connecté",
    en: "📱 {name} connected"
  },
  "toast.sessionCreated": {
    fr: "Session {code} créée !",
    en: "Session {code} created!"
  },
  "toast.connectedToSession": {
    fr: "Connecté à la session {code}",
    en: "Connected to session {code}"
  },
  "toast.sessionLocalCreated": {
    fr: "Session locale créée: {code}",
    en: "Local session created: {code}"
  },
  "toast.sessionError": {
    fr: "Erreur session: {error}",
    en: "Session error: {error}"
  },
  "toast.sendError": {
    fr: "Erreur lors de l'envoi de {type}",
    en: "Error sending {type}"
  },
  "toast.deviceJoined": {
    fr: "{name} a rejoint la session",
    en: "{name} joined the session"
  },
  "toast.configSentToSynoptic": {
    fr: "Configuration envoyée au Synoptique !",
    en: "Configuration sent to Synoptic!"
  },
  "toast.configSentToSynopticDesc": {
    fr: "{columns}×{rows} panneaux détectés",
    en: "{columns}×{rows} panels detected"
  },
  "toast.webCodecsNotSupported": {
    fr: "WebCodecs non supporté",
    en: "WebCodecs not supported"
  },
  "toast.webCodecsNotSupportedDesc": {
    fr: "Votre navigateur ne supporte pas WebCodecs.",
    en: "Your browser does not support WebCodecs."
  },
  "toast.configImportError": {
    fr: "Erreur lors de l'importation de la configuration",
    en: "Error importing configuration"
  },
  "toast.configImportFormatError": {
    fr: "Impossible d'importer: format non supporté ({format})",
    en: "Cannot import: unsupported format ({format})"
  },
  "toast.configImportedFrom": {
    fr: "Configuration importée avec succès {source}",
    en: "Configuration imported successfully {source}"
  },
  "toast.configImportedFromMultigrid": {
    fr: "depuis une configuration multigrid",
    en: "from a multigrid configuration"
  },
  "toast.configImportedFromClassic": {
    fr: "depuis une configuration classique",
    en: "from a classic configuration"
  },
  "toast.resetComplete": {
    fr: "Configuration complètement réinitialisée avec succès",
    en: "Configuration completely reset successfully"
  },
  "toast.sessionLocalFailed": {
    fr: "Session locale échouée - Mode autonome activé",
    en: "Local session failed - Standalone mode activated"
  },

  // ========== NOVA CONFIG PANEL ==========
  "nova.processorsDiscovered": {
    fr: "{count} processeur(s) découvert(s)",
    en: "{count} processor(s) discovered"
  },
  "nova.discoveryError": {
    fr: "Erreur lors de la découverte",
    en: "Discovery error"
  },
  "nova.bridgeOffline": {
    fr: "Impossible de contacter le serveur Nova Bridge",
    en: "Cannot contact Nova Bridge server"
  },
  "nova.connectedTo": {
    fr: "Connecté à {ip}",
    en: "Connected to {ip}"
  },
  "nova.processorAssociated": {
    fr: "Processeur associé: {id} → {ip}",
    en: "Processor associated: {id} → {ip}"
  },
  "nova.portSelector.title": {
    fr: "Ports de connexion",
    en: "Connection ports"
  },
  "nova.portSelector.addPort": {
    fr: "Ajouter",
    en: "Add"
  },
  "nova.portSelector.noPorts": {
    fr: "Aucun port configuré. Cliquez sur '+' pour ajouter un port.",
    en: "No ports configured. Click '+' to add a port."
  },
  "nova.portSelector.panels": {
    fr: "panneaux",
    en: "panels"
  },
  "nova.portSelector.selectedPort": {
    fr: "Port sélectionné",
    en: "Selected port"
  },
  "nova.portSelector.clickPanels": {
    fr: "Cliquez sur les panneaux pour les câbler",
    en: "Click on panels to wire them"
  },
  "nova.portSelector.instruction": {
    fr: "Cliquez sur les panneaux de la mire pour les ajouter à ce port",
    en: "Click on the grid panels to add them to this port"
  },
  "nova.portSelector.showArrows": {
    fr: "Afficher les flèches",
    en: "Show arrows"
  },
  "nova.portSelector.showLines": {
    fr: "Afficher les lignes",
    en: "Show lines"
  },
  "nova.portSelector.minimalMode": {
    fr: "Mode minimal",
    en: "Minimal mode"
  },
  "nova.mode.title": {
    fr: "Mode Nova Screen Config",
    en: "Nova Screen Config Mode"
  },
  "nova.mode.description": {
    fr: "Créez votre propre numérotation de panneaux LED en les câblant sur des ports",
    en: "Create your own LED panel numbering by wiring them to ports"
  },

  // ========== SYNOPTIC PROJECT PROVIDER ==========
  "synopticProvider.projectUpdatedOtherTab": {
    fr: "Projet mis à jour dans un autre onglet",
    en: "Project updated in another tab"
  },
  "synopticProvider.errorLoadingProjects": {
    fr: "Erreur lors du chargement des projets",
    en: "Error loading projects"
  },
  "synopticProvider.mustBeProToLoad": {
    fr: "Vous devez être connecté et Pro pour charger un projet",
    en: "You must be logged in and Pro to load a project"
  },
  "synopticProvider.errorLoadingProject": {
    fr: "Erreur lors du chargement du projet",
    en: "Error loading project"
  },
  "synopticProvider.loadedFromLocalBackup": {
    fr: "Projet restauré depuis la sauvegarde locale",
    en: "Project restored from local backup"
  },
  "synopticProvider.projectCreated": {
    fr: "Projet \"{name}\" créé",
    en: "Project \"{name}\" created"
  },
  "synopticProvider.errorCreatingProject": {
    fr: "Erreur lors de la création du projet",
    en: "Error creating project"
  },
  "synopticProvider.errorSaving": {
    fr: "Erreur lors de la sauvegarde",
    en: "Error saving"
  },
  "synopticProvider.errorSavingTooLarge": {
    fr: "Le projet est trop volumineux pour être sauvegardé",
    en: "The project is too large to be saved"
  },
  "synopticProvider.saveRetryScheduled": {
    fr: "Échec de sauvegarde — nouvelle tentative automatique",
    en: "Save failed — automatic retry scheduled"
  },
  "synopticProvider.projectRenamed": {
    fr: "Projet renommé",
    en: "Project renamed"
  },
  "synopticProvider.errorRenaming": {
    fr: "Erreur lors du renommage",
    en: "Error renaming"
  },
  "synopticProvider.projectDuplicated": {
    fr: "Projet \"{name}\" créé",
    en: "Project \"{name}\" created"
  },
  "synopticProvider.errorDuplicating": {
    fr: "Erreur lors de la duplication",
    en: "Error duplicating"
  },
  "synopticProvider.projectDeleted": {
    fr: "Projet supprimé",
    en: "Project deleted"
  },
  "synopticProvider.errorDeleting": {
    fr: "Erreur lors de la suppression",
    en: "Error deleting"
  },
  "synopticProvider.rootFolder": {
    fr: "Racine",
    en: "Root"
  },
  "synopticProvider.folderCreated": {
    fr: "Dossier créé",
    en: "Folder created"
  },
  "synopticProvider.errorCreatingFolder": {
    fr: "Erreur lors de la création du dossier",
    en: "Error creating folder"
  },
  "synopticProvider.folderRenamed": {
    fr: "Dossier renommé",
    en: "Folder renamed"
  },
  "synopticProvider.errorRenamingFolder": {
    fr: "Erreur lors du renommage du dossier",
    en: "Error renaming folder"
  },
  "synopticProvider.folderDeleted": {
    fr: "Dossier supprimé",
    en: "Folder deleted"
  },
  "synopticProvider.errorDeletingFolder": {
    fr: "Erreur lors de la suppression du dossier",
    en: "Error deleting folder"
  },
  "synopticProvider.unsavedChangesTitle": {
    fr: "Modifications non sauvegardées",
    en: "Unsaved changes"
  },
  "synopticProvider.unsavedChangesDescription": {
    fr: "Des modifications sont en cours de sauvegarde ou en attente. Vous pouvez partir maintenant (elles seront perdues) ou rester pour attendre la validation.",
    en: "Changes are being saved or are pending. You can leave now (they will be lost) or stay and wait for validation."
  },
  "synopticProvider.unsavedChangesStay": {
    fr: "Rester et sauvegarder",
    en: "Stay and save"
  },
  "synopticProvider.unsavedChangesLeave": {
    fr: "Partir sans sauvegarder",
    en: "Leave without saving"
  },

  // ========== SHARED SESSION HOOK ==========
  "sharedSession.connectionLost": {
    fr: "Connexion session perdue",
    en: "Session connection lost"
  },
  "sharedSession.connectionRestored": {
    fr: "Connexion session rétablie",
    en: "Session connection restored"
  },
  "sharedSession.syncError": {
    fr: "Erreur lors de la synchronisation",
    en: "Synchronization error"
  },
  "sharedSession.sessionEnded": {
    fr: "Session terminée",
    en: "Session ended"
  },
  "sharedSession.endError": {
    fr: "Erreur lors de la fermeture de session",
    en: "Error ending session"
  },

  // ========== PRIVACY POLICY ==========
  "privacy.title": {
    fr: "Politique de Confidentialité",
    en: "Privacy Policy"
  },
  "privacy.lastUpdated": {
    fr: "Dernière mise à jour",
    en: "Last updated"
  },
  "privacy.intro.title": {
    fr: "Introduction",
    en: "Introduction"
  },
  "privacy.intro.content": {
    fr: "VisualGrid s'engage à protéger votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos données personnelles lorsque vous utilisez notre application.",
    en: "VisualGrid is committed to protecting your privacy. This privacy policy explains how we collect, use, and protect your personal data when you use our application."
  },
  "privacy.dataCollection.title": {
    fr: "Données Collectées",
    en: "Data Collection"
  },
  "privacy.dataCollection.content": {
    fr: "Nous collectons les informations suivantes : votre adresse email, votre nom d'affichage, les configurations que vous créez, et les métadonnées d'utilisation de l'application. Ces données sont nécessaires pour vous fournir nos services.",
    en: "We collect the following information: your email address, display name, configurations you create, and application usage metadata. This data is necessary to provide you with our services."
  },
  "privacy.dataUsage.title": {
    fr: "Utilisation des Données",
    en: "Data Usage"
  },
  "privacy.dataUsage.content": {
    fr: "Vos données sont utilisées pour : gérer votre compte, sauvegarder vos configurations, améliorer nos services, et communiquer avec vous concernant votre abonnement. Nous ne vendons jamais vos données à des tiers.",
    en: "Your data is used to: manage your account, save your configurations, improve our services, and communicate with you about your subscription. We never sell your data to third parties."
  },
  "privacy.dataSecurity.title": {
    fr: "Sécurité des Données",
    en: "Data Security"
  },
  "privacy.dataSecurity.content": {
    fr: "Nous utilisons Supabase pour le stockage sécurisé de vos données avec chiffrement SSL/TLS. Les paiements sont traités de manière sécurisée par Stripe. Nous ne stockons aucune information de carte bancaire.",
    en: "We use Supabase for secure data storage with SSL/TLS encryption. Payments are securely processed by Stripe. We do not store any credit card information."
  },
  "privacy.userRights.title": {
    fr: "Vos Droits",
    en: "Your Rights"
  },
  "privacy.userRights.content": {
    fr: "Conformément au RGPD, vous disposez des droits suivants : accès à vos données, rectification, suppression, limitation du traitement, portabilité des données, et opposition au traitement. Contactez-nous pour exercer ces droits.",
    en: "In accordance with GDPR, you have the following rights: access to your data, rectification, deletion, processing limitation, data portability, and objection to processing. Contact us to exercise these rights."
  },
  "privacy.cookies.title": {
    fr: "Cookies et Technologies Similaires",
    en: "Cookies and Similar Technologies"
  },
  "privacy.cookies.content": {
    fr: "Nous utilisons des cookies essentiels pour le fonctionnement de l'application (authentification, préférences). Vous pouvez gérer vos préférences de cookies dans les paramètres de votre navigateur.",
    en: "We use essential cookies for application functionality (authentication, preferences). You can manage your cookie preferences in your browser settings."
  },
  "privacy.dataRetention.title": {
    fr: "Conservation des Données",
    en: "Data Retention"
  },
  "privacy.dataRetention.content": {
    fr: "Nous conservons vos données aussi longtemps que votre compte est actif. Si vous supprimez votre compte, vos données personnelles seront supprimées dans un délai de 30 jours, sauf obligation légale de conservation.",
    en: "We retain your data as long as your account is active. If you delete your account, your personal data will be deleted within 30 days, unless legally required to retain it."
  },
  "privacy.thirdParty.title": {
    fr: "Services Tiers",
    en: "Third-Party Services"
  },
  "privacy.thirdParty.content": {
    fr: "Nous utilisons les services tiers suivants : Supabase (hébergement et authentification), Stripe (paiements), et Google OAuth (connexion optionnelle). Ces services ont leurs propres politiques de confidentialité.",
    en: "We use the following third-party services: Supabase (hosting and authentication), Stripe (payments), and Google OAuth (optional login). These services have their own privacy policies."
  },
  "privacy.contact.title": {
    fr: "Nous Contacter",
    en: "Contact Us"
  },
  "privacy.contact.content": {
    fr: "Pour toute question concernant cette politique de confidentialité ou vos données personnelles, contactez-nous à : app.visualgrid@gmail.com",
    en: "For any questions about this privacy policy or your personal data, contact us at: app.visualgrid@gmail.com"
  },

  // ========== TERMS OF SERVICE ==========
  "terms.title": {
    fr: "Conditions d'Utilisation",
    en: "Terms of Service"
  },
  "terms.lastUpdated": {
    fr: "Dernière mise à jour",
    en: "Last updated"
  },
  "terms.acceptance.title": {
    fr: "Acceptation des Conditions",
    en: "Acceptance of Terms"
  },
  "terms.acceptance.content": {
    fr: "En utilisant VisualGrid, vous acceptez d'être lié par ces conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre application.",
    en: "By using VisualGrid, you agree to be bound by these terms of service. If you do not accept these terms, please do not use our application."
  },
  "terms.license.title": {
    fr: "Licence d'Utilisation",
    en: "License to Use"
  },
  "terms.license.content": {
    fr: "VisualGrid vous accorde une licence personnelle, non transférable et non exclusive pour utiliser l'application conformément à ces conditions. Les fonctionnalités Pro nécessitent un abonnement payant actif.",
    en: "VisualGrid grants you a personal, non-transferable, and non-exclusive license to use the application in accordance with these terms. Pro features require an active paid subscription."
  },
  "terms.userAccount.title": {
    fr: "Compte Utilisateur",
    en: "User Account"
  },
  "terms.userAccount.content": {
    fr: "Vous êtes responsable de maintenir la confidentialité de vos identifiants de connexion. Vous acceptez de nous informer immédiatement de toute utilisation non autorisée de votre compte.",
    en: "You are responsible for maintaining the confidentiality of your login credentials. You agree to notify us immediately of any unauthorized use of your account."
  },
  "terms.subscription.title": {
    fr: "Abonnement et Paiements",
    en: "Subscription and Payments"
  },
  "terms.subscription.content": {
    fr: "Les abonnements Pro sont facturés tous les 6 mois. Vous pouvez annuler votre abonnement à tout moment. L'annulation prendra effet à la fin de votre période de facturation en cours. Les remboursements sont possibles sous 14 jours.",
    en: "Pro subscriptions are billed every 6 months. You can cancel your subscription at any time. Cancellation will take effect at the end of your current billing period. Refunds are available within 14 days."
  },
  "terms.intellectualProperty.title": {
    fr: "Propriété Intellectuelle",
    en: "Intellectual Property"
  },
  "terms.intellectualProperty.content": {
    fr: "Tous les droits de propriété intellectuelle de VisualGrid appartiennent à Axel Pouppart. Vous conservez la propriété de vos configurations et contenus créés dans l'application.",
    en: "All intellectual property rights to VisualGrid belong to Axel Pouppart. You retain ownership of your configurations and content created in the application."
  },
  "terms.prohibited.title": {
    fr: "Utilisations Interdites",
    en: "Prohibited Uses"
  },
  "terms.prohibited.content": {
    fr: "Vous ne devez pas : utiliser l'application de manière illégale, tenter de contourner les mesures de sécurité, partager votre compte avec des tiers, ou utiliser l'application pour créer du contenu illégal ou offensant.",
    en: "You must not: use the application illegally, attempt to bypass security measures, share your account with third parties, or use the application to create illegal or offensive content."
  },
  "terms.liability.title": {
    fr: "Limitation de Responsabilité",
    en: "Limitation of Liability"
  },
  "terms.liability.content": {
    fr: "VisualGrid est fourni 'tel quel'. Nous ne garantissons pas que l'application sera sans erreur ou disponible en permanence. Notre responsabilité est limitée au montant que vous avez payé pour le service au cours des 12 derniers mois.",
    en: "VisualGrid is provided 'as is'. We do not guarantee that the application will be error-free or permanently available. Our liability is limited to the amount you paid for the service in the last 12 months."
  },
  "terms.termination.title": {
    fr: "Résiliation",
    en: "Termination"
  },
  "terms.termination.content": {
    fr: "Nous nous réservons le droit de suspendre ou de résilier votre compte en cas de violation de ces conditions. Vous pouvez résilier votre compte à tout moment depuis les paramètres de votre compte.",
    en: "We reserve the right to suspend or terminate your account in case of violation of these terms. You can terminate your account at any time from your account settings."
  },
  "terms.modifications.title": {
    fr: "Modifications des Conditions",
    en: "Modifications to Terms"
  },
  "terms.modifications.content": {
    fr: "Nous nous réservons le droit de modifier ces conditions à tout moment. Les modifications importantes vous seront notifiées par email. Votre utilisation continue de l'application après les modifications constitue votre acceptation des nouvelles conditions.",
    en: "We reserve the right to modify these terms at any time. Significant changes will be notified to you by email. Your continued use of the application after changes constitutes your acceptance of the new terms."
  },
  "terms.law.title": {
    fr: "Loi Applicable",
    en: "Applicable Law"
  },
  "terms.law.content": {
    fr: "Ces conditions sont régies par le droit français. Tout litige sera soumis à la juridiction exclusive des tribunaux français.",
    en: "These terms are governed by French law. Any dispute will be subject to the exclusive jurisdiction of French courts."
  },
  "terms.contact.title": {
    fr: "Contact",
    en: "Contact"
  },
  "terms.contact.content": {
    fr: "Pour toute question concernant ces conditions d'utilisation, contactez-nous à : app.visualgrid@gmail.com",
    en: "For any questions about these terms of service, contact us at: app.visualgrid@gmail.com"
  },

  // Navigation
  "nav.privacy": {
    fr: "Confidentialité",
    en: "Privacy"
  },
  "nav.terms": {
    fr: "Conditions",
    en: "Terms"
  },

  // Toast Messages - Account
  "toast.userNotConnected": {
    fr: "Utilisateur non connecté",
    en: "User not connected"
  },
  "toast.noStripeSubscription": {
    fr: "Aucun abonnement Stripe trouvé. Veuillez contacter le support.",
    en: "No Stripe subscription found. Please contact support."
  },
  "toast.sessionExpired": {
    fr: "Session expirée. Reconnectez-vous.",
    en: "Session expired. Please log in again."
  },
  "toast.redirectingToStripe": {
    fr: "Redirection vers le portail Stripe...",
    en: "Redirecting to Stripe portal..."
  },
  "toast.requestTimeout": {
    fr: "La requête a expiré. Vérifiez votre connexion internet.",
    en: "Request timed out. Check your internet connection."
  },
  "toast.stripePortalNotConfigured": {
    fr: "Le portail client Stripe n'est pas configuré. Contactez l'administrateur.",
    en: "Stripe customer portal is not configured. Contact the administrator."
  },
  "toast.logoutError": {
    fr: "Erreur lors de la déconnexion",
    en: "Error during logout"
  },
  "toast.languageUpdateFailed": {
    fr: "Échec de la mise à jour de la préférence linguistique",
    en: "Failed to update language preference"
  },

  // Toast Messages - External Display
  "toast.configSaved": {
    fr: "Configuration \"{name}\" sauvegardée avec succès",
    en: "Configuration \"{name}\" saved successfully"
  },
  "toast.saveError": {
    fr: "Erreur lors de la sauvegarde",
    en: "Error while saving"
  },
  "toast.loadError": {
    fr: "Erreur lors du chargement",
    en: "Error while loading"
  },
  "toast.imageExported": {
    fr: "Image exportée avec succès",
    en: "Image exported successfully"
  },
  "toast.configReset": {
    fr: "Configuration réinitialisée avec succès",
    en: "Configuration reset successfully"
  },
  "toast.configExported": {
    fr: "Configuration exportée avec succès",
    en: "Configuration exported successfully"
  },
  "toast.configExportError": {
    fr: "Erreur lors de l'exportation de la configuration",
    en: "Error exporting configuration"
  },
  "toast.configImported": {
    fr: "Configuration importée avec succès",
    en: "Configuration imported successfully"
  },
  "toast.invalidWidth": {
    fr: "Largeur invalide, valeur par défaut appliquée (1920px)",
    en: "Invalid width, default value applied (1920px)"
  },
  "toast.invalidHeight": {
    fr: "Hauteur invalide, valeur par défaut appliquée (1080px)",
    en: "Invalid height, default value applied (1080px)"
  },
  "toast.invalidGridSize": {
    fr: "Taille de grille invalide, valeur par défaut appliquée (192px)",
    en: "Invalid grid size, default value applied (192px)"
  },
  "toast.portalError": {
    fr: "Erreur lors de l'ouverture du portail",
    en: "Error opening portal"
  },

  // Toast Messages - Synoptic
  "toast.projectRestored": {
    fr: "Projet restauré avec succès",
    en: "Project restored successfully"
  },
  "toast.projectLoaded": {
    fr: "Projet \"{name}\" chargé",
    en: "Project \"{name}\" loaded"
  },
  "toast.projectCreatedEmpty": {
    fr: "Nouveau projet créé",
    en: "New project created"
  },
  "toast.projectRestorationError": {
    fr: "Erreur lors de la restauration du projet",
    en: "Error restoring project"
  },
  "toast.projectDeletedElsewhere": {
    fr: "Ce projet a été supprimé",
    en: "This project was deleted"
  },
  "toast.projectMovedTo": {
    fr: "Projet déplacé vers {folder}",
    en: "Project moved to {folder}"
  },
  "toast.projectMoveError": {
    fr: "Erreur lors du déplacement",
    en: "Error moving project"
  },

  // Placeholders - Synoptic
  "placeholder.projectName": {
    fr: "Nom du projet",
    en: "Project name"
  },
  "placeholder.testPatternName": {
    fr: "Nom de la mire (optionnel)",
    en: "Test pattern name (optional)"
  },
  "placeholder.agencyName": {
    fr: "Nom agence",
    en: "Agency name"
  },
  "placeholder.clientName": {
    fr: "Nom client",
    en: "Client name"
  },
  "placeholder.eventName": {
    fr: "Nom de l'événement",
    en: "Event name"
  },
  "placeholder.chooseNovaIP": {
    fr: "Choisir IP Nova...",
    en: "Choose Nova IP..."
  },

  // Aria Labels & Titles - Canvas
  "aria.canvasWidth": {
    fr: "Largeur du canvas",
    en: "Canvas width"
  },
  "aria.canvasHeight": {
    fr: "Hauteur du canvas",
    en: "Canvas height"
  },
  "aria.gridWidth": {
    fr: "Largeur de la grille",
    en: "Grid width"
  },
  "aria.gridHeight": {
    fr: "Hauteur de la grille",
    en: "Grid height"
  },
  "aria.gridSize": {
    fr: "Taille de grille",
    en: "Grid size"
  },
  "aria.tileWidth": {
    fr: "Largeur de la dalle",
    en: "Tile width"
  },
  "aria.tileHeight": {
    fr: "Hauteur de la dalle",
    en: "Tile height"
  },

  // Titles - UI Actions
  "title.fullscreenMode": {
    fr: "Mode plein écran",
    en: "Fullscreen mode"
  },
  "title.toggleSidebar": {
    fr: "Basculer la barre latérale",
    en: "Toggle sidebar"
  },
  "title.clickToOpenEquipment": {
    fr: "Cliquer pour ouvrir le panneau équipements",
    en: "Click to open equipment panel"
  },
  "title.clickToHideLeftPanel": {
    fr: "Cliquer pour masquer le panneau gauche",
    en: "Click to hide left panel"
  },
  "title.duplicatePage": {
    fr: "Dupliquer la page",
    en: "Duplicate page"
  },
  "title.addDataPage": {
    fr: "Ajouter une page Data",
    en: "Add Data page"
  },
  "title.addPowerPage": {
    fr: "Ajouter une page Power",
    en: "Add Power page"
  },
  "title.selectionMode": {
    fr: "Mode Sélection (V)",
    en: "Selection Mode (V)"
  },
  "title.navigationMode": {
    fr: "Mode Navigation (H)",
    en: "Navigation Mode (H)"
  },
  "title.resetColor": {
    fr: "Réinitialiser la couleur par défaut",
    en: "Reset to default color"
  },
  "title.enableSnapping": {
    fr: "Activer l'alignement",
    en: "Enable snapping"
  },
  "title.disableSnapping": {
    fr: "Désactiver l'alignement",
    en: "Disable snapping"
  },
  "title.switchToLight": {
    fr: "Passer en thème clair",
    en: "Switch to light theme"
  },
  "title.switchToDark": {
    fr: "Passer en thème sombre",
    en: "Switch to dark theme"
  },
  "title.mireGenerator": {
    fr: "Générateur de Mires LED",
    en: "LED Test Pattern Generator"
  },
  "title.pasteElements": {
    fr: "Coller {count} élément(s) (Ctrl+V)",
    en: "Paste {count} element(s) (Ctrl+V)"
  },
  "title.pc16Outlet": {
    fr: "Prise PC16 {number} - {count} panneau{plural} connecté{plural}",
    en: "PC16 outlet {number} - {count} panel{plural} connected"
  },

  // Toast Messages - Sessions
  "toast.sharedSessionsProOnly": {
    fr: "Les sessions partagées sont réservées aux utilisateurs PRO",
    en: "Shared sessions are reserved for PRO users"
  },
  "toast.remoteDisconnected": {
    fr: "📱 Remote déconnectée",
    en: "📱 Remote disconnected"
  },
  "toast.sessionEnded": {
    fr: "Session terminée",
    en: "Session ended"
  },
  "toast.connectionLost": {
    fr: "Connexion perdue",
    en: "Connection lost"
  },
  "toast.sessionCreationError": {
    fr: "Erreur lors de la création de la session",
    en: "Error creating session"
  },
  "toast.enterSessionCode": {
    fr: "Veuillez saisir un code de session",
    en: "Please enter a session code"
  },
  "toast.deviceDisconnected": {
    fr: "📱 Appareil déconnecté",
    en: "📱 Device disconnected"
  },
  "toast.sessionEndedByServer": {
    fr: "Session terminée par le serveur",
    en: "Session terminated by server"
  },
  "toast.codeCopied": {
    fr: "Code copié dans le presse-papier",
    en: "Code copied to clipboard"
  },
  "toast.sessionLinkCopied": {
    fr: "Lien de session copié",
    en: "Session link copied"
  },

  // Toast Messages - Snake Game
  "toast.invalidScore": {
    fr: "Score invalide",
    en: "Invalid score"
  },

  // Alert Messages - Validation & Errors
  "alert.svgExportError": {
    fr: "Erreur lors de l'export SVG. Veuillez réessayer.",
    en: "Error exporting SVG. Please try again."
  },
  "alert.svgLoadError": {
    fr: "Erreur : Impossible de charger l'image SVG pour l'export.",
    en: "Error: Unable to load SVG image for export."
  },
  "alert.pdfExportError": {
    fr: "Erreur lors de l'export PDF. Veuillez réessayer.",
    en: "Error exporting PDF. Please try again."
  },
  "alert.selectProcessorFirst": {
    fr: "Veuillez d'abord sélectionner un processeur et un port dans le menu du bas.",
    en: "Please first select a processor and port in the menu below."
  },
  "alert.fillRequiredFields": {
    fr: "Veuillez remplir tous les champs obligatoires (Résolution et Taille).",
    en: "Please fill in all required fields (Resolution and Size)."
  },
  "alert.fillPowerFields": {
    fr: "Veuillez remplir tous les champs obligatoires (Puissance max et Nombre de prises).",
    en: "Please fill in all required fields (Max Power and Number of Outlets)."
  },
  "alert.enterValidPositiveValues": {
    fr: "Veuillez entrer des valeurs numériques valides et positives.",
    en: "Please enter valid positive numerical values."
  },
  "alert.enterValidDimensions": {
    fr: "Veuillez entrer des dimensions valides et positives.",
    en: "Please enter valid positive dimensions."
  },
  "alert.panelAlreadyPowered": {
    fr: "Ce panneau est déjà alimenté. Impossible de créer une boucle.",
    en: "This panel is already powered. Cannot create a loop."
  },

  // Footer Navigation
  "footer.about": {
    fr: "À propos",
    en: "About"
  },
  "footer.changelogs": {
    fr: "Changelogs",
    en: "Changelogs"
  },
  "footer.downloads": {
    fr: "Téléchargements",
    en: "Downloads"
  },
  "footer.privacy": {
    fr: "Confidentialité",
    en: "Privacy"
  },
  "footer.terms": {
    fr: "Conditions",
    en: "Terms"
  },

  // Export Cartouche (Synoptic)
  "export.cartouche": {
    fr: "Cartouche d'export",
    en: "Export cartouche"
  },
  "export.cartoucheDescription": {
    fr: "Personnalisez les informations du cartouche en bas de page",
    en: "Customize the cartouche information at the bottom of the page"
  },
  "export.agencyClient": {
    fr: "Agence/Client",
    en: "Agency/Client"
  },
  "export.client": {
    fr: "Client",
    en: "Client"
  },
  "export.event": {
    fr: "Événement",
    en: "Event"
  },
  "export.location": {
    fr: "Lieu",
    en: "Location"
  },
  "export.suite": {
    fr: "Suite",
    en: "Suite"
  },
  "export.what": {
    fr: "Quoi",
    en: "What"
  },
  "export.synopticLegend": {
    fr: "Légende synoptique",
    en: "Synoptic legend"
  },
  "export.date": {
    fr: "Date",
    en: "Date"
  },
  "export.from": {
    fr: "De",
    en: "From"
  },
  "placeholder.location": {
    fr: "Lieu",
    en: "Location"
  },
  "placeholder.suite": {
    fr: "Suite",
    en: "Suite"
  },
  "placeholder.description": {
    fr: "Description",
    en: "Description"
  },
  "placeholder.legend": {
    fr: "Légende",
    en: "Legend"
  },
  "placeholder.name": {
    fr: "Nom",
    en: "Name"
  },
  "placeholder.patternNameOptional": {
    fr: "Nom de la mire (optionnel)",
    en: "Pattern name (optional)"
  },

  // ========== PURCHASE SUCCESS PAGE ==========
  "purchaseSuccess.title": {
    fr: "Paiement réussi !",
    en: "Payment successful!"
  },
  "purchaseSuccess.welcome": {
    fr: "Bienvenue dans VisualGrid Pro ! Votre abonnement a été activé avec succès.",
    en: "Welcome to VisualGrid Pro! Your subscription has been successfully activated."
  },
  "purchaseSuccess.subscription": {
    fr: "Abonnement",
    en: "Subscription"
  },
  "purchaseSuccess.pro": {
    fr: "VisualGrid Pro",
    en: "VisualGrid Pro"
  },
  "purchaseSuccess.featureMultigrid": {
    fr: "Accès illimité au MultiGrid pour vos configurations complexes",
    en: "Unlimited access to MultiGrid for your complex configurations"
  },
  "purchaseSuccess.featureSynoptic": {
    fr: "Créez des synoptiques professionnels pour vos projets",
    en: "Create professional synoptics for your projects"
  },
  "purchaseSuccess.featureRemoteControl": {
    fr: "Contrôlez vos écrans à distance depuis votre téléphone",
    en: "Control your screens remotely from your phone"
  },
  "purchaseSuccess.featurePrioritySupport": {
    fr: "Support prioritaire et assistance technique dédiée",
    en: "Priority support and dedicated technical assistance"
  },
  "purchaseSuccess.subscriptionActive": {
    fr: "Votre abonnement est maintenant actif et toutes les fonctionnalités Pro sont disponibles.",
    en: "Your subscription is now active and all Pro features are available."
  },
  "purchaseSuccess.startUsingPro": {
    fr: "Commencer à utiliser Pro",
    en: "Start using Pro"
  },

  // Mobile routing
  "mobile.grid.remote.title": {
    fr: "Contrôle à distance",
    en: "Remote Control"
  },
  "mobile.grid.remote.description": {
    fr: "Contrôlez vos écrans LED depuis votre téléphone",
    en: "Control your LED screens from your phone"
  },
  "mobile.grid.remote.accessDesktop": {
    fr: "Accéder à la version ordinateur complète",
    en: "Access full desktop version"
  },
  "mobile.grid.redirecting": {
    fr: "Redirection vers la version mobile...",
    en: "Redirecting to mobile version..."
  },
  "mobile.grid.desktopWarning.title": {
    fr: "Version ordinateur",
    en: "Desktop Version"
  },
  "mobile.grid.desktopWarning.description": {
    fr: "Cette interface est optimisée pour les écrans d'ordinateur. Pour une meilleure expérience sur mobile, utilisez la version contrôle à distance.",
    en: "This interface is optimized for desktop screens. For a better mobile experience, use the remote control version."
  },
  "mobile.grid.desktopWarning.understand": {
    fr: "J'ai compris",
    en: "I understand"
  },

  // Mobile banner - Display mode switcher
  "mobile.banner.mobileMode": {
    fr: "Mode mobile",
    en: "Mobile mode"
  },
  "mobile.banner.desktopMode": {
    fr: "Mode ordinateur",
    en: "Desktop mode"
  },
  "mobile.banner.chooseDisplay": {
    fr: "Choisissez votre affichage",
    en: "Choose your display"
  },
  "mobile.banner.versionMobile": {
    fr: "Version mobile",
    en: "Mobile version"
  },
  "mobile.banner.versionDesktop": {
    fr: "Version ordinateur",
    en: "Desktop version"
  },

  // Session mode indicators
  "session.displayMode.title": {
    fr: "Mode Affichage - Les changements effectués avec la Remote sont automatiquement synchronisés.",
    en: "Display Mode - Changes made with the Remote are automatically synchronized."
  },
  "session.remoteMode.title": {
    fr: "Mode Remote - Les changements effectués avec la Remote sont automatiquement synchronisés avec le serveur.",
    en: "Remote Mode - Changes made with the Remote are automatically synchronized with the server."
  },
  "session.remoteControlOnly": {
    fr: "Seule la Remote peut contrôler l'animation",
    en: "Only the Remote can control the animation"
  },
  "sessions.proFeature1": {
    fr: "Soutenir le développement de VisualGrid",
    en: "Support the development of VisualGrid"
  },
  "sessions.proFeature2": {
    fr: "Contrôler à distance votre mire depuis un téléphone ou tablette",
    en: "Control your test pattern remotely from a phone or tablet"
  },
  "sessions.proFeature3": {
    fr: "Créez de puissants synoptiques LED",
    en: "Create powerful LED synoptics"
  },
  "sessions.upgradeToPro": {
    fr: "Passer en Pro",
    en: "Upgrade to Pro"
  },

  // Export Video Dialog
  "export.dialog.title": {
    fr: "Export Vidéo Loop",
    en: "Export Video Loop"
  },
  "export.dialog.description": {
    fr: "Exportez une boucle vidéo parfaite de votre mire",
    en: "Export a seamless video loop of your test pattern"
  },
  "export.dialog.format": {
    fr: "Format",
    en: "Format"
  },
  "export.dialog.format.mp4": {
    fr: "MP4",
    en: "MP4"
  },
  "export.dialog.format.mov": {
    fr: "MOV",
    en: "MOV"
  },
  "export.dialog.format.webm": {
    fr: "WebM",
    en: "WebM"
  },
  "export.dialog.format.prores": {
    fr: "ProRes",
    en: "ProRes"
  },
  "export.dialog.codec": {
    fr: "Codec",
    en: "Codec"
  },
  "export.dialog.codec.h264": {
    fr: "H.264",
    en: "H.264"
  },
  "export.dialog.codec.h265": {
    fr: "H.265 (Meilleure compression)",
    en: "H.265 (Better compression)"
  },
  "export.dialog.codec.vp9": {
    fr: "VP9 (Optimisé web)",
    en: "VP9 (Web optimized)"
  },
  "export.dialog.hardwareEncoder": {
    fr: "Accélération matérielle",
    en: "Hardware Acceleration"
  },
  "export.dialog.encoder.nvidia": {
    fr: "NVIDIA NVENC",
    en: "NVIDIA NVENC"
  },
  "export.dialog.encoder.intel": {
    fr: "Intel QuickSync",
    en: "Intel QuickSync"
  },
  "export.dialog.encoder.amd": {
    fr: "AMD AMF",
    en: "AMD AMF"
  },
  "export.dialog.encoder.apple": {
    fr: "Apple VideoToolbox",
    en: "Apple VideoToolbox"
  },
  "export.dialog.encoder.cpu": {
    fr: "CPU",
    en: "CPU"
  },
  "export.dialog.encoder.cpu.slower": {
    fr: "Plus lent mais compatible",
    en: "Slower but compatible"
  },
  "export.dialog.frameRate": {
    fr: "Fréquence d'images",
    en: "Frame Rate"
  },
  "export.dialog.fps": {
    fr: "fps",
    en: "fps"
  },
  "export.dialog.duration": {
    fr: "Durée",
    en: "Duration"
  },
  "export.dialog.duration.3s": {
    fr: "3 secondes",
    en: "3 seconds"
  },
  "export.dialog.duration.5s": {
    fr: "5 secondes",
    en: "5 seconds"
  },
  "export.dialog.duration.10s": {
    fr: "10 secondes",
    en: "10 seconds"
  },
  "export.dialog.quality": {
    fr: "Qualité",
    en: "Quality"
  },
  "export.dialog.qualityPreset": {
    fr: "Préset de qualité",
    en: "Quality Preset"
  },
  "export.dialog.summary": {
    fr: "Résumé de l'export",
    en: "Export Summary"
  },
  "export.dialog.totalFrames": {
    fr: "Nombre total d'images",
    en: "Total Frames"
  },
  "export.dialog.estimatedSize": {
    fr: "Taille estimée",
    en: "Estimated Size"
  },
  "export.dialog.encoder.label": {
    fr: "Encodeur",
    en: "Encoder"
  },
  "export.dialog.cancel": {
    fr: "Annuler",
    en: "Cancel"
  },
  "export.dialog.export": {
    fr: "Exporter",
    en: "Export"
  },
  "export.dialog.exportMode": {
    fr: "Mode d'export",
    en: "Export Mode"
  },
  "export.dialog.exportMode.fullCanvas": {
    fr: "Canvas complet",
    en: "Full Canvas"
  },
  "export.dialog.exportMode.fullCanvas.desc": {
    fr: "Exporter tout le canvas en une seule vidéo",
    en: "Export the entire canvas as a single video"
  },
  "export.dialog.exportMode.individualGrids": {
    fr: "Grilles individuelles",
    en: "Individual Grids"
  },
  "export.dialog.exportMode.individualGrids.desc": {
    fr: "Exporter chaque grille séparément",
    en: "Export each grid separately"
  },
  "export.dialog.grid": {
    fr: "grille",
    en: "grid"
  },
  "export.dialog.grids": {
    fr: "grilles",
    en: "grids"
  },
  "export.dialog.automaticSelection": {
    fr: "Sélection automatique",
    en: "Automatic selection"
  },
  "export.dialog.codecOutput": {
    fr: "Encapsuleur & Codec de sortie",
    en: "Output Container & Codec"
  },
  "export.dialog.format.h264mp4": {
    fr: "H.264 MP4",
    en: "H.264 MP4"
  },
  "export.dialog.format.h264mov": {
    fr: "H.264 MOV",
    en: "H.264 MOV"
  },
  "export.dialog.format.proresmov": {
    fr: "ProRes MOV",
    en: "ProRes MOV"
  },
  "export.dialog.format.h264mp4.desc": {
    fr: "Compatible universel (Web, After Effects, Premiere)",
    en: "Universal compatibility (Web, After Effects, Premiere)"
  },
  "export.dialog.format.h264mov.desc": {
    fr: "QuickTime - Idéal pour Apple/Final Cut",
    en: "QuickTime - Ideal for Apple/Final Cut"
  },
  "export.dialog.format.proresmov.desc": {
    fr: "Meilleure qualité mais fichiers volumineux",
    en: "Best quality but large file size"
  },
  "export.dialog.format.webm.desc": {
    fr: "Format web universel, compatible tous navigateurs",
    en: "Universal web format, compatible with all browsers"
  },
  "export.dialog.desktopOnly": {
    fr: "H.264 et ProRes nécessitent l'application desktop VisualGrid",
    en: "H.264 and ProRes require the VisualGrid desktop app"
  },
  "export.dialog.loopDuration": {
    fr: "Durée de la boucle",
    en: "Loop Duration"
  },
  "export.dialog.resolution": {
    fr: "Résolution",
    en: "Resolution"
  },
  "export.dialog.estimatedTime": {
    fr: "Temps estimé",
    en: "Estimated Time"
  },
  "export.progress.title.encoding": {
    fr: "Encodage en cours",
    en: "Encoding"
  },
  "export.progress.title.transcoding": {
    fr: "Transcodage en {format}",
    en: "Transcoding to {format}"
  },
  "export.progress.title.saving": {
    fr: "Enregistrement",
    en: "Saving"
  },
  "export.progress.title.complete": {
    fr: "Export terminé !",
    en: "Export Complete!"
  },
  "export.progress.selectLocation": {
    fr: "Sélectionnez l'emplacement...",
    en: "Select save location..."
  },
  "export.progress.preparingData": {
    fr: "Préparation des données...",
    en: "Preparing data..."
  },
  "export.progress.transcoding": {
    fr: "Transcodage en {format}...",
    en: "Transcoding to {format}..."
  },
  "export.progress.saving": {
    fr: "Enregistrement...",
    en: "Saving..."
  },
  "export.progress.finalizing": {
    fr: "Finalisation...",
    en: "Finalizing..."
  },
  "export.progress.cancelled": {
    fr: "Export annulé",
    en: "Export cancelled"
  },
  "export.progress.success": {
    fr: "Vidéo exportée avec succès !",
    en: "Video exported successfully!"
  },
  "export.progress.progression": {
    fr: "Progression",
    en: "Progress"
  },
  "export.progress.frame": {
    fr: "Frame",
    en: "Frame"
  },
  "export.progress.speed": {
    fr: "Vitesse",
    en: "Speed"
  },
  "export.progress.timeRemaining": {
    fr: "Temps restant",
    en: "Time remaining"
  },
  "export.progress.step": {
    fr: "Étape",
    en: "Step"
  },
  "export.progress.encoding": {
    fr: "Encodage",
    en: "Encoding"
  },
  "export.progress.transcoding.step": {
    fr: "Transcodage",
    en: "Transcoding"
  },
  "export.progress.close": {
    fr: "Fermer",
    en: "Close"
  },
  "export.progress.cancel": {
    fr: "Annuler",
    en: "Cancel"
  },
  "export.progress.complete": {
    fr: "Export terminé !",
    en: "Export Complete!"
  },
  "export.inProgress": {
    fr: "Export en cours...",
    en: "Export in progress..."
  },
  "export.createVideo": {
    fr: "Créer une vidéo animée",
    en: "Create an animated video"
  },
  "export.progress.converting": {
    fr: "Conversion...",
    en: "Converting..."
  },
  "export.progress.remaining": {
    fr: "Temps restant",
    en: "Time Remaining"
  },
  "export.progress.frames": {
    fr: "images",
    en: "frames"
  },
  "export.progress.creatingZip": {
    fr: "Archive ZIP en création...",
    en: "Creating ZIP archive..."
  },
  "export.progress.gridsExportedInZip": {
    fr: "{count} grille(s) exportée(s) dans une archive ZIP",
    en: "{count} grid(s) exported in a ZIP archive"
  },
  "export.progress.dontModify": {
    fr: "Veuillez ne pas modifier les paramètres pendant l'export...",
    en: "Please do not modify settings during export..."
  },
  "export.progress.individualGrids": {
    fr: "Export des grilles individuelles",
    en: "Exporting individual grids"
  },
  "export.progress.grid": {
    fr: "Grille",
    en: "Grid"
  },
  "export.webNotAvailable": {
    fr: "L'export vidéo est disponible uniquement dans la version desktop de VisualGrid. Installez l'application desktop pour exporter vos vidéos.",
    en: "Video export is only available in the VisualGrid desktop version. Install the desktop application to export your videos."
  },
  "config.exportToFile": {
    fr: "Exporter en .mgrd",
    en: "Export as .mgrd"
  },
  "config.exportToFileDesc": {
    fr: "Exporter la configuration en fichier .mgrd",
    en: "Export configuration as .mgrd file"
  },
  "config.emptyConfigName": {
    fr: "Configuration vierge",
    en: "Empty configuration"
  },
  "config.exportedToFile": {
    fr: "Configuration exportée en fichier .mgrd",
    en: "Configuration exported to .mgrd file"
  },
  "config.exportFileError": {
    fr: "Erreur lors de l'export du fichier",
    en: "Error exporting file"
  },

  // Synoptic - New Strings
  "synoptic.project.newName": {
    fr: "Nouveau Projet",
    en: "New Project"
  },
  "synoptic.dataPage": {
    fr: "Data {page}",
    en: "Data {page}"
  },
  "synoptic.powerPage": {
    fr: "Power {page}",
    en: "Power {page}"
  },
  "synoptic.active": {
    fr: "⚡ Actif",
    en: "⚡ Active"
  },
  "synoptic.navigation": {
    fr: "⬅️ ➡️ ⬆️ ⬇️",
    en: "⬅️ ➡️ ⬆️ ⬇️"
  },
  "synoptic.noProcessor": {
    fr: "Aucun processeur placé",
    en: "No processor placed"
  },
  "synoptic.hide": {
    fr: "Masquer",
    en: "Hide"
  },
  "synoptic.statistics": {
    fr: "Statistiques du projet",
    en: "Project Statistics"
  },
  "synoptic.processorsCount": {
    fr: "Processeurs :",
    en: "Processors:"
  },
  "synoptic.panelsCount": {
    fr: "Dalles :",
    en: "Panels:"
  },
  "synoptic.cablesCount": {
    fr: "Câbles :",
    en: "Cables:"
  },
  "synoptic.estimatedConsumption": {
    fr: "Consommation estimée :",
    en: "Estimated Consumption :"
  },
  "synoptic.mireConsumption": {
    fr: "Consommation LED :",
    en: "LED Wall Consumption :"
  },
  "synoptic.clickToOpenRightPanel": {
    fr: "Cliquer pour ouvrir le panneau droit",
    en: "Click to open right panel"
  },
  "synoptic.exportOptions": {
    fr: "Options d'export",
    en: "Export Options"
  },
  "synoptic.showCartouche": {
    fr: "Afficher la cartouche",
    en: "Show Info Block"
  },
  "synoptic.showCartoucheDesc": {
    fr: "Active ou désactive l'affichage de la cartouche d'informations en bas de la zone d'export",
    en: "Enables or disables the display of the information block at the bottom of the export area"
  },
  "synoptic.ungroup": {
    fr: "Dissocier le groupe",
    en: "Ungroup"
  },
  "synoptic.createGroup": {
    fr: "Créer un groupe",
    en: "Create Group"
  },
  "synoptic.opacity": {
    fr: "Opacité",
    en: "Opacity"
  },
  "synoptic.brand": {
    fr: "Marque :",
    en: "Brand:"
  },
  "synoptic.model": {
    fr: "Modèle :",
    en: "Model:"
  },
  "synoptic.outputPorts": {
    fr: "Ports RJ45 en sortie :",
    en: "Output RJ45 Ports:"
  },
  "synoptic.totalPixels": {
    fr: "Total de pixels :",
    en: "Total Pixels:"
  },
  "synoptic.videoInputs": {
    fr: "Entrées vidéo :",
    en: "Video Inputs:"
  },
  "synoptic.processorCustomName": {
    fr: "Nom personnalise",
    en: "Custom name"
  },
  "synoptic.processorCustomNameDesc": {
    fr: "Renommez ce processeur. Visible dans les exports PDF, SVG et PNG.",
    en: "Rename this processor. Visible in PDF, SVG and PNG exports."
  },
  "synoptic.consumption": {
    fr: "Consommation :",
    en: "Consumption:"
  },
  "synoptic.pixelPitch": {
    fr: "Pixel pitch :",
    en: "Pixel pitch:"
  },
  "synoptic.resolution": {
    fr: "Résolution ",
    en: "Resolution "
  },
  "synoptic.dimensions": {
    fr: "Dimensions :",
    en: "Dimensions:"
  },
  "synoptic.brightness": {
    fr: "Luminosité :",
    en: "Brightness:"
  },
  "synoptic.ipRating": {
    fr: "IP :",
    en: "IP:"
  },
  "synoptic.maxPower": {
    fr: "Puissance max :",
    en: "Max Power:"
  },
  "synoptic.voltage": {
    fr: "Voltage :",
    en: "Voltage:"
  },
  "synoptic.cabinetType": {
    fr: "Type :",
    en: "Type:"
  },
  "synoptic.deleteGroup": {
    fr: "Supprimer le groupe",
    en: "Delete Group"
  },
  "synoptic.processor": {
    fr: "Processeur",
    en: "Processor"
  },
  "synoptic.panel": {
    fr: "Dalle",
    en: "Panel"
  },
  "synoptic.cabinet": {
    fr: "Coffret",
    en: "Cabinet"
  },
  "synoptic.selectedItems": {
    fr: "{count} éléments sélectionnés",
    en: "{count} items selected"
  },
  "synoptic.group": {
    fr: "Groupe",
    en: "Group"
  },
  "synoptic.elements": {
    fr: "Éléments",
    en: "Elements"
  },
  "synoptic.searchComponents": {
    fr: "Rechercher des composants...",
    en: "Search components..."
  },
  "synoptic.addEquipment": {
    fr: "Ajouter un équipement",
    en: "Add an equipment"
  },
  "synoptic.dragAndDropHint": {
    fr: "Glissez-déposez des éléments sur le canvas pour commencer",
    en: "Drag and drop elements onto the canvas to start"
  },
  "synoptic.cabinets": {
    fr: "Armoires :",
    en: "Cabinets:"
  },
  "synoptic.panelsPowered": {
    fr: "Dalles alimentées :",
    en: "Panels powered:"
  },
  "synoptic.powerCables": {
    fr: "Câbles Power :",
    en: "Power Cables:"
  },
  "synoptic.totalConsumption": {
    fr: "Consommation totale :",
    en: "Total Consumption:"
  },
  "synoptic.ledProcessors": {
    fr: "Processeurs LED",
    en: "LED Processors"
  },
  "synoptic.ledPanels": {
    fr: "Dalles LED",
    en: "LED Panels"
  },
  "synoptic.powerCabinets": {
    fr: "Armoires & Coffrets",
    en: "Power Cabinets"
  },
  "synoptic.showSpecs": {
    fr: "Afficher specs",
    en: "Show specs"
  },
  "synoptic.search": {
    fr: "Rechercher...",
    en: "Search..."
  },
  "synoptic.custom": {
    fr: "Custom",
    en: "Custom"
  },
  "synoptic.selected": {
    fr: "Sélectionné",
    en: "Selected"
  },
  "synoptic.clickToPlace": {
    fr: "Cliquer pour placer →",
    en: "Click to place →"
  },
  "synoptic.clickToSelect": {
    fr: "Cliquer pour sélectionner",
    en: "Click to select"
  },
  "synoptic.conso": {
    fr: "Conso :",
    en: "Conso:"
  },
  "synoptic.hideLeftPanel": {
    fr: "Cliquer pour masquer le panneau gauche",
    en: "Click to hide left panel"
  },
  "synoptic.maxOutput": {
    fr: "Sortie max :",
    en: "Max Output:"
  },
  "synoptic.ports": {
    fr: "Ports :",
    en: "Ports:"
  },
  "synoptic.dragNDrop": {
    fr: "Cliquer-glisser →",
    en: "Drag-n-Drop →"
  },
  "synoptic.hideBottomPanel": {
    fr: "Cliquer pour masquer le panneau du bas",
    en: "Click to hide bottom panel"
  },
  "synoptic.portsLabel": {
    fr: "Ports :",
    en: "Ports:"
  },
  "synoptic.processorToPanelLink": {
    fr: "Liaison entre le processeur et le 1er panel :",
    en: "Connection between processor and 1st panel:"
  },
  "synoptic.visible": {
    fr: "Visible",
    en: "Visible"
  },
  "synoptic.hidden": {
    fr: "Masqué",
    en: "Hidden"
  },
  "synoptic.action": {
    fr: "Action :",
    en: "Action:"
  },
  "synoptic.connectSelectedPanels": {
    fr: "Connecter panneaux sélectionnés",
    en: "Connect selected panels"
  },
  "synoptic.daisyChain": {
    fr: "Daisy Chain :",
    en: "Daisy Chain:"
  },
  "synoptic.portInfo": {
    fr: "Port {port} - {count} panneau(x) connecté(s)",
    en: "Port {port} - {count} panel(s) connected"
  },
  "synoptic.backupPortInfo": {
    fr: "Port backup {backup} du port {primary}",
    en: "Backup port {backup} of port {primary}"
  },
  "synoptic.removeBackup": {
    fr: "Supprimer ce backup",
    en: "Remove this backup"
  },
  "synoptic.createCustomPanel": {
    fr: "Créer un panneau personnalisé",
    en: "Create Custom Panel"
  },
  "synoptic.createCustomPanelDescription": {
    fr: "Entrez les spécifications de votre panneau LED. Les champs marqués d'un * sont obligatoires.",
    en: "Enter your LED panel specifications. Fields marked with * are required."
  },
  "synoptic.panelNamePlaceholder": {
    fr: "ex: P2.6 192x192",
    en: "ex: P2.6 192x192"
  },
  "synoptic.panelNameHint": {
    fr: "Si vide, le nom sera généré automatiquement (ex: Custom 128×128)",
    en: "If empty, name will be auto-generated (ex: Custom 128×128)"
  },
  "synoptic.resolutionRequired": {
    fr: "Résolution *",
    en: "Resolution *"
  },
  "synoptic.widthPx": {
    fr: "Largeur (px)",
    en: "Width (px)"
  },
  "synoptic.heightPx": {
    fr: "Hauteur (px)",
    en: "Height (px)"
  },
  "synoptic.widthMm": {
    fr: "Largeur (mm)",
    en: "Width (mm)"
  },
  "synoptic.heightMm": {
    fr: "Hauteur (mm)",
    en: "Height (mm)"
  },
  "synoptic.brightnessLabel": {
    fr: "Luminosité (cd/m²)",
    en: "Brightness (cd/m²)"
  },
  "synoptic.consumptionLabel": {
    fr: "Consommation (W)",
    en: "Consumption (W)"
  },
  "synoptic.createPanel": {
    fr: "Créer le panneau",
    en: "Create Panel"
  },
  "synoptic.createCustomCabinet": {
    fr: "Créer une armoire électrique personnalisée",
    en: "Create Custom Power Cabinet"
  },
  "synoptic.createCustomCabinetDescription": {
    fr: "Entrez les spécifications de votre armoire électrique. Seuls la puissance maximale et le nombre de prises sont obligatoires.",
    en: "Enter your power cabinet specifications. Only max power and outlet count are required."
  },
  "synoptic.cabinetNameLabel": {
    fr: "Nom de l'armoire",
    en: "Cabinet Name"
  },
  "synoptic.cabinetNameHint": {
    fr: "Si vide, le nom sera généré automatiquement (ex: Custom 10000W)",
    en: "If empty, name will be auto-generated (ex: Custom 10000W)"
  },
  "synoptic.cabinetTypeLabel": {
    fr: "Type",
    en: "Type"
  },
  "synoptic.cabinetTypePlaceholder": {
    fr: "ex: PDU, Distribution Panel, Power Supply",
    en: "ex: PDU, Distribution Panel, Power Supply"
  },
  "synoptic.cabinetTypeHint": {
    fr: "Par défaut : PDU",
    en: "Default: PDU"
  },
  "synoptic.maxPowerLabel": {
    fr: "Puissance maximale (W) *",
    en: "Max Power (W) *"
  },
  "synoptic.voltageLabel": {
    fr: "Tension",
    en: "Voltage"
  },
  "synoptic.voltagePlaceholder": {
    fr: "ex: 230V, 400V 3Ph",
    en: "ex: 230V, 400V 3Ph"
  },
  "synoptic.voltageHint": {
    fr: "Par défaut : 230V",
    en: "Default: 230V"
  },
  "synoptic.dimensionsLabel": {
    fr: "Dimensions",
    en: "Dimensions"
  },
  "synoptic.dimensionsHint": {
    fr: "Par défaut : 100mm × 100mm",
    en: "Default: 100mm × 100mm"
  },
  "synoptic.createCabinet": {
    fr: "Créer l'armoire",
    en: "Create Cabinet"
  },
  "synoptic.setAsBackup": {
    fr: "Marquer comme backup",
    en: "Set as backup"
  },
  "synoptic.cancelBackupSelection": {
    fr: "Annuler sélection",
    en: "Cancel selection"
  },
  "synoptic.removeBackupRelation": {
    fr: "Retirer la relation backup",
    en: "Remove backup relation"
  },
  "synoptic.selectProcessorForBackup": {
    fr: "Sélectionnez un processeur pour définir comme backup",
    en: "Select a processor to set as backup"
  },
  "synoptic.backupProcessorSet": {
    fr: "Processeur configuré comme backup",
    en: "Processor set as backup"
  },
  "synoptic.setProcessorBackup": {
    fr: "Définir ce processeur comme backup par Drag'n Drop",
    en: "Set this processor as backup by Drag'n Drop"
  },
  "synoptic.clickMainProcessor": {
    fr: "Cliquez sur le processeur Main dans le workspace",
    en: "Click on the Main processor in the workspace"
  },
  "synoptic.cannotBeOwnBackup": {
    fr: "Un processeur ne peut pas être son propre backup",
    en: "A processor cannot be its own backup"
  },
  "synoptic.iWillBeYourBackup": {
    fr: "Je serai ton backup",
    en: "I will be your backup"
  },
  "synoptic.backupProcessorDisabled": {
    fr: "Processeur backup",
    en: "Backup processor"
  },
  "synoptic.backupPortsNotInteractive": {
    fr: "Ports non interactifs (processeur backup)",
    en: "Ports not interactive (backup processor)"
  },
  // ========== PROJECT HUB ==========
  "projectHub.title": {
    fr: "Mes Projets",
    en: "My Projects"
  },
  "projectHub.proRequired": {
    fr: "Accès Pro requis",
    en: "Pro access required"
  },
  "projectHub.proRequiredDesc": {
    fr: "Connectez-vous avec un compte Pro pour accéder à vos projets.",
    en: "Sign in with a Pro account to access your projects."
  },
  "projectHub.import": {
    fr: "Importer",
    en: "Import"
  },
  "projectHub.newFolder": {
    fr: "Nouveau dossier",
    en: "New folder"
  },
  "projectHub.newProject": {
    fr: "Nouveau projet",
    en: "New project"
  },
  "projectHub.back": {
    fr: "Retour",
    en: "Back"
  },
  "projectHub.folders": {
    fr: "Dossiers",
    en: "Folders"
  },
  "projectHub.projects": {
    fr: "Projets",
    en: "Projects"
  },
  "projectHub.noProjects": {
    fr: "Aucun projet",
    en: "No projects"
  },
  "projectHub.noProjectsDesc": {
    fr: "Créez votre premier projet pour commencer",
    en: "Create your first project to get started"
  },
  "projectHub.rename": {
    fr: "Renommer",
    en: "Rename"
  },
  "projectHub.duplicate": {
    fr: "Dupliquer",
    en: "Duplicate"
  },
  "projectHub.move": {
    fr: "Déplacer",
    en: "Move"
  },
  "projectHub.delete": {
    fr: "Supprimer",
    en: "Delete"
  },
  "projectHub.root": {
    fr: "Racine",
    en: "Root"
  },
  "projectHub.createdAt": {
    fr: "Créé le",
    en: "Created on"
  },
  "projectHub.modifiedAt": {
    fr: "Modifié le",
    en: "Modified on"
  },
  "projectHub.lastOpened": {
    fr: "Ouvert",
    en: "Opened"
  },
  "projectHub.dialogNewProject": {
    fr: "Nouveau projet",
    en: "New project"
  },
  "projectHub.dialogNewProjectDesc": {
    fr: "Donnez un nom à votre nouveau projet synoptique",
    en: "Give a name to your new synoptic project"
  },
  "projectHub.dialogNewFolder": {
    fr: "Nouveau dossier",
    en: "New folder"
  },
  "projectHub.dialogNewFolderDesc": {
    fr: "Créez un dossier pour organiser vos projets",
    en: "Create a folder to organize your projects"
  },
  "projectHub.dialogRenameProject": {
    fr: "Renommer le projet",
    en: "Rename project"
  },
  "projectHub.dialogRenameFolder": {
    fr: "Renommer le dossier",
    en: "Rename folder"
  },
  "projectHub.dialogImport": {
    fr: "Importer des projets",
    en: "Import projects"
  },
  "projectHub.dialogImportDesc": {
    fr: "Importez des fichiers .vgsyn pour les ajouter à vos projets",
    en: "Import .vgsyn files to add them to your projects"
  },
  "projectHub.projectName": {
    fr: "Nom du projet",
    en: "Project name"
  },
  "projectHub.folderName": {
    fr: "Nom du dossier",
    en: "Folder name"
  },
  "projectHub.create": {
    fr: "Créer",
    en: "Create"
  },
  "projectHub.cancel": {
    fr: "Annuler",
    en: "Cancel"
  },
  "projectHub.deleteProjectTitle": {
    fr: "Supprimer le projet",
    en: "Delete project"
  },
  "projectHub.deleteProjectDesc": {
    fr: "Êtes-vous sûr de vouloir supprimer le projet \"{name}\" ? Cette action est irréversible.",
    en: "Are you sure you want to delete the project \"{name}\"? This action cannot be undone."
  },
  "projectHub.deleteFolderTitle": {
    fr: "Supprimer le dossier",
    en: "Delete folder"
  },
  "projectHub.deleteFolderDesc": {
    fr: "Êtes-vous sûr de vouloir supprimer le dossier \"{name}\" ? Les projets seront déplacés à la racine.",
    en: "Are you sure you want to delete the folder \"{name}\"? Projects will be moved to the root."
  },
  "projectHub.dropFilesHere": {
    fr: "Déposez vos fichiers .vgsyn ici",
    en: "Drop your .vgsyn files here"
  },
  "projectHub.orClickToSelect": {
    fr: "ou cliquez pour sélectionner",
    en: "or click to select"
  },
  "projectHub.filesSelected": {
    fr: "{count} fichier(s) sélectionné(s)",
    en: "{count} file(s) selected"
  },
  "projectHub.loadingProjects": {
    fr: "Chargement des projets...",
    en: "Loading projects..."
  },
  "projectHub.openingFromCloud": {
    fr: "Ouverture depuis VisualCloud...",
    en: "Opening from VisualCloud..."
  },
  "projectHub.importSuccess": {
    fr: "Projet importé avec succès",
    en: "Project imported successfully"
  },
  "projectHub.importError": {
    fr: "Erreur lors de l'import du projet",
    en: "Error importing project"
  },
  "projectHub.invalidFile": {
    fr: "Fichier invalide. Seuls les fichiers .vgsyn sont acceptés.",
    en: "Invalid file. Only .vgsyn files are accepted."
  },
  "projectHub.importingFile": {
    fr: "Import du projet...",
    en: "Importing project..."
  },

  // ========== DEMO MODE ==========
  "demo.badge": {
    fr: "DÉMO",
    en: "DEMO"
  },
  "demo.welcome.title": {
    fr: "Découvrez le Synoptique",
    en: "Discover the Synoptic"
  },
  "demo.welcome.subtitle": {
    fr: "Testez gratuitement notre outil professionnel de schématisation LED",
    en: "Try our professional LED schematic tool for free"
  },
  "demo.onboarding.step1.title": {
    fr: "Ajoutez des processeurs",
    en: "Add processors"
  },
  "demo.onboarding.step1.desc": {
    fr: "Glissez-déposez vos processeurs vidéo NovaStar, Brompton ou autres sur le workspace.",
    en: "Drag and drop your NovaStar, Brompton or other video processors onto the workspace."
  },
  "demo.onboarding.step2.title": {
    fr: "Connectez vos panneaux",
    en: "Connect your panels"
  },
  "demo.onboarding.step2.desc": {
    fr: "Créez des liaisons visuelles entre processeurs et panneaux LED avec un système de câblage intuitif.",
    en: "Create visual links between processors and LED panels with an intuitive cabling system."
  },
  "demo.onboarding.step3.title": {
    fr: "Gérez l'alimentation",
    en: "Manage power"
  },
  "demo.onboarding.step3.desc": {
    fr: "Configurez les armoires électriques et visualisez la distribution de puissance.",
    en: "Configure electrical cabinets and visualize power distribution."
  },
  "demo.onboarding.step4.title": {
    fr: "Exportez vos synoptiques",
    en: "Export your synoptics"
  },
  "demo.onboarding.step4.desc": {
    fr: "Générez des exports PNG, PDF ou vidéo pour partager vos schémas professionnels.",
    en: "Generate PNG, PDF or video exports to share your professional diagrams."
  },
  "demo.limit.time": {
    fr: "Session limitée à 5 minutes",
    en: "Session limited to 5 minutes"
  },
  "demo.limit.elements": {
    fr: "Maximum 3 éléments",
    en: "Maximum 3 elements"
  },
  "demo.limit.noSave": {
    fr: "Sauvegarde désactivée",
    en: "Save disabled"
  },
  "demo.limitations.title": {
    fr: "Limitations du mode démo",
    en: "Demo mode limitations"
  },
  "demo.start.title": {
    fr: "Commencer la démo",
    en: "Start the demo"
  },
  "demo.start.duration": {
    fr: "5 minutes d'essai gratuit",
    en: "5 minutes free trial"
  },
  "demo.start.button": {
    fr: "Démarrer la démonstration",
    en: "Start the demonstration"
  },
  "demo.cooldown.button": {
    fr: "Démo temporairement indisponible",
    en: "Demo temporarily unavailable"
  },
  "demo.cooldown.message": {
    fr: "Nouvelle démo disponible dans",
    en: "New demo available in"
  },
  "demo.pro.title": {
    fr: "Passez en Pro",
    en: "Upgrade to Pro"
  },
  "demo.pro.subtitle": {
    fr: "Accès complet sans limitations",
    en: "Full access without limitations"
  },
  "demo.pro.unlimited": {
    fr: "Éléments illimités",
    en: "Unlimited elements"
  },
  "demo.pro.save": {
    fr: "Sauvegarde cloud",
    en: "Cloud save"
  },
  "demo.pro.export": {
    fr: "Export haute résolution",
    en: "High resolution export"
  },
  "demo.pro.collaboration": {
    fr: "Collaboration en temps réel",
    en: "Real-time collaboration"
  },
  "demo.pro.button": {
    fr: "Découvrir Pro - 9,99€/6 mois",
    en: "Discover Pro - €9.99/6 month"
  },
  "demo.timeRemaining": {
    fr: "Temps restant",
    en: "Time remaining"
  },
  "demo.resourceLimits": {
    fr: "Limites de ressources",
    en: "Resource limits"
  },
  "demo.elements": {
    fr: "Éléments",
    en: "Elements"
  },
  "demo.connections": {
    fr: "Connexions",
    en: "Connections"
  },
  "demo.cables": {
    fr: "Câbles",
    en: "Cables"
  },
  "demo.nearLimit": {
    fr: "Vous approchez des limites",
    en: "You are approaching the limits"
  },
  "demo.upgradeNow": {
    fr: "Passer en Pro",
    en: "Upgrade to Pro"
  },
  "demo.ended.badge": {
    fr: "Session terminée",
    en: "Session ended"
  },
  "demo.ended.title": {
    fr: "Votre démonstration est terminée",
    en: "Your demonstration has ended"
  },
  "demo.ended.subtitle": {
    fr: "Vous avez pu découvrir les fonctionnalités du Synoptique. Passez en Pro pour un accès complet !",
    en: "You were able to discover the Synoptic features. Upgrade to Pro for full access!"
  },
  "demo.ended.feature1.title": {
    fr: "Éléments illimités",
    en: "Unlimited elements"
  },
  "demo.ended.feature1.desc": {
    fr: "Ajoutez autant de processeurs, panneaux et armoires que nécessaire",
    en: "Add as many processors, panels and cabinets as needed"
  },
  "demo.ended.feature2.title": {
    fr: "Sauvegarde cloud",
    en: "Cloud save"
  },
  "demo.ended.feature2.desc": {
    fr: "Vos projets sont sauvegardés automatiquement et accessibles partout",
    en: "Your projects are saved automatically and accessible everywhere"
  },
  "demo.ended.feature3.title": {
    fr: "Export professionnel",
    en: "Professional export"
  },
  "demo.ended.feature3.desc": {
    fr: "Exportez en PDF, PNG haute résolution pour vos clients",
    en: "Export to PDF, high resolution PNG for your clients"
  },
  "demo.ended.upgradeButton": {
    fr: "Passer en Pro - 9,99€/6 mois",
    en: "Upgrade to Pro - €9.99/6 month"
  },
  "demo.ended.restartButton": {
    fr: "Relancer une démo",
    en: "Restart a demo"
  },
  "demo.ended.cooldownButton": {
    fr: "Démo indisponible temporairement",
    en: "Demo temporarily unavailable"
  },
  "demo.ended.cooldownMessage": {
    fr: "Prochaine démo disponible dans",
    en: "Next demo available in"
  },
  "demo.ended.backHome": {
    fr: "Retour à l'accueil",
    en: "Back to home"
  },
  "demo.ended.trust1": {
    fr: "Paiement sécurisé",
    en: "Secure payment"
  },
  "demo.ended.trust2": {
    fr: "Annulation facile",
    en: "Easy cancellation"
  },
  "demo.ended.trust3": {
    fr: "Support prioritaire",
    en: "Priority support"
  },
  "demo.limit.element.title": {
    fr: "Limite d'éléments atteinte",
    en: "Element limit reached"
  },
  "demo.limit.element.desc": {
    fr: "En mode démo, vous pouvez ajouter jusqu'à 3 éléments. Passez en Pro pour un nombre illimité !",
    en: "In demo mode, you can add up to 3 elements. Upgrade to Pro for unlimited!"
  },
  "demo.limit.connection.title": {
    fr: "Limite de connexions atteinte",
    en: "Connection limit reached"
  },
  "demo.limit.connection.desc": {
    fr: "En mode démo, vous pouvez créer jusqu'à 5 connexions. Passez en Pro pour connecter tous vos équipements !",
    en: "In demo mode, you can create up to 5 connections. Upgrade to Pro to connect all your equipment!"
  },
  "demo.limit.cable.title": {
    fr: "Limite de câbles atteinte",
    en: "Cable limit reached"
  },
  "demo.limit.cable.desc": {
    fr: "En mode démo, vous pouvez tracer jusqu'à 3 câbles. Passez en Pro pour un câblage complet !",
    en: "In demo mode, you can draw up to 3 cables. Upgrade to Pro for complete cabling!"
  },
  "demo.limit.processor.title": {
    fr: "Limite de processeurs atteinte",
    en: "Processor limit reached"
  },
  "demo.limit.processor.desc": {
    fr: "En mode démo, vous pouvez ajouter jusqu'à 2 processeurs. Passez en Pro pour un nombre illimité !",
    en: "In demo mode, you can add up to 2 processors. Upgrade to Pro for unlimited!"
  },
  "demo.limit.cabinet.title": {
    fr: "Limite d'armoires atteinte",
    en: "Cabinet limit reached"
  },
  "demo.limit.cabinet.desc": {
    fr: "En mode démo, vous pouvez ajouter jusqu'à 1 armoire. Passez en Pro pour un nombre illimité !",
    en: "In demo mode, you can add up to 1 cabinet. Upgrade to Pro for unlimited!"
  },
  "demo.limit.upgradeButton": {
    fr: "Passer en Pro",
    en: "Upgrade to Pro"
  },
  "demo.limit.continueButton": {
    fr: "Continuer en mode démo",
    en: "Continue in demo mode"
  },
  "demo.saveDisabled": {
    fr: "Sauvegarde désactivée en mode démo",
    en: "Save disabled in demo mode"
  },
  "demo.exportDisabled": {
    fr: "Export désactivé en mode démo",
    en: "Export disabled in demo mode"
  },
  "demo.pageCreationDisabled": {
    fr: "Création de pages désactivée en mode démo",
    en: "Page creation disabled in demo mode"
  },
  "demo.exportPngWithWatermark": {
    fr: "Exporter PNG (avec watermark)",
    en: "Export PNG (with watermark)"
  },
  "demo.limitations": {
    fr: "Mode démo : 2 mires max par page, export PNG uniquement",
    en: "Demo mode: 2 mires max per page, PNG export only"
  },
  "demo.mireLimit": {
    fr: "Limite de 2 mires par page atteinte",
    en: "Limit of 2 mires per page reached"
  },
  "onboarding.step": {
    fr: "Étape {current}/{total}",
    en: "Step {current}/{total}"
  },
  "onboarding.overviewSteps.title": {
    fr: "Les 4 étapes du workflow",
    en: "The 4 workflow steps"
  },
  "onboarding.overviewSteps.description": {
    fr: "Le Synoptique est divisé en 4 étapes.",
    en: "The Synoptic is divided into 4 steps."
  },
  "onboarding.step2CreateRedundancy.title": {
    fr: "Créez une redondance",
    en: "Create redundancy"
  },
  "onboarding.step2CreateRedundancy.description": {
    fr: "Glissez le Port 2 sur le Port 1 pour créer une redondance.",
    en: "Drag Port 2 onto Port 1 to create redundancy."
  },
  "onboarding.welcome.title": {
    fr: "Bienvenue sur VisualGrid Synoptique !",
    en: "Welcome to VisualGrid Synoptic!"
  },
  "onboarding.welcome.description": {
    fr: "Découvrez comment créer votre premier synoptique LED en quelques étapes simples.",
    en: "Learn how to create your first LED synoptic in a few simple steps."
  },
  "onboarding.step1Intro.title": {
    fr: "Étape 1 : Créer votre mire LED",
    en: "Step 1: Create your LED pattern"
  },
  "onboarding.step1Intro.description": {
    fr: "C'est ici que vous allez créer votre première grille de mire LED.",
    en: "This is where you'll create your first LED test pattern grid."
  },
  "onboarding.step1Customize.title": {
    fr: "Personnalisez votre mire",
    en: "Customize your pattern"
  },
  "onboarding.step1Customize.description": {
    fr: "Modifiez au moins 2 paramètres (couleurs, patterns, etc.)",
    en: "Modify at least 2 parameters (colors, patterns, etc.)"
  },
  "onboarding.step1AddToList.title": {
    fr: "Ajoutez votre mire",
    en: "Add your pattern"
  },
  "onboarding.step1AddToList.description": {
    fr: "Donnez un nom à votre mire et cliquez sur \"Ajouter à la liste\". Vous pouvez créer plusieurs mires différentes.",
    en: "Name your pattern and click \"Add to list\". You can create multiple different patterns."
  },
  "onboarding.step1UsePattern.title": {
    fr: "Validez votre mire",
    en: "Confirm your pattern"
  },
  "onboarding.step1UsePattern.description": {
    fr: "Cliquez sur \"Utiliser la mire\" pour passer à l'étape suivante.",
    en: "Click \"Use pattern\" to proceed to the next step."
  },
  "onboarding.step2Intro.title": {
    fr: "Étape 2 : Processeur LED et cablâge du signal",
    en: "Step 2: LED Processor and signal cabling"
  },
  "onboarding.step2Intro.description": {
    fr: "C'est ici que vous allez configurer votre processeur et câbler le signal de vos panneaux LED.",
    en: "This is where you'll configure your processor and cable your LED panels signal."
  },
  "onboarding.step2SelectAndDragProcessor.title": {
    fr: "Placez un processeur",
    en: "Place a processor"
  },
  "onboarding.step2SelectAndDragProcessor.description": {
    fr: "Recherchez \"MCTRL 4K\" dans la liste des processeurs à gauche, puis glissez-déposez-le sur le workspace.",
    en: "Search for \"MCTRL 4K\" in the processor list on the left, then drag and drop it onto the workspace."
  },
  "onboarding.step2ClickProcessor.title": {
    fr: "Sélectionnez le processeur",
    en: "Select the processor"
  },
  "onboarding.step2ClickProcessor.description": {
    fr: "Cliquez sur le processeur dans le workspace pour le sélectionner et voir ses ports de connexion.",
    en: "Click on the processor in the workspace to select it and view its connection ports."
  },
  "onboarding.step2SelectPort.title": {
    fr: "Sélectionnez le Port 1",
    en: "Select Port 1"
  },
  "onboarding.step2SelectPort.description": {
    fr: "Dans le panneau du processeur en bas, cliquez sur le Port 1 pour commencer le câblage.",
    en: "In the processor panel at the bottom, click on Port 1 to start cabling."
  },
  "onboarding.step2ClickMire.title": {
    fr: "Câblez les panneaux",
    en: "Cable the panels"
  },
  "onboarding.step2ClickMire.description": {
    fr: "Cliquez sur chaque cellule de la mire pour connecter les panneaux au processeur dans l'ordre.",
    en: "Click on each pattern cell to connect the panels to the processor in order."
  },
  "onboarding.step2CablePanels.title": {
    fr: "Continuez le câblage",
    en: "Continue cabling"
  },
  "onboarding.step2CablePanels.description": {
    fr: "Continuez à cliquer sur les cellules pour compléter le câblage de tous les panneaux.",
    en: "Continue clicking on cells to complete cabling all the panels."
  },
  "onboarding.step3Intro.title": {
    fr: "Étape 3 : Câblage électrique",
    en: "Step 3: Electrical cabling"
  },
  "onboarding.step3Intro.description": {
    fr: "Maintenant, configurez l'alimentation électrique de vos panneaux LED.",
    en: "Now, configure the electrical power for your LED panels."
  },
  "onboarding.step3SelectAndDragCabinet.title": {
    fr: "Placez une armoire",
    en: "Place a cabinet"
  },
  "onboarding.step3SelectAndDragCabinet.description": {
    fr: "Glissez-déposez une armoire électrique de la liste vers le workspace.",
    en: "Drag and drop an electrical cabinet from the list onto the workspace."
  },
  "onboarding.step3ClickCabinet.title": {
    fr: "Sélectionnez l'armoire",
    en: "Select the cabinet"
  },
  "onboarding.step3ClickCabinet.description": {
    fr: "Cliquez sur l'armoire dans le workspace pour la sélectionner.",
    en: "Click on the cabinet in the workspace to select it."
  },
  "onboarding.step3SelectOutlet.title": {
    fr: "Sélectionnez la prise PC16 n°1",
    en: "Select PC16 outlet #1"
  },
  "onboarding.step3SelectOutlet.description": {
    fr: "Dans le panneau de l'armoire en bas, cliquez sur la première prise PC16 pour commencer le câblage électrique.",
    en: "In the cabinet panel at the bottom, click on the first PC16 outlet to start electrical cabling."
  },
  "onboarding.step3CableMire.title": {
    fr: "Câblez l'alimentation",
    en: "Cable the power"
  },
  "onboarding.step3CableMire.description": {
    fr: "Cliquez sur les cellules de la mire pour connecter l'alimentation aux panneaux.",
    en: "Click on the pattern cells to connect power to the panels."
  },
  "onboarding.step4Intro.title": {
    fr: "Étape 4 : Export",
    en: "Step 4: Export"
  },
  "onboarding.step4Intro.description": {
    fr: "Votre synoptique est prêt ! Passons à l'export.",
    en: "Your synoptic is ready! Let's proceed to export."
  },
  "onboarding.step4Cartouche.title": {
    fr: "Remplissez la cartouche",
    en: "Fill in the title block"
  },
  "onboarding.step4Cartouche.description": {
    fr: "La cartouche d'informations apparaît à gauche. Renseignez au moins 2 champs (client, événement, lieu, etc.).",
    en: "The information title block appears on the left. Fill in at least 2 fields (client, event, location, etc.)."
  },
  "onboarding.step4ExportOptions.title": {
    fr: "Exportez en PNG",
    en: "Export as PNG"
  },
  "onboarding.step4ExportOptions.description": {
    fr: "Cliquez sur le bouton d'export PNG pour télécharger votre synoptique. En démo, un watermark sera ajouté.",
    en: "Click the PNG export button to download your synoptic. In demo mode, a watermark will be added."
  },
  "onboarding.finalSaveMenu.title": {
    fr: "Sauvegarde et gestion",
    en: "Save and manage"
  },
  "onboarding.finalSaveMenu.description": {
    fr: "Le menu Import/Export vous permet de sauvegarder votre projet localement, d'importer un projet ou de l'exporter en fichier .vgsyn.",
    en: "The Import/Export menu allows you to save your project locally, import a project, or export as a .vgsyn file."
  },
  "onboarding.finalCloud.title": {
    fr: "VisualCloud",
    en: "VisualCloud"
  },
  "onboarding.finalCloud.description": {
    fr: "Avec le VisualCloud, synchronisez vos projets en ligne et accédez-y depuis n'importe quel appareil.",
    en: "With VisualCloud, sync your projects online and access them from any device."
  },
  "onboarding.completed.title": {
    fr: "Félicitations !",
    en: "Congratulations!"
  },
  "onboarding.completed.description": {
    fr: "Vous maîtrisez maintenant les bases de VisualGrid Synoptique. Explorez les fonctionnalités avancées !",
    en: "You now master the basics of VisualGrid Synoptic. Explore the advanced features!"
  },
  "onboarding.button.next": {
    fr: "Suivant",
    en: "Next"
  },
  "onboarding.button.back": {
    fr: "Retour",
    en: "Back"
  },
  "onboarding.button.skip": {
    fr: "Passer",
    en: "Skip"
  },
  "onboarding.button.finish": {
    fr: "Terminer",
    en: "Finish"
  },
  "onboarding.button.continue": {
    fr: "Continuer",
    en: "Continue"
  },
  "onboarding.button.startTutorial": {
    fr: "Commencer le tutoriel",
    en: "Start tutorial"
  },
  "onboarding.button.restartTutorial": {
    fr: "Recommencer le tutoriel",
    en: "Restart tutorial"
  },
  "onboarding.aria.skipTutorial": {
    fr: "Passer le tutoriel",
    en: "Skip tutorial"
  },
  "onboarding.hint.click": {
    fr: "Cliquez sur l'élément surligné",
    en: "Click on the highlighted element"
  },
  "onboarding.hint.drag": {
    fr: "Glissez-déposez l'élément",
    en: "Drag and drop the element"
  },
  "onboarding.hint.select": {
    fr: "Sélectionnez un élément dans la liste",
    en: "Select an element from the list"
  },
  "onboarding.hint.input": {
    fr: "Entrez une valeur",
    en: "Enter a value"
  },
  "onboarding.hint.stepChange": {
    fr: "Cliquez pour continuer",
    en: "Click to continue"
  },
  "onboarding.hint.processorPlaced": {
    fr: "Glissez le processeur sur le workspace",
    en: "Drag the processor onto the workspace"
  },
  "onboarding.hint.processorSelected": {
    fr: "Cliquez sur le processeur pour le sélectionner",
    en: "Click on the processor to select it"
  },
  "onboarding.hint.processorDragging": {
    fr: "En train de glisser le processeur...",
    en: "Dragging the processor..."
  },
  "onboarding.hint.cabinetPlaced": {
    fr: "Glissez l'armoire sur le workspace",
    en: "Drag the cabinet onto the workspace"
  },
  "onboarding.hint.cabinetSelected": {
    fr: "Cliquez sur l'armoire pour la sélectionner",
    en: "Click on the cabinet to select it"
  },
  "onboarding.hint.cabinetDragging": {
    fr: "En train de glisser l'armoire...",
    en: "Dragging the cabinet..."
  },
  "onboarding.hint.portSelected": {
    fr: "Cliquez sur le port pour le sélectionner",
    en: "Click on the port to select it"
  },
  "onboarding.hint.portDragging": {
    fr: "Glissez le port sur un autre port",
    en: "Drag the port onto another port"
  },
  "onboarding.hint.outletSelected": {
    fr: "Cliquez sur une prise pour la sélectionner",
    en: "Click on an outlet to select it"
  },
  "onboarding.hint.panelsCabled": {
    fr: "Câblez les panneaux avec les flèches",
    en: "Cable the panels using arrow keys"
  },
  "onboarding.hint.redundancyCreated": {
    fr: "Glissez le Port 2 sur le Port 1",
    en: "Drag Port 2 onto Port 1"
  },
  "onboarding.hint.mireCustomized": {
    fr: "Modifiez au moins 2 paramètres",
    en: "Modify at least 2 parameters"
  },
  "onboarding.hint.mireAddedToList": {
    fr: "Donnez un nom et cliquez sur \"Ajouter à la liste\"",
    en: "Name it and click \"Add to list\""
  },
  "onboarding.hint.mireUsed": {
    fr: "Cliquez sur \"Utiliser la mire\"",
    en: "Click \"Use pattern\""
  },
  "onboarding.hint.cartoucheFilled": {
    fr: "Remplissez au moins 2 champs",
    en: "Fill in at least 2 fields"
  },
  "onboarding.hint.pngExported": {
    fr: "Cliquez sur le bouton d'export PNG",
    en: "Click the PNG export button"
  },
  "onboarding.hint.default": {
    fr: "Effectuez l'action demandée",
    en: "Perform the requested action"
  },

  // ========== SYNOPTIQUE PAGE ==========
  "synoptic.title": { fr: "Interface Synoptique", en: "Synoptic Interface" },
  "synoptic.subtitle": { fr: "Interface Synoptique LED", en: "LED Synoptic Interface" },
  "synoptic.pleaseWait": { fr: "Veuillez patienter", en: "Please wait" },
  "synoptic.smallScreenTitle": { fr: "Interface Synoptique", en: "Synoptic Interface" },
  "synoptic.smallScreenDesc": {
    fr: "Cette interface nécessite un écran plus large pour une expérience optimale. Veuillez utiliser un ordinateur de bureau ou une tablette.",
    en: "This interface requires a larger screen for the best experience. Please use a desktop or tablet."
  },
  "synoptic.backToHome": { fr: "Retour à l'accueil", en: "Back to home" },

  // Toasts - imports / conversions
  "synoptic.toast.mireImported": { fr: "Mire importée !", en: "Pattern imported!" },
  "synoptic.toast.mireConverted": { fr: "Mire convertie !", en: "Pattern converted!" },
  "synoptic.toast.mirePending": { fr: "Mire remise en attente", en: "Pattern reset to pending" },
  "synoptic.toast.mirePendingDesc": { fr: "Sélectionnez un processeur pour régénérer les panneaux", en: "Select a processor to regenerate panels" },
  "synoptic.toast.conversionInProgress": { fr: "Conversion en cours...", en: "Conversion in progress..." },
  "synoptic.toast.mireConvertedDesc": { fr: "{columns}×{rows} panneaux en groupe (image conservée)", en: "{columns}×{rows} panels grouped (image kept)" },

  // Toasts - connexions Data
  "synoptic.toast.selectProcessorFirst": { fr: "Sélectionnez d'abord un processeur et un port", en: "Select a processor and port first" },
  "synoptic.toast.selectCabinetFirst": { fr: "Sélectionnez d'abord une armoire et une sortie", en: "Select a cabinet and outlet first" },
  "synoptic.toast.mireNotFound": { fr: "Image de mire introuvable", en: "Pattern image not found" },
  "synoptic.toast.cellAlreadyConnected": { fr: "Cette cellule est déjà connectée", en: "This cell is already connected" },
  "synoptic.toast.cellAlreadyPowered": { fr: "Cette cellule est déjà alimentée", en: "This cell is already powered" },
  "synoptic.toast.invalidCell": { fr: "Cellule [{row},{col}] invalide", en: "Cell [{row},{col}] invalid" },
  "synoptic.toast.processorNotFound": { fr: "Processeur introuvable", en: "Processor not found" },
  "synoptic.toast.cabinetNotFound": { fr: "Armoire introuvable", en: "Cabinet not found" },
  "synoptic.toast.previousCellNotFound": { fr: "Erreur: cellule précédente introuvable", en: "Error: previous cell not found" },
  "synoptic.toast.noPanelType": { fr: "Aucun type de panneau disponible", en: "No panel type available" },
  "synoptic.toast.genericPanelUsed": { fr: "Panneau générique utilisé", en: "Generic panel used" },
  "synoptic.toast.genericPanelDesc": { fr: "Résolution : {width}×{height}px", en: "Resolution : {width}×{height}px" },
  "synoptic.toast.panelAlreadyConnected": { fr: "Ce panneau est déjà connecté à ce port", en: "This panel is already connected to this port" },
  "synoptic.toast.panelNotConnected": { fr: "Ce panneau n'est pas connecté à la prise sélectionnée", en: "This panel is not connected to the selected outlet" },
  "synoptic.toast.cellNotConnectedOutlet": { fr: "Cette cellule n'est pas connectée à la prise sélectionnée", en: "This cell is not connected to the selected outlet" },
  "synoptic.toast.panelNotConnectedPort": { fr: "Ce panneau n'est pas connecté au port sélectionné", en: "This panel is not connected to the selected port" },
  "synoptic.toast.cellNotConnectedPort": { fr: "Cette cellule n'est pas connectée au port sélectionné", en: "This cell is not connected to the selected port" },
  "synoptic.toast.daisyChainLimit": { fr: "Limite de daisy chain atteinte", en: "Daisy chain limit reached" },
  "synoptic.toast.daisyChainLimitDesc": { fr: "Port {port} : {existing}/{max} panneaux connectés", en: "Port {port}: {existing}/{max} panels connected" },
  "synoptic.toast.daisyChainPartial": { fr: "Seuls {remaining} panneaux sur {total} seront connectés (limite {max})", en: "Only {remaining} of {total} panels will be connected (limit {max})" },

  // Toasts - export
  "synoptic.toast.svgExported": { fr: "SVG exporté avec succès", en: "SVG exported successfully" },
  "synoptic.toast.pngExported": { fr: "PNG exporté avec succès", en: "PNG exported successfully" },
  "synoptic.toast.pdfExported": { fr: "PDF exporté avec succès", en: "PDF exported successfully" },
  "synoptic.toast.pngExportError": { fr: "Erreur lors de l'export PNG", en: "Error exporting PNG" },
  "synoptic.toast.exportSuccess": { fr: "Export réussi !", en: "Export successful!" },

  // Toasts - sauvegarde
  "synoptic.toast.savedLocally": { fr: " Projet sauvegardé localement", en: " Project saved locally" },
  "synoptic.toast.savedLocallyDesc": { fr: "Fichier: {filename}", en: "File: {filename}" },
  "synoptic.toast.savedToCloud": { fr: "Sauvegardé dans le VisualCloud", en: "Saved to VisualCloud" },
  "synoptic.toast.cloudTimeout": { fr: " Cloud: Timeout", en: " Cloud: Timeout" },
  "synoptic.toast.cloudTimeoutDesc": { fr: "Le Cloud est lent. Votre sauvegarde locale est safe.", en: "Cloud is slow. Your local save is safe." },
  "synoptic.toast.cloudNetwork": { fr: " Cloud: Réseau", en: " Cloud: Network" },
  "synoptic.toast.cloudNetworkDesc": { fr: "Problème réseau. Sauvegarde locale réussie.", en: "Network issue. Local save succeeded." },
  "synoptic.toast.cloudSession": { fr: " Cloud: Session", en: " Cloud: Session" },
  "synoptic.toast.cloudSessionDesc": { fr: "Session expirée. Sauvegarde locale réussie.", en: "Session expired. Local save succeeded." },
  "synoptic.toast.cloudSessionWarning": { fr: " Cloud: Session expirée", en: "Cloud: Session expired" },
  "synoptic.toast.cloudSessionWarningDesc": { fr: "Reconnectez-vous pour sauvegarder dans le Cloud", en: "Sign in again to save to the Cloud" },
  "synoptic.toast.timeoutError": { fr: " Timeout: La sauvegarde Cloud prend trop de temps. Essayez de rafraîchir la page.", en: " Timeout: Cloud save is taking too long. Try refreshing the page." },
  "synoptic.toast.networkError": { fr: " Erreur réseau: Vérifiez votre connexion internet.", en: " Network error: Check your internet connection." },
  "synoptic.toast.authError": { fr: " Erreur d'authentification: Veuillez vous reconnecter.", en: " Authentication error: Please sign in again." },
  "synoptic.toast.backupDeleted": { fr: "Backup supprimé", en: "Backup deleted" },
  "synoptic.toast.backupDeletedDesc": { fr: "Les processeurs sont maintenant autonomes.", en: "Processors are now independent." },
  "synoptic.toast.pagesCopied": { fr: "Pages copiées !", en: "Pages copied!" },
  "synoptic.toast.pagesCopiedDesc": { fr: "{count} page(s) Data copiée(s) vers Power (sans processeurs)", en: "{count} Data page(s) copied to Power (without processors)" },
  "synoptic.proOnlyFeature": { fr: "Fonctionnalité Pro uniquement", en: "Pro feature only" },
  "synoptic.savingInProgress": { fr: "Sauvegarde en cours...", en: "Saving in progress..." },
  "synoptic.saveCloudDesc": { fr: "Sauvegardez votre projet localement et dans le cloud", en: "Save your project locally and in the cloud" },
  "synoptic.saveDuration": { fr: "Durée: {seconds}s", en: "Duration: {seconds}s" },
  "synoptic.offlineWarning": { fr: "Hors connexion", en: "Offline" },

  // Toasts - historique
  "synoptic.toast.nothingToUndo": { fr: "Aucune action à annuler", en: "Nothing to undo" },
  "synoptic.toast.nothingToRedo": { fr: "Aucune action à rétablir", en: "Nothing to redo" },
  "synoptic.toast.navigationCancelled": { fr: "Navigation annulée", en: "Navigation cancelled" },
  "synoptic.toast.noCellInDirection": { fr: "Aucune cellule disponible dans cette direction", en: "No cell available in this direction" },

  // Toasts - groupes
  "synoptic.toast.groupLocked": { fr: "Groupe indissociable", en: "Group cannot be ungrouped" },
  "synoptic.toast.groupLockedDesc": { fr: "Ce groupe de panneaux-mires ne peut pas être dissocié", en: "This panel-pattern group cannot be ungrouped" },

  // Toasts - mires
  "synoptic.toast.capturingPattern": { fr: "Capture de la mire en cours...", en: "Capturing pattern..." },
  "synoptic.toast.mireAddError": { fr: "Erreur lors de l'ajout de la mire", en: "Error adding pattern" },
  "synoptic.toast.mireCaptureError": { fr: "Erreur lors de la capture de l'image", en: "Error capturing image" },
  "synoptic.toast.mireSendError": { fr: "Erreur lors de l'envoi des mires", en: "Error sending patterns" },
  "synoptic.toast.noMireToSend": { fr: "Aucune mire à envoyer", en: "No pattern to send" },
  "synoptic.toast.noMireToSendDesc": { fr: "Créez une mire dans l'aperçu ci-dessus", en: "Create a pattern in the preview above" },
  "synoptic.toast.novaConfigSent": { fr: "Configuration Nova envoyée avec succès !", en: "Nova configuration sent successfully!" },
  "synoptic.toast.novaConfigError": { fr: "Erreur: {message}", en: "Error: {message}" },
  "synoptic.toast.panelLinkedToMire": { fr: "Panneau {name} lié à la mire", en: "Panel {name} linked to pattern" },

  // JSX visible
  "synoptic.configurationNova": { fr: "Configuration Nova", en: "Nova Configuration" },
  "synoptic.miresData": { fr: "Mires Data", en: "Data Patterns" },
  "synoptic.miresDataDrag": { fr: "Glisser vers le workspace Power", en: "Drag to Power workspace" },
  "synoptic.permanent": { fr: "Permanent", en: "Permanent" },
  "synoptic.dissocierGroupe": { fr: "Dissocier le groupe", en: "Ungroup" },
  "synoptic.noCabinetPlaced": { fr: "Aucune armoire placée", en: "No cabinet placed" },
  "synoptic.powerManagement": { fr: "Power Management", en: "Power Management" },
  "synoptic.clickToOpen": { fr: "Cliquer pour ouvrir", en: "Click to open" },
  "synoptic.electricalCabinets": { fr: "Armoires électriques:", en: "Electrical cabinets:" },

  // Bulle config
  "synoptic.bubble.config": { fr: "Configuration de la bulle", en: "Bubble configuration" },
  "synoptic.bubble.title": { fr: "Titre de la bulle", en: "Bubble title" },
  "synoptic.bubble.background": { fr: "Fond", en: "Background" },
  "synoptic.bubble.text": { fr: "Texte", en: "Text" },
  "synoptic.bubble.width": { fr: "Largeur", en: "Width" },
  "synoptic.bubble.height": { fr: "Hauteur", en: "Height" },
  "synoptic.bubble.titleFont": { fr: "Police titre", en: "Title font" },
  "synoptic.bubble.infoFont": { fr: "Police infos", en: "Info font" },
  "synoptic.bubble.reset": { fr: "Réinitialiser la bulle", en: "Reset bubble" },
  "synoptic.bubble.countPowerConsumption": { fr: "Comptabiliser consommation Power", en: "Count Power consumption" },
  "synoptic.bubble.visible": { fr: "Afficher la bulle", en: "Show bubble" },
  "synoptic.miresDownload.title": { fr: "Mires du synoptique", en: "Synoptic test patterns" },
  "synoptic.miresDownload.desc": { fr: "Téléchargez les mires présentes en PNG", en: "Download the test patterns as PNG" },
  "synoptic.miresDownload.empty": { fr: "Aucune mire présente sur le synoptique", en: "No test pattern on the synoptic" },
  "synoptic.miresDownload.selectAll": { fr: "Tout sélectionner", en: "Select all" },
  "synoptic.miresDownload.panels": { fr: "panneaux", en: "panels" },
  "synoptic.miresDownload.download": { fr: "Télécharger en PNG", en: "Download as PNG" },
  "synoptic.miresDownload.downloadSelected": { fr: "Télécharger la sélection ({count})", en: "Download selection ({count})" },
  "synoptic.miresDownload.downloaded": { fr: "Mire téléchargée : {name}", en: "Pattern downloaded: {name}" },
  "synoptic.miresDownload.downloadedCount": { fr: "{count} mire(s) téléchargée(s)", en: "{count} pattern(s) downloaded" },
  "synoptic.miresDownload.error": { fr: "Erreur lors du téléchargement de la mire", en: "Error downloading the pattern" },
  "synoptic.miresDownload.downloadCabled": { fr: "Télécharger en PNG avec le schéma de câblage", en: "Download as PNG with cabling diagram" },
  "synoptic.miresDownload.downloadSelectedCabled": { fr: "Sélection + câblage ({count})", en: "Selection + cabling ({count})" },
  "synoptic.miresDownload.noCabling": { fr: "Aucun câblage sur cette mire", en: "No cabling on this pattern" },
  "synoptic.bubble.configure": { fr: "Configurer la bulle", en: "Configure bubble" },
  "synoptic.bubble.bgColor": { fr: "Couleur de fond", en: "Background color" },
  "synoptic.bubble.textColor": { fr: "Couleur du texte", en: "Text color" },
  "synoptic.toast.invalidNumericValue": { fr: "Valeur numérique invalide", en: "Invalid numeric value" },
  "synoptic.toast.parsingError": { fr: "Erreur de parsing", en: "Parsing error" },
  "synoptic.toast.invalidHexColor": { fr: "Couleur hexadécimale invalide", en: "Invalid hex color" },

  // Boutons mire
  "synoptic.useMires": { fr: "Utiliser les mires", en: "Use patterns" },
  "synoptic.useMire": { fr: "Utiliser la mire", en: "Use pattern" },
  "synoptic.createMire": { fr: "Créer une mire", en: "Create a pattern" },
  "synoptic.deleteMireTitle": { fr: "Supprimer la mire", en: "Delete pattern" },
  "synoptic.deleteMireDescription": { fr: "Voulez-vous vraiment supprimer la mire \"{name}\" du projet ? Cette action est irréversible.", en: "Do you really want to delete pattern \"{name}\" from the project? This action is irreversible." },
  "synoptic.delete": { fr: "Supprimer", en: "Delete" },
  "synoptic.addToList": { fr: "Ajouter à la liste", en: "Add to list" },
  "synoptic.updateMire": { fr: "Mettre à jour", en: "Update" },
  "synoptic.updateMireTitle": { fr: "Écraser la mire existante avec les modifications", en: "Overwrite the existing pattern with your changes" },
  "synoptic.saveAsNewMire": { fr: "Enregistrer comme nouvelle", en: "Save as new" },
  "synoptic.saveAsNewMireTitle": { fr: "Ajouter comme nouvelle mire sans écraser l'existante", en: "Add as a new pattern without overwriting the existing one" },
  "synoptic.cancelEditMire": { fr: "Annuler la modification", en: "Cancel editing" },
  "synoptic.clickMireToEdit": { fr: "Cliquer pour modifier cette mire", en: "Click to edit this pattern" },
  "synoptic.toast.mireEditorNotReady": { fr: "L'éditeur de mire n'est pas encore prêt", en: "Pattern editor is not ready yet" },
  "synoptic.toast.mireEditorLoadTimeout": { fr: "L'éditeur de mire n'a pas répondu à temps", en: "Pattern editor did not respond in time" },
  "synoptic.mireCount": { fr: "{count} mire{plural} enregistrée{plural}", en: "{count} pattern{plural} saved" },
  "synoptic.modifyAndAdd": { fr: "Modifiez votre prochaine mire et ajoutez-la à la liste", en: "Modify your next pattern and add it to the list" },
  "synoptic.savedMires": { fr: "Mires enregistrées :", en: "Saved patterns:" },
  "synoptic.prisesPC16": { fr: "Prises PC16:", en: "PC16 outlets:" },
  "synoptic.cabinetToCabinetLink": { fr: "Liaison armoire → armoire", en: "Cabinet → cabinet link" },
  "synoptic.cabinetLinkCreate": { fr: "Lier vers une armoire", en: "Link to a cabinet" },
  "synoptic.cabinetLinkCancel": { fr: "Annuler la liaison", en: "Cancel linking" },
  "synoptic.cabinetLinkPickTarget": { fr: "Cliquez sur l'armoire à alimenter", en: "Click the cabinet to power" },
  "synoptic.cabinetLinkCreated": { fr: "Liaison armoire créée", en: "Cabinet link created" },
  "synoptic.cabinetLinkRejected": { fr: "Liaison impossible (déjà alimentée, doublon ou boucle)", en: "Cannot link (already powered, duplicate or loop)" },
  "synoptic.cabinetLinkFeeds": { fr: "alimente", en: "feeds" },
  "synoptic.cabinetLinkFedBy": { fr: "alimentée par", en: "fed by" },
  "synoptic.removeLink": { fr: "Supprimer la liaison", en: "Remove link" },
  "synoptic.cabinetLoad": { fr: "Charge totale", en: "Total load" },
  "synoptic.cabinetLoadLinked": { fr: "dont {kw} kW via armoires liées", en: "incl. {kw} kW from linked cabinets" },
  "synoptic.cabinetOverload": { fr: "Surcharge !", en: "Overload!" },
  "synoptic.howToCreateMire": { fr: "Comment créer une mire ?", en: "How to create a pattern?" },
  "synoptic.howToMireStep1": { fr: "Dans l'aperçu ci-dessus, activez le <strong>Mode LED Wall</strong> (onglet \"Mur LED\")", en: "In the preview above, enable <strong>LED Wall Mode</strong> (\"LED Wall\" tab)" },
  "synoptic.howToMireStep2": { fr: "Configurez les <strong>colonnes</strong> et <strong>rangées</strong> de votre mur", en: "Configure the <strong>columns</strong> and <strong>rows</strong> of your wall" },
  "synoptic.howToMireStep3": { fr: "La configuration sera automatiquement détectée ici", en: "The configuration will be automatically detected here" },
  "synoptic.howToMireStep4": { fr: "Cliquez sur <strong>\"Utiliser la mire\"</strong> pour l'ajouter au workspace", en: "Click <strong>\"Use pattern\"</strong> to add it to the workspace" },
  "synoptic.zoom": { fr: "Zoom", en: "Zoom" },
  "synoptic.grid": { fr: "Grille", en: "Grid" },
  "synoptic.panelNumbering": { fr: "Numérotation des panneaux", en: "Panel numbering" },
  "synoptic.numbering.all": { fr: "Tous", en: "All" },
  "synoptic.numbering.firstLast": { fr: "1er + Dernier", en: "1st + Last" },
  "synoptic.numbering.none": { fr: "Aucun", en: "None" },
  "synoptic.showProcessorLink": { fr: "Afficher la liaison processeur → 1er panneau", en: "Show processor → 1st panel link" },
  "synoptic.showProcessorLinkDesc": { fr: "Affiche ou masque les lignes pointillées entre les processeurs/armoires et le premier panneau de chaque chaîne dans l'export", en: "Shows or hides dashed lines between processors/cabinets and the first panel of each chain in the export" },
  "synoptic.size": { fr: "Taille", en: "Size" },
  "synoptic.outletsCount": { fr: "Nb. prises", en: "Outlets count" },
  "config.gridSizeLabel": { fr: "Taille de grille (px)", en: "Grid size (px)" },
  "config.quickColors": { fr: "Couleurs rapides", en: "Quick colors" },
  "mobile.remote.collaborativeTitle": { fr: "Sessions collaboratives", en: "Collaborative sessions" },
  "mobile.remote.collaborativeDesc": { fr: "Rejoignez une session pour contrôler un écran LED à distance depuis votre téléphone.", en: "Join a session to control an LED screen remotely from your phone." },
  "mobile.remote.selfTestTitle": { fr: "Mode Self-Test", en: "Self-Test Mode" },
  "mobile.remote.selfTestDesc": { fr: "Lorsque vous rejoignez une session en mode Self-Test, vous pouvez naviguer entre les panneaux LED et les identifier directement depuis votre mobile.", en: "When you join a session in Self-Test mode, you can navigate between LED panels and identify them directly from your mobile." },

  // ── Technical Report (PDF) ──────────────────────────────────────────
  "report.technicalReport": { fr: "Rapport Technique", en: "Technical Report" },
  "report.untitledProject": { fr: "Projet sans titre", en: "Untitled Project" },
  "report.client": { fr: "Client", en: "Client" },
  "report.event": { fr: "Événement", en: "Event" },
  "report.location": { fr: "Lieu", en: "Location" },
  "report.agency": { fr: "Agence", en: "Agency" },
  "report.suite": { fr: "Suite", en: "Suite" },
  "report.subject": { fr: "Sujet", en: "Subject" },
  "report.date": { fr: "Date", en: "Date" },
  "report.author": { fr: "Auteur", en: "Author" },
  "report.projectSummary": { fr: "Résumé du Projet", en: "Project Summary" },
  "report.ledWalls": { fr: "Murs LED", en: "LED Walls" },
  "report.totalProcessors": { fr: "Processeurs", en: "Processors" },
  "report.totalPanels": { fr: "Dalles totales", en: "Total panels" },
  "report.totalCabinets": { fr: "Armoires", en: "Cabinets" },
  "report.totalPixels": { fr: "Pixels totaux", en: "Total pixels" },
  "report.totalPowerShort": { fr: "Conso. totale", en: "Total consumption" },
  "report.dataCables": { fr: "Câbles data", en: "Data cables" },
  "report.powerCables": { fr: "Câbles power", en: "Power cables" },
  "report.dataPortsUsed": { fr: "Ports data utilisés", en: "Data ports used" },
  "report.powerOutletsUsed": { fr: "Prises power utilisées", en: "Power outlets used" },
  "report.redundancyPorts": { fr: "Ports de redondance", en: "Redundancy ports" },
  "report.ledWallDetails": { fr: "Détails des Murs LED", en: "LED Wall Details" },
  "report.ledWall": { fr: "Mur LED", en: "LED Wall" },
  "report.grid": { fr: "Grille", en: "Grid" },
  "report.panels": { fr: "Dalles", en: "Panels" },
  "report.resolution": { fr: "Résolution", en: "Resolution" },
  "report.panelType": { fr: "Type de dalle", en: "Panel type" },
  "report.processors": { fr: "Processeurs", en: "Processors" },
  "report.device": { fr: "Appareil", en: "Device" },
  "report.role": { fr: "Rôle", en: "Role" },
  "report.quantity": { fr: "Quantité", en: "Quantity" },
  "report.ports": { fr: "Ports", en: "Ports" },
  "report.powerUsage": { fr: "Consommation", en: "Power usage" },
  "report.total": { fr: "Total", en: "Total" },
  "report.ledPanels": { fr: "Dalles LED", en: "LED Panels" },
  "report.pitch": { fr: "Pitch", en: "Pitch" },
  "report.dimensions": { fr: "Dimensions", en: "Dimensions" },
  "report.powerCabinets": { fr: "Armoires Électriques", en: "Power Cabinets" },
  "report.voltage": { fr: "Tension", en: "Voltage" },
  "report.maxPower": { fr: "Puissance max", en: "Max power" },
  "report.outlets": { fr: "Prises", en: "Outlets" },
  "report.cablesSummary": { fr: "Résumé des Câbles", en: "Cables Summary" },
  "report.cableType": { fr: "Type de câble", en: "Cable type" },
  "report.dataCablesEthernet": { fr: "Câbles Ethernet (Data)", en: "Ethernet Cables (Data)" },
  "report.powerCablesElectric": { fr: "Câbles Électriques (Power)", en: "Electric Cables (Power)" },
  "report.firstDataLinks": { fr: "First Data (Processeur > 1er panneau)", en: "First Data (Processor > 1st panel)" },
  "report.firstPowerLinks": { fr: "First Power (Armoire > 1er panneau)", en: "First Power (Cabinet > 1st panel)" },
  "report.powerLinkType": { fr: "Liaison Power (Type)", en: "Power Link (Type)" },
  "report.portUsageByWall": { fr: "Ports et Redondances par Mur LED", en: "Ports and Redundancies per LED Wall" },
  "report.dataPage": { fr: "Page Data", en: "Data Page" },
  "report.panelsShort": { fr: "dalles", en: "panels" },
  "report.powerSummary": { fr: "Bilan de Consommation", en: "Power Summary" },
  "report.processorsConsumption": { fr: "Consommation processeurs", en: "Processors consumption" },
  "report.panelsConsumption": { fr: "Consommation dalles", en: "Panels consumption" },
  "report.totalEstimatedConsumption": { fr: "Consommation totale estimée", en: "Total estimated consumption" },
  "report.backupConfig": { fr: "Configuration Backup", en: "Backup Configuration" },
  "report.mainProcessor": { fr: "Processeur principal", en: "Main processor" },
  "report.backupProcessor": { fr: "Processeur backup", en: "Backup processor" },
  "report.portRedundancies": { fr: "Redondances de ports", en: "Port redundancies" },
  "report.mainPort": { fr: "Port principal", en: "Main port" },
  "report.redundancyPort": { fr: "Port de redondance", en: "Redundancy port" },
  "report.generatedBy": { fr: "Généré par", en: "Generated by" },
  "report.page": { fr: "Page", en: "Page" },
  "report.totalCables": { fr: "Total cables", en: "Total cables" },
  "report.ledWallOverview": { fr: "Apercu des murs LED", en: "LED Wall Overview" },
  "report.summary": { fr: "Recapitulatif", en: "Summary" },
  "report.mainProcessors": { fr: "Processeurs principaux", en: "Main processors" },
  "report.backupProcessors": { fr: "Processeurs backup", en: "Backup processors" },
  "report.totalOutputPorts": { fr: "Ports de sortie", en: "Output ports" },
  "report.processorList": { fr: "Liste des processeurs", en: "Processor list" },
  "report.panelInventory": { fr: "Inventaire des dalles", en: "Panel inventory" },
  "report.panelSpecs": { fr: "Specifications techniques", en: "Technical specifications" },
  "report.cablingConnections": { fr: "Cablage et connexions", en: "Cabling and connections" },
  "report.powerPerWall": { fr: "Consommation par mur LED", en: "Power per LED wall" },
  "report.perPanel": { fr: "Par dalle", en: "Per panel" },
  "report.wallTotal": { fr: "Total mur", en: "Wall total" },
  "report.brightness": { fr: "Luminosite", en: "Brightness" },
  "report.ipRating": { fr: "Indice IP", en: "IP Rating" },
  "report.weight": { fr: "Poids", en: "Weight" },
  "report.ledType": { fr: "Type LED", en: "LED type" },
  "report.viewingAngle": { fr: "Angle de vision", en: "Viewing angle" },
  "report.grayScale": { fr: "Niveaux de gris", en: "Gray scale" },
  "report.contrastRatio": { fr: "Contraste", en: "Contrast ratio" },
  "report.refreshRate": { fr: "Taux de rafraichissement", en: "Refresh rate" },
  "report.receivingCard": { fr: "Carte de reception", en: "Receiving card" },
  "report.lineVoltage": { fr: "Tension", en: "Line voltage" },
  "report.ledWallsSummary": { fr: "Murs LED - Synthese", en: "LED Walls - Summary" },
  "report.wallsAtAGlance": { fr: "Vue d'ensemble des murs", en: "All LED Walls at a Glance" },
  "report.wallSpecs": { fr: "Fiches techniques des murs", en: "Wall Technical Specs" },
  "report.dataConnections": { fr: "Connexions DATA par mur", en: "Data Connections per Wall" },
  "report.physicalSize": { fr: "Dimensions physiques", en: "Physical size" },
  "report.powerWall": { fr: "Conso. mur", en: "Wall power" },
  "report.connectionsPerWall": { fr: "Connexions DATA par Mur LED", en: "Data Connections per LED Wall" },
  "report.processor": { fr: "Processeur", en: "Processor" },
  "report.port": { fr: "Port", en: "Port" },
  "report.redundancy": { fr: "Redondance", en: "Redundancy" },
  "report.powerInKw": { fr: "Puissance (kW)", en: "Power (kW)" },
  "report.estimatedCurrent": { fr: "Courant estime (A)", en: "Estimated Current (A)" },
  "report.circuitCapacity": { fr: "Capacite des circuits electriques", en: "Circuit Capacity Check" },
  "report.totalCircuitCapacity": { fr: "Capacite totale", en: "Total capacity" },
  "report.totalLoad": { fr: "Charge totale", en: "Total load" },
  "report.circuitLoad": { fr: "Taux de charge", en: "Load rate" },
  "report.totalCapacity": { fr: "Capacite totale", en: "Total capacity" },
  "report.powerDisclaimer": { fr: "Estimations calculees a 100% de la capacite nominale, 230V AC, 50Hz. Prevoir une marge de securite de 20% sur les circuits.", en: "Estimates calculated at 100% of nominal capacity, 230V AC, 50Hz. Allow 20% safety margin on circuits." },
  "synoptic.generateReport": { fr: "Rapport technique (PDF)", en: "Technical report (PDF)" },
  "synoptic.generateReportDesc": { fr: "Génère un rapport PDF A4 complet avec toutes les données techniques du projet", en: "Generate a complete A4 PDF report with all technical project data" },
  "synoptic.reportGenerating": { fr: "Génération du rapport technique...", en: "Generating technical report..." },
  "synoptic.reportExportError": { fr: "Erreur lors de la génération du rapport", en: "Failed to generate the report" }
};